/**
 * Page-specific Javascript file.  Should generally be included as a separate asset bundle in your page template.
 * example: {{ assets.js('js/pages/sign-in-or-register') | raw }}
 *
 * This script depends on widgets/users.js, uf-table.js, moment.js, handlebars-helpers.js
 *
 * Target page: /users
 */
var gAssetPrefix = '/assets-raw/tactiqs/assets/sailcast';
// var gAssetPrefix = 'https://s3-us-west-2.amazonaws.com/cdn-tactiqs-io/web';
var gDaePrefix = 'https://dg3pi8cjmqwyp.cloudfront.net';

var kDegToRad = 0.01745329252;

var kRenderMaxFps = 30.0;
var kCameraModeInit = "INIT";
var kCameraModeBevGeo = 'BEV-GEO';
var kCameraModeBevWind = 'BEV-WIND';
var kCameraModeChase = 'CHASE';
var kCameraModeOverview = 'OVERVIEW';   // static whole-race view (race report), see renderOverview()
var kCameraPlaneLateralDistanceNorm = 16.0;
var kCameraPlaneLateralDistanceLow = 14.0;
var kCameraPlaneVerticalDistanceNorm = 24.0;
var kCameraPlaneVerticalDistanceLow = 8.0;
var kCameraPlaneChaseDistance = 15.0;
var kCameraLookAtOffset = 1.0;
var kCameraFovBev = 30;
var kCameraFovChase = 90;
var kCameraViewpointNorm = 0;
var kCameraViewpointLow = 1;
var kCameraViewpointFleet = 2;       // the top of the fleet and its last 15 minutes of trail (fleet replays)
var kFleetViewTrailSeconds = 900;
var kFleetViewMargin = 1.15;
var kFleetViewMinHalfExtent = 0.25;  // scene units - a tight fleet is not zoomed in beyond this
var kEgoScaleFleet = 1.0;
var gFleetCam = null;                // the smoothed {cx, cy, d} of the fleet viewpoint
var kOceanSize = 36;
var kOceanResolution = 1024;
var kElevationResolution = 256;
var kElevationScaleMin = 0.001;
var kElevationScaleMax = 0.004;
var kEgoScaleBev = 3.0;
var kEgoFullSizeFactor = 0.03;
var kMarkConeRadius = 0.04;
var kMarkConeHeight = 0.08;
var kMarkScaleBev = 2.5;
var kTrailColors = [ 0xe0e0e0, 0xd6ff00, 0x00e0ff, 0x1cff00, 0xff3600, 0xce00ff ];
var kNextMarkIsReaching = 0;
var kNextMarkIsUpwind = 1;
var kNextMarkIsDownwind = 2;
var kFixMaxInterpolationGap = 30;    // seconds - a longer gap between two fixes of a boat holds the earlier one

// Fleet replays (Design/TRACKER_RC.md): the boats placed 1..kFullModelBoats in the standings carry
// the full Collada models, every other boat a flat textured hull sized to kSimpleBoatSizeFactor of
// the model's hull length, with a callsign-only annotation. The texture's opaque hull spans
// kSimpleBoatTextureFill of the (square) image height.
var kFullModelBoats = 6;
var kSimpleBoatSizeFactor = 0.8;
var kSimpleBoatTextureFill = 0.897;
var kSimpleBoatTexture = '/assets/userfrosting/images/tx-simple-boat-sailcast.png';
var kStandingsIntervalMs = 2000;
var gBoatSprites = [];        // per boat: the textured hull mesh, or null below kFullModelBoats boats
var gBoatFullModel = [];      // per boat: true = Collada models, false = the textured hull
var gBoatRank = [];           // per boat: 0-based place in the standings
var gBoatAnnotationHtml = []; // per boat: the last annotation written (skip the DOM write when unchanged)
var gBoatAnnotationWidth = []; // per boat: the annotation's width in px, measured when its text changes
var gBoatAnnotationFullHeight = 60; // the annotation height of a boat on models (60 bird's-eye, 80 chase); a hull's is 18
var gBoatTrailShown = [];     // per boat: the trail dots are visible (only the boats on models trail)
var gSimpleBoatHalfSide = 0;  // half the textured hull plane's side, scene units
var gStandingsHold = false;

var kSailpointSbUp = 0;
var kSailpointSbDn = 1;
var kSailpointPtUp = 2;
var kSailpointPtDn = 3;

var kTwaTgtUp = 40.0;
var kTwaTgtDown = 155.0;

/* ==============================================================
   GLOBALS
   ============================================================== */
var gWindowWidth = $(window).width();
var gEnable3DTerrain = true;
var gGoogleMapsLoaded = false;
var gMarks = null;
var gMarkCones = null;
var gMarkAnnotations = null;
var gBeaconMarkExtras = null;   // beacon marks no drawn mark covers: [{lat, lon, cone, div, z}] (addBeaconMarks)
var gReferenceMarkListIndex = 0;
var gFirstMarkRaceTimeOffset = 0;
var gLegs = null;
var gMarkAnnotationOffset = 0.6;
var gMarkScale = kMarkScaleBev;
var gMarksLoaded = false;
var gStartingLine = null;
var gStartingLineMaterialPre = new THREE.LineBasicMaterial( { color: 0xf00000, linewidth: 5.0 } );
var gStartingLineMaterialPost = new THREE.LineBasicMaterial( { color: 0x00f000, linewidth: 5.0 } );
var gGeoBox = null;
var gLatScale = 1.0;
var gLonScale = 1.0;
var centerLat;
var centerLon;
var gBoatIdList;
var gRecords;
var gBoatFixes = [];                 // per boat slot: {rows, times} of its real records (boatFixBracket)
var gPlaybackTime = 0.0;
var gPlaybackSpeed = 2.0;
var gPlaybackIndex;
var gRaceTimer = 100;
var gNumRecords;
var gLeaderBoard = null;
var gLeaderCalculationHold = false;

var gScene = null;
var gCamera;
var gCameraMode = kCameraModeInit;
var gCameraPlaneLateralDistance = kCameraPlaneLateralDistanceNorm;
var gCameraPlaneVerticalDistance = kCameraPlaneVerticalDistanceNorm;
var gCameraViewpoint = kCameraViewpointNorm;
var gElevationScale = kElevationScaleMin;
var gRenderer;
var gRenderInterval = 1.0 / kRenderMaxFps;
var gRenderMeasuredInterval = 0;
var gBoats;
var gSailpoints;
var gEgoScale = kEgoScaleBev;
var gBoatTrails;
var gBoatTrailInterval = 15;
var gBoatTrailSpotSize = 0.009;
var gBoatTrailSize = 100;
var gBoatTrailIndex;
var gBoatAnnotations;
var gBoatAnnotationOffset = 0;
var gBoatChaseDistance = kCameraPlaneChaseDistance;
var gSelectedBoatPos;
var gHdmDampTime = 100;
var gHdmAvgPerBoat = new Array();
var gEgoModel;
var gWindIndRing = null;
var gWindIndAvg = null;
var gWindIndCurrent = null;
var gWindIndAvgValue = 0;
var gWindIndCurrentValue = 0;
var gWindSpeedFont = null;
var gWindSpeedText = null;
var gWindSpeedUnit = null;
var gLaylines = null;
var gLaylineMaterial = new THREE.LineBasicMaterial( { color: 0xfcbf07, linewidth: 1.5 } );
var gLadderLines = new Array();
var gLadderLinesMaterial = new THREE.LineBasicMaterial( { color: 0xa0a0a0 } );
var gTrackline = null;
var gTracklineMaterial = new THREE.LineDashedMaterial( { color: 0xfcbf07, linewidth: 4.0, scale: 10, dashSize: 1, gapSize: 1  } );
var gTrackLineMark = null;
var gWaterLevel = 2.2;
var gCourseLevel = gWaterLevel + 0.001;
var gLaylineLevel = gWaterLevel + 0.004;
var gGeoOverlayLevel = gWaterLevel + 0.01;
var gWindIndLevel = gWaterLevel + 0.015;
// The replay's wind rose sits on open water near the scene centre (roseWaterPlacement): its x / y / z
var gWindRoseX = 0.0;
var gWindRoseY = 0.0;
var gWindRoseZ = gWindIndLevel;
var kWindRoseRadius = 1.3;      // the ring's visible radius at scale 1 (tx-wind-indicator-ring.png)
var kWindRoseSearchMax = 6.0;   // how far from the centre it may move - the default views show about +-7.5
var kWindRoseLiftMax = 0.15;    // fallback lift above the terrain base at most (a mountain cannot float it away)
var water = null;
var gVector = new THREE.Vector3();
var time = 0;
var renderClock = new THREE.Clock();

// Boat tracking data for wind overlay
var gTwdDampTime = 10;
var gTwdCameraDampTime = 600;
var gTwdAvg = mvutils_avg360_init( numBoats );
var gTwdDisplayAvg = mvutils_avg360_init( gTwdDampTime * Math.round(gPlaybackSpeed) );
var gTwdCameraAvg = mvutils_avg360_init( gTwdCameraDampTime * Math.round(gPlaybackSpeed) );
var gTwd = 0;
var gTws = 0;
var gTwaTgt = 0;
var gTwaTgtUp = kTwaTgtUp;
var gTwaTgtUpAvg = mvutils_avg360_init( gTwdDampTime * Math.round(gPlaybackSpeed) );
var gTwaTgtDown = kTwaTgtDown;
var gTwaTgtDownAvg = mvutils_avg360_init( gTwdDampTime * Math.round(gPlaybackSpeed) );
var gTwaTgtPointOfSail = kNextMarkIsReaching;
var gNextMarkHDT = 0;
var gXName = '';
var gLaylineLength = 5.0;
var gSelectedBoatIndex = 0;

// Replay controls
var gReplayScrubber = document.getElementById("replay-scrubber");
var gReplayScrubberStops = new Array();
var gReplayActive = false;
var gRaceStartTime;
var gRaceDuration;
var gRaceStartOffset = new Array();
var gAllElementsLoaded = false;
var gAllLogsLoaded = false;
var gGeoTexturesLoaded = false;
var gOceanTexturesLoaded = false;
var gDemoMode = false;

// Overview mode (Design/SAILCAST.md): one static frame of the whole race - full track coloured by
// speed performance, wind arrows, all marks - from a high camera with the mean wind as "up".
// Set from the page (overviewMode / rCaptureToken); the replay never enters these branches.
var gOverviewMode = (typeof overviewMode !== 'undefined' && overviewMode) ? true : false;
var gCaptureToken = (typeof rCaptureToken !== 'undefined' ? rCaptureToken : '');
// Fleet overview (Design/TRACKER_RC.md): every participant's track in its own colour
var gFleetMode = (typeof overviewFleet !== 'undefined' && overviewFleet) ? true : false;
var gFleetInfo = (typeof overviewFleetInfo !== 'undefined' && overviewFleetInfo ? overviewFleetInfo : null);

// A start group - several fleets started with one gun (Design/TRACKER_RC_IMPL.md "Start groups on
// the website"): the page's fleetLegend lists the fleets in group order with the hull colour of
// their Collada models and the tint of their textured hulls; raceInfos[i].fleetIndex says which
// fleet a boat sails in. null for a single fleet or an ordinary race - nothing below changes then.
var gFleetHulls = (typeof fleetLegend !== 'undefined' && fleetLegend && fleetLegend.length > 1) ? fleetLegend : null;
var gFleetHullMaterials = {};  // fleet index + '|' + original material uuid -> the tinted clone

/** The fleet a boat sails in, its position in the start group (0 = the requested start). */
function fleetIndexOfBoat( idx )
{
    if ( raceInfos === null || raceInfos[idx] === undefined ) return 0;
    var k = parseInt( raceInfos[idx].fleetIndex );
    return (isNaN( k ) || k < 0 ? 0 : k);
}

/** The models' own red hull (diffuse 0.80, 0, 0 in the Collada files): the meshes a fleet tint applies to. */
function isHullMaterial( material )
{
    return (material !== undefined && material !== null && material.color !== undefined
            && material.color.r > 0.7 && material.color.g < 0.05 && material.color.b < 0.05);
}

/**
 * Tints the hull meshes of a boat's model clone in its fleet's colour. clone() shares materials
 * with the shared model, so a tinted copy is swapped in per original material and cached per
 * fleet - a fleet adds a handful of materials, not one per boat. Fleet 0 keeps the red model.
 */
function applyFleetHullTint( model, fleetIdx )
{
    if ( gFleetHulls === null || fleetIdx <= 0 || !gFleetHulls[fleetIdx % gFleetHulls.length] ) return;
    var color = gFleetHulls[fleetIdx % gFleetHulls.length].color;
    var tinted = function ( original )
    {
        if ( !isHullMaterial( original ) ) return original;
        var key = fleetIdx + '|' + original.uuid;
        if ( gFleetHullMaterials[key] === undefined )
        {
            var m = original.clone();
            m.color.set( color );
            gFleetHullMaterials[key] = m;
        }
        return gFleetHullMaterials[key];
    };
    model.traverse( function ( o )
    {
        if ( !(o instanceof THREE.Mesh) || !o.material ) return;
        if ( Array.isArray( o.material ) ) o.material = o.material.map( tinted );
        else o.material = tinted( o.material );
    } );
}

/** '&solo=1' when the page was opened for one fleet of a start group, else '' (the shared requests carry it) */
function replaySoloFlag()
{
    return (/[?&]solo=1(&|$)/.test( window.location.search ) ? '&solo=1' : '');
}
var gOverviewObjects = [];
var gOverviewCam = null;
var kOverviewElevationDeg = 60;
var kOverviewArrowIntervalS = 120;
var kOverviewMaxArrows = 150;
var kOverviewMaxTrackPoints = 3000;
var gOverviewRose = null;     // { sector, outline, twd, tws, left, right } - see renderOverviewWindRose()
var gOverviewLegPoints = null; // [{idx, x, y, anchors[], seconds}] label anchors - see overviewLegSplit()
// Leg label placement: offsets tried around an anchor, in label widths / heights (renderOverviewLegLabels)
var kOverviewLabelOffsets = [ [0, 0], [0, 1.9], [0.75, 0], [-0.75, 0], [0.75, 1.9], [-0.75, 1.9], [0, -1.1], [0, 3.0] ];
// ... and the fractions of a leg's time at which anchors are tried: the midpoint first, then outwards
var kOverviewLabelFractions = [0.5, 0.42, 0.58, 0.34, 0.66, 0.26, 0.74, 0.18, 0.82];
var gOverviewArrowTws = null; // { min, max } kn of the wind-arrow colour scale, { constant } or { none } - see renderOverviewWindArrows()
var gOverviewTerrain = null;  // { res, water: Uint8Array, zmax: Float32Array|null } - see overviewBuildTerrainMask()
var kOverviewTerrainRes = 256;

// Race media photo masonry
var gMediaPhotoTimelineHeight = 0;
var gPhotoTimelineAnimationInterval = 0;
//var gMediaMinColWidth = 128;
//var gMediaRoots;

// Google elevation service
var gElevationService = null;
var googleMapsLoaded = false;

/* ==============================================================
   ENTRY POINT
   ============================================================== */
function loadView( demo )
{
    gDemoMode = demo;

    if ( gOverviewMode )
    {
        document.body.classList.add( 'sc-overview' );
        if ( gCaptureToken !== '' ) document.body.classList.add( 'sc-capture' );
    }

    if ( !demo )
    {
        $("#alerts-page").ufAlerts('clear');
    }

    if ( numBoats === 0 ) return;

    $('#loading-data-alert').show();

    if ( loadRaceData() )
    {
        // Initialize target TWA averages
        mvutils_avg360_add( gTwaTgtUpAvg, gTwaTgtUp );
        mvutils_avg360_add( gTwaTgtDownAvg, gTwaTgtDown );

        loadScene();

        downloadRaceData( demo );

        loadGmaps();
    }
    else
    {
        // Need to show an alert that no race info is available
    }

    // Event listener for the seek bar
    gReplayScrubber.min = 0;
    gReplayScrubber.max = 1000;
    gReplayScrubber.step = 0.1;
    gReplayScrubber.addEventListener("input", function() {

        // Stop the auto-play
        replayPause();

        // Calculate the new time
        var racetime = gRaceDuration * ( gReplayScrubber.value / 1000.0 );

        // Update the video time
        replaySkipTo( racetime );
    });

    // Pause the playback when the slider handle is being dragged
    gReplayScrubber.addEventListener("mousedown", function() {
        replayPause();
    });

    // Play the playback when the slider handle is dropped
    gReplayScrubber.addEventListener("mouseup", function() {
        replayResume();
    });
    gReplayScrubber.addEventListener("touchend", function() {
        replayResume();
    });

    // Reload the scene if the window changed
    if ( browserIsMobile === 0 )
    {
        $(window).resize(function () {
            layoutContainer();
            layoutPlayerView();
        });
    }
    else
    {
        // On mobile only use the width change to trigger a reload.
        // The height changes when the browser bar is hidden automatically.
        $(window).resize(function () {
            if ( $(window).width() !== gWindowWidth )
            {
                gWindowWidth = $(window).width();
                layoutContainer();
                layoutPlayerView();
            }
        });
    }

    $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-north.png"');
    $('#scene-viewpoint-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-normal.png"');
}

function gSailCastSizeNotification()
{
    // Make sure the layout loop is done before we use the current DIV sizes
    setTimeout( function() {
        layoutPlayerView();
    }, 500 );
}

/* ==============================================================
   VIEW LAYOUT
   ============================================================== */
function scrollViewForMobile()
{
    if ( browserIsMobile !== 0 || originatorIsApp === 1 )
    {
        console.log('Adjusting for mobile');

        // Collapse the side bar
        if ( $('body,html').hasClass('sidebar-collapse') === false )
        {
            $('.sidebar-toggle').click()
        }

        // Scroll past the header to maximize viewing area in landscape orientation and on phones
        if ( window.innerWidth > window.innerHeight || window.innerWidth < 400 )
        {
            $([document.documentElement, document.body]).animate({scrollTop: $('.content-wrapper').offset().top}, 1000);
        }
    }
}

function layoutContainer()
{
    var totalWidth = parseInt($('#sailcast-container').width(), 10);
    var timelinePercentage = (totalWidth > 1120 ? 0.40 : (totalWidth > 768 ? 0.30 : 0.20));

    // Override width percentage for phones in landscape
    if ( window.innerHeight <= 450 && window.innerWidth > 500 ) timelinePercentage = 0.30;
    var timelineWidth = (mediaStreamNumPhotos > 0 && !gOverviewMode ? Math.min( 420, (totalWidth * timelinePercentage).toFixed(0) ) : 0);
    var playerWidth = totalWidth - timelineWidth - 6;
    $('#sailcast-player').attr('style', 'width: ' + playerWidth.toFixed(0) + 'px');
    $('#sailcast-photostream').attr('style', 'width: ' + timelineWidth.toFixed(0) + 'px');

    if ( document.getElementById('sailcast-photostream') != null )
    {
        gMediaPhotoTimelineHeight = document.getElementById('sailcast-photostream').scrollHeight;
    }
}

function layoutPlayerView()
{
    var sceneDiv = document.getElementById('scene');
    gRenderer.setSize( sceneDiv.offsetWidth, sceneDiv.offsetHeight );

    gCamera.aspect = sceneDiv.offsetWidth / sceneDiv.offsetHeight;
    gCamera.updateProjectionMatrix();

    if ( gCameraMode === kCameraModeBevGeo || kCameraModeBevWind )
    {
        gCamera.fov = kCameraFovBev;
    }
    else
    {
        gCamera.fov = kCameraFovChase;
    }
    if ( gOverviewMode && gOverviewCam !== null ) computeOverviewCamera();
    updateCamera();

    $('#scene-canvas').css('opacity', 1.0);
    $('#sailcast-data-spinner').removeClass('fa-spin');
    $('#sailcast-data-spinner').hide();
    $('#loading-data-alert').hide();
    if ( !gOverviewMode )
    {
        $('#scene-controls').show();
        $('#scene-boat-legend').show();
        $('#scene-camera-toggle').show();
        $('#scene-viewpoint-toggle').show();
        preloadCameraIcons();
        $('#replay-pause').show();
        $('#replay-scrubber-container').show();
    }

    // Reset the mark cone and annotation positions
    if ( gMarkCones != null && gMarkCones.length > 0
         && gMarkAnnotations != null && gMarkAnnotations.length > 0 )
    {
        for ( var i = 0; i < gMarks.length; i++ )
        {
            var pos = translate(gMarks[i].lat, gMarks[i].lon);
            gMarkCones[i].position.x = pos.x;
            gMarkCones[i].position.y = pos.y;

            for ( var j=0; j<gMarkAnnotations.length; j++ )
            {
                if ( gMarkAnnotations[j].index === gMarks[i].index )
                {
                    // The pin has no annotation, so skip it (index 0, no name)
                    if ( (gMarks[i].index === 0 && gMarks[i].name === 'Start') || gMarks[i].index > 0 )
                    {
                        gMarkAnnotations[j].x = pos.x;
                        gMarkAnnotations[j].y = pos.y;
                    }
                }
            }
        }
    }
    if ( gBeaconMarkExtras !== null )
    {
        for ( var e = 0; e < gBeaconMarkExtras.length; e++ )
        {
            var ePos = translate( gBeaconMarkExtras[e].lat, gBeaconMarkExtras[e].lon );
            gBeaconMarkExtras[e].cone.position.x = ePos.x;
            gBeaconMarkExtras[e].cone.position.y = ePos.y;
        }
    }

    if ( gOverviewMode )
    {
        // Viewport changes after the one-shot render (the capture sidecar sizes its window
        // late): re-project every DOM label, not only the marks
        if ( gOverviewCam !== null ) { renderMarkAnnotations(); renderOverviewLegLabels(); gRenderer.render( gScene, gCamera ); }
        return;
    }

    setTimeout( function() {
        layoutScrubberTimeline();
    }, 100 );
}

function layoutScrubberTimeline()
{
    var divWidth = $('#replay-scrubber-container').width();

    // Get the effective rendered width of each label after the first paint cycle had a chance to run
    for ( var i = 0; i < gReplayScrubberStops.length; i++ )
    {
        if ( gReplayScrubberStops[i].normalWidth === 0 )
        {
            // Add a 2px margin since sometimes the pixel rounding can cause the width to be 1px too small
            // to fit the text as rendered based on the DIV's x-offset fraction
            gReplayScrubberStops[i].normalWidth = gReplayScrubberStops[i].labelNormed.width() + 2;
        }
    }

    for ( var i=0; i<gReplayScrubberStops.length; i++ )
    {
        var yOffset = $('#replay-scrubber-container').offset().top + 5;
        var lOffset = (gReplayScrubberStops[i].raceTime + gFirstMarkRaceTimeOffset) / gRaceDuration * divWidth;
        lOffset += $('#replay-scrubber-container').offset().left; // Need to account for parent position

        /// Set left offset (adjust for icon width)
        gReplayScrubberStops[i].xOffset = lOffset - 10;
        gReplayScrubberStops[i].label.offset( {left: lOffset - 10, top: yOffset} );
        gReplayScrubberStops[i].labelBr.offset( {left: lOffset - 10, top: yOffset} );
    }

    $('#replay-scrubber').width( divWidth );

    // Adjust visibility of the mark labels based on available space
    var upperLine = true;
    for ( var i=0; i<gReplayScrubberStops.length - 1; i++ )
    {
        var gap = gReplayScrubberStops[i+1].xOffset - gReplayScrubberStops[i].xOffset;
        document.getElementById('rsstop-' + i ).style.width = gReplayScrubberStops[i].normalWidth + 'px';
        document.getElementById('rsstop-' + i ).style.maxWidth = gReplayScrubberStops[i].normalWidth + 'px';

        if ( gReplayScrubberStops[i].label.width() < gap )
        {
            // Text fits - put it above scrubber
            upperLine = true;
            gReplayScrubberStops[i].label.css( 'opacity', 1.0 );
            gReplayScrubberStops[i].labelBr.css( 'opacity', 0.0 );
        }
        else
        {
            if ( upperLine )
            {
                // Text is too long - put it below scrubber
                upperLine = false;
                gReplayScrubberStops[i].label.css( 'opacity', 0.0 );
                gReplayScrubberStops[i].labelBr.css( 'opacity', 1.0 );
            }
            else
            {
                // Text is too long but we already were below scrubber - put it above and truncate the DIV
                upperLine = true;
                gReplayScrubberStops[i].label.css( 'opacity', 1.0 );
                gReplayScrubberStops[i].labelBr.css( 'opacity', 0.0 );
                gReplayScrubberStops[i].label.css( 'maxWidth', Math.max( gap, 16 ) + 'px' );
            }
        }
    }

    // Finish is always in the top row
    gReplayScrubberStops[i].label.css( 'opacity', 1.0 );
    gReplayScrubberStops[i].labelBr.css( 'opacity', 0.0 );
}

function togglePlay()
{
    if ( gReplayActive )
    {
        replayPause();
    }
    else
    {
        replayResume();
    }
}

/* ==============================================================
   LOADING RACE DATA
   ============================================================== */
function loadRaceData()
{
    if ( raceInfos == null || raceInfos.length === 0 )
    {
        return false;
    }

    // Parse the logged marks for each boat entry and sort them as they are not ordered in the JSON.
    for ( var i = 0; i < raceInfos.length; i++ )
    {
        var mlist = JSON.parse(raceInfos[i].markList.replace(/'/g, '"'));
        if ( mlist != null && Array.isArray(mlist) )
        {
             mlist = mlist.sort(function (a, b) {
                return (a.index > b.index ? 1 : -1);
            });

            // Sanity check that the marks have a valid lat/lon/roundingTime
            raceInfos[i].loggedMarkList = [];
            for ( var j=0; j<mlist.length; j++ )
            {
                if ( mlist[j].hasOwnProperty('name') && mlist[j]['name']
                     && mlist[j].hasOwnProperty('lat') && mlist[j]['lat']
                     && mlist[j].hasOwnProperty('lon') && mlist[j]['lon']
                     && mlist[j].hasOwnProperty('roundingRaceTime') && mlist[j]['roundingRaceTime'] )
                {
                    // Some 0/0 marks have lat/lon of 10^-41, so accommodate float interpretations for 0/0 (invalid) marks
                    if ( Math.abs(mlist[j]['lat']) > 0.01 && Math.abs(mlist[j]['lon']) > 0.01 )
                    {
                        raceInfos[i].loggedMarkList.push(mlist[j]);
                    }
                }
                else
                {
                    console.log("Ignoring incomplete mark:");
                    console.log(mlist[j]);
                }
            }
        }
        else
        {
            raceInfos[i].loggedMarkList = [];
        }
    }

    // Find the most complete mark list
    var gReferenceMarkListIndex = 0;
    for ( var i = 1; i < raceInfos.length; i++ )
    {
        if ( raceInfos[i].loggedMarkList.length > raceInfos[gReferenceMarkListIndex].loggedMarkList.length )
        {
            gReferenceMarkListIndex = i;
        }
    }

    /// For now we set the selected boat to the one with the best mark list and draw wind
    /// lines based on this boat:
    gSelectedBoatIndex = gReferenceMarkListIndex;

    // Figure out which boats are in the race logs and create a lookup array for them - by race id:
    // every tracker race has boatId 0, so the boat id cannot tell the boats of a fleet apart
    gBoatIdList = new Array();
    for ( var i = 0; i < raceInfos.length; i++ )
    {
        gBoatIdList.push(raceInfos[i].raceId);
    }

    return true;
}

function updateTimelineStopsForSelectedBoatIdx( selectedBoatIdx )
{
    gSelectedBoatIndex = selectedBoatIdx;

    // Save a deep copy of our global mark list as we will add start marks to it
    gMarks = JSON.parse( JSON.stringify( raceInfos[gSelectedBoatIndex].loggedMarkList ) );

    var startBoat = { index: 0,
        lat: raceInfos[gReferenceMarkListIndex].startBoatLat,
        lon: raceInfos[gReferenceMarkListIndex].startBoatLon,
        name: 'Start',
        type: 'start-boat' };

    var startPin = { index: 0,
        lat: raceInfos[gReferenceMarkListIndex].startPinLat,
        lon: raceInfos[gReferenceMarkListIndex].startPinLon,
        name: '',
        type: 'start-pin' };

    // Add the start time, rounding times and names to the time scrubber stops
    var startLabel = $('<div id="rsstop-0" class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>Start</div>')
        .appendTo($('#replay-scrubber-container'));
    var startLabelNormed = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>Start</div>')
        .appendTo($('#replay-scrubber-container'));
    var startLabelBr = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i><br>Start</div>')
        .appendTo($('#replay-scrubber-container'));
    startLabel.css('left', '0px');
    startLabelBr.css('left', '0px');

    var start = {
        label: startLabel,
        labelNormed: startLabelNormed,
        labelBr: startLabelBr,
        brActive: false,
        xOffset: 0,
        normalWidth: 0,
        raceTime: 0,
        utcTime: raceInfos[0].startTimeUtc,
        name: 'Start' };
    gReplayScrubberStops.push( start );

    for ( var i=0; i<gMarks.length; i++ )
    {
        if ( gMarks[i].name === 'START-FINISH' )
        {
            gMarks[i].name = 'Finish';
        }

        var stopLabel = $('<div id="rsstop-' + (i+1) + '" class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>' + scBeaconDot( gMarks[i] ) + scMarkLabel( gMarks[i].name ) + '</div>')
            .appendTo($('#replay-scrubber-container'));
        var stopLabelNormed = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>' + scBeaconDot( gMarks[i] ) + scMarkLabel( gMarks[i].name ) + '</div>')
            .appendTo($('#replay-scrubber-container'));
        var stopLabelBr = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i><br>' + scBeaconDot( gMarks[i] ) + scMarkLabel( gMarks[i].name ) + '</div>')
            .appendTo($('#replay-scrubber-container'));
        stopLabel.css('left', '0px');
        stopLabelBr.css('left', '0px');

        var stop = {
            label: stopLabel,
            labelNormed: stopLabelNormed,
            labelBr: stopLabelBr,
            brActive: false,
            xOffset: 0,
            normalWidth: 0,
            raceTime: gMarks[i].roundingRaceTime,
            utcTime: gMarks[i].roundingUtcTime,
            name: gMarks[i].name };
        gReplayScrubberStops.push( stop );

        var annotationDiv = document.createElement('div');
        annotationDiv.id = 'mark-annotation-' + gMarks[i].index;
        annotationDiv.style.position = 'absolute';
        annotationDiv.style.width = 100;
        annotationDiv.style.height = 50;
        annotationDiv.style.top = 0 + 'px';
        annotationDiv.style.left = 9999 + 'px';
        annotationDiv.style.zIndex = 5000;
        if ( gMarks[i].name === 'FINISH' || gMarks[i].name === 'Finish' )
        {
            if ( !((gMarks[i].lat > startBoat.lat - 0.0001 && gMarks[i].lat < startBoat.lat + 0.0001)
                   &&
                   (gMarks[i].lon > startBoat.lon - 0.0001 && gMarks[i].lon < startBoat.lon + 0.0001)) )
            {
                annotationDiv.innerHTML = '<p class="mark-legend no-text-select">' + scBeaconDot( gMarks[i] ) + scMarkLabel( gMarks[i].name ) + '</p>';
            }
        }
        else
        {
            annotationDiv.innerHTML = '<p class="mark-legend">' + scBeaconDot( gMarks[i] ) + scMarkLabel( gMarks[i].name ) + '</p>';
        }
        document.getElementById('scene').appendChild( annotationDiv );
    }

    // Add headings to marks for up-/downwind determination
    if ( gMarks.length > 0 )
    {
        gMarks[0].xhdt = mvutils_calculate_xhdm(startBoat, gMarks[0]);
        console.log( 'Heading 0: ' + gMarks[0].xhdt);
    }
    for ( var m=1; m<gMarks.length; m++ )
    {
        gMarks[m].xhdt = mvutils_calculate_xhdm( gMarks[m-1], gMarks[m] );
        console.log( 'Heading ' + m + ': ' + gMarks[m].xhdt);
    }

    gMarks.unshift( startPin );
    gMarks.unshift( startBoat );

    var startDiv = document.createElement('div');
    startDiv.id = 'mark-annotation-0';
    startDiv.style.position = 'absolute';
    startDiv.style.width = 100;
    startDiv.style.height = 50;
    startDiv.style.top = 0 + 'px';
    startDiv.style.left = 9999 + 'px';
    startDiv.style.color = '#fff200';
    startDiv.innerHTML = '<p class="mark-legend">START</p>';
    document.getElementById('scene').appendChild( startDiv );
}

function replaySpeedChanged( speed )
{
    gPlaybackSpeed = speed;
    mvutils_avg360_reset( gTwdDisplayAvg, gTwdDampTime * Math.round(gPlaybackSpeed) );
    mvutils_avg360_reset( gTwdCameraAvg, gTwdCameraDampTime * Math.round(gPlaybackSpeed) );
    mvutils_avg360_reset( gTwaTgtUpAvg, gTwdDampTime * Math.round(gPlaybackSpeed) );
    mvutils_avg360_reset( gTwaTgtDownAvg, gTwdDampTime * Math.round(gPlaybackSpeed) );

    for ( var i=0; i<numBoats; i++ )
    {
        mvutils_avg360_reset( gHdmAvgPerBoat[i], gHdmDampTime * Math.round(gPlaybackSpeed) );
    }
}

/* ==============================================================
   CAMERA CONTROL
   ============================================================== */
function toggleViewpointMode()
{
    if ( gCameraViewpoint === kCameraViewpointNorm )
    {
        gCameraViewpoint = kCameraViewpointLow;
        $('#scene-viewpoint-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-low.png"');
        gCameraPlaneLateralDistance = kCameraPlaneLateralDistanceLow;
        gCameraPlaneVerticalDistance = kCameraPlaneVerticalDistanceLow;
    }
    else if ( gCameraViewpoint === kCameraViewpointLow )
    {
        // The fleet view: the camera follows the top of the standings and frames their last
        // 15 minutes of trail (fleetViewTarget), at the chase-size boat scale
        gCameraViewpoint = kCameraViewpointFleet;
        gFleetCam = null;
        $('#scene-viewpoint-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-fleet.png"');
        gCameraPlaneLateralDistance = kCameraPlaneLateralDistanceNorm;
        gCameraPlaneVerticalDistance = kCameraPlaneVerticalDistanceNorm;
    }
    else
    {
        gCameraViewpoint = kCameraViewpointNorm;
        $('#scene-viewpoint-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-normal.png"');
        gCameraPlaneLateralDistance = kCameraPlaneLateralDistanceNorm;
        gCameraPlaneVerticalDistance = kCameraPlaneVerticalDistanceNorm;
    }

    applyViewpointScales();
    updateCamera();
    renderOnce();
}

/** The boat, trail, hull and mark scales of the bird's-eye modes: the fleet view uses the chase sizes */
function applyViewpointScales()
{
    if ( gCameraMode === kCameraModeChase ) return;
    var fleet = (gCameraViewpoint === kCameraViewpointFleet);
    gEgoScale = (fleet ? kEgoScaleFleet : kEgoScaleBev);
    gBoatAnnotationOffset = (fleet ? 0.2 : 0.6);
    gMarkScale = (fleet ? 1.0 : kMarkScaleBev);
    gMarkAnnotationOffset = (fleet ? 0.2 : 0.5);
    applyEgoScale();
    for ( var i=0; i<gMarkCones.length; i++ ) gMarkCones[i].scale.set( gMarkScale, gMarkScale, gMarkScale );
}

/** gEgoScale onto every boat's models, trail dots and textured hull */
function applyEgoScale()
{
    for ( var i=0; i<gBoats.length; i++ )
    {
        for ( var cc=0; cc<4; cc++ ) gBoats[i][cc].scale.set( gEgoScale, gEgoScale, gEgoScale );
        if ( gBoatTrails[i] !== null )
        {
            for ( var d=0; d<gBoatTrailSize; d++ ) gBoatTrails[i][d].scale.set( gEgoScale, gEgoScale, gEgoScale );
        }
        if ( gBoatSprites.length > i ) gBoatSprites[i].scale.set( gEgoScale / kEgoScaleBev, gEgoScale / kEgoScaleBev, 1 );
    }
}

/**
 * The fleet viewpoint's frame: the centre and camera distance that hold the boats on models
 * (the top of the standings) and their last kFleetViewTrailSeconds of trail dots.
 *
 * @return {{cx, cy, d}|null} null until a boat has been placed
 */
function fleetViewTarget()
{
    var minX = 1e9, maxX = -1e9, minY = 1e9, maxY = -1e9, n = 0;
    var dots = Math.min( gBoatTrailSize, Math.ceil( kFleetViewTrailSeconds / gBoatTrailInterval ) );
    for ( var i=0; i<gBoats.length; i++ )
    {
        if ( gBoatSprites.length > 0 && !gBoatFullModel[i] ) continue;
        var p = gBoats[i][0].position;
        if ( p.z < 1.0 ) continue;   // not placed yet
        minX = Math.min( minX, p.x ); maxX = Math.max( maxX, p.x ); minY = Math.min( minY, p.y ); maxY = Math.max( maxY, p.y ); n++;
        if ( gBoatTrails[i] === null || !gBoatTrailShown[i] ) continue;
        for ( var k=0; k<dots; k++ )
        {
            var dot = gBoatTrails[i][((gBoatTrailIndex[i].index - k) % gBoatTrailSize + gBoatTrailSize) % gBoatTrailSize];
            if ( dot.position.z < 1.0 ) continue;
            minX = Math.min( minX, dot.position.x ); maxX = Math.max( maxX, dot.position.x );
            minY = Math.min( minY, dot.position.y ); maxY = Math.max( maxY, dot.position.y );
        }
    }
    if ( n === 0 ) return null;
    var r = Math.max( kFleetViewMinHalfExtent, (maxX - minX) / 2, (maxY - minY) / 2 );
    // The distance that fits r into the vertical field of view (the oblique angle foreshortens the
    // far half and enlarges the near half of the frame - about even at the bird's-eye elevation)
    var d = r * kFleetViewMargin / Math.tan( kCameraFovBev / 2 * kDegToRad );

    return { cx: (minX + maxX) / 2, cy: (minY + maxY) / 2, d: d };
}

function toggleCameraMode()
{
    // Update the camera mode
    if ( gCameraMode === kCameraModeBevGeo )
    {
        gCameraMode = kCameraModeBevWind;
        gCamera.fov = kCameraFovBev;

        windIndicatorShow();

        gEgoScale = kEgoScaleBev;
        gBoatAnnotationOffset = 0.6; //0.1;
        gMarkScale = kMarkScaleBev;
        gMarkAnnotationOffset = 0.5;
        gBoatAnnotationFullHeight = 60;
        applyAnnotationStyles();
        $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-wind.png"');
    }
    else if ( gCameraMode === kCameraModeBevWind )
    {
        gCameraMode = kCameraModeChase;
        gCamera.fov = kCameraFovChase;

        windIndicatorHide();

        gEgoScale = 1.0;
        gBoatAnnotationOffset = 0.08;
        gMarkScale = 0.5;
        gMarkAnnotationOffset = -0.18;
        gBoatAnnotationFullHeight = 80;
        applyAnnotationStyles();
        $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-chase.png"');
        $('#scene-viewpoint-toggle').hide();
    }
    else
    {
        gCameraMode = kCameraModeBevGeo;
        gCamera.fov = kCameraFovBev;

        windIndicatorShow();

        gEgoScale = kEgoScaleBev;
        gBoatAnnotationOffset = 0.6;
        gMarkScale = kMarkScaleBev;
        gMarkAnnotationOffset = 0.5;
        gBoatAnnotationFullHeight = 60;
        applyAnnotationStyles();
        $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-north.png"');
        $('#scene-viewpoint-toggle').show();
    }

    // Update scale of boat (the fleet viewpoint keeps its own sizes in the bird's-eye modes)
    if ( gCameraMode !== kCameraModeChase && gCameraViewpoint === kCameraViewpointFleet )
    {
        gFleetCam = null;
        applyViewpointScales();
    }
    else applyEgoScale();

    // Update scale of mark cones
    for ( var i=0; i<gMarkCones.length; i++ )
    {
        gMarkCones[i].scale.set( gMarkScale, gMarkScale, gMarkScale );
    }

    updateCamera();
    renderOnce();
}

/**
 * One frame right now: the animation loop only draws while the replay runs and at the frame
 * rate, so a camera or viewpoint toggle would otherwise show at the next player update
 */
function renderOnce()
{
    if ( typeof gRenderer !== 'undefined' && gRenderer && gScene && gCamera ) gRenderer.render( gScene, gCamera );
}

/** The toggle icons fetched up front, so a click swaps the icon at once instead of after a download */
var gCameraIconCache = [];
function preloadCameraIcons()
{
    if ( gCameraIconCache.length > 0 ) return;   // layoutPlayerView runs on every resize
    var names = ['north', 'wind', 'chase', 'normal', 'low', 'fleet'];
    for ( var i=0; i<names.length; i++ )
    {
        var img = new Image();
        img.src = gAssetPrefix + '/img/ic-cam-' + names[i] + '.png';
        gCameraIconCache.push( img );
    }
}

function updateCamera()
{
    // The fleet viewpoint: follow the top of the standings, smoothed, from the bird's-eye direction
    var fleetTarget = ((gCameraMode === kCameraModeBevGeo || gCameraMode === kCameraModeBevWind) && gCameraViewpoint === kCameraViewpointFleet ? fleetViewTarget() : null);
    if ( fleetTarget !== null )
    {
        if ( gFleetCam === null ) gFleetCam = fleetTarget;
        else
        {
            gFleetCam.cx += (fleetTarget.cx - gFleetCam.cx) * 0.06;
            gFleetCam.cy += (fleetTarget.cy - gFleetCam.cy) * 0.06;
            gFleetCam.d += (fleetTarget.d - gFleetCam.d) * 0.06;
        }
        var lx = 0.0, ly = -gCameraPlaneLateralDistance;
        if ( gCameraMode === kCameraModeBevWind )
        {
            lx = Math.sin( mvutils_add360( gTwdCameraAvg.avg, 180 ) * kDegToRad ) * gCameraPlaneLateralDistance;
            ly = Math.cos( mvutils_add360( gTwdCameraAvg.avg, 180 ) * kDegToRad ) * gCameraPlaneLateralDistance;
        }
        var len = Math.sqrt( lx * lx + ly * ly + gCameraPlaneVerticalDistance * gCameraPlaneVerticalDistance );
        gCamera.position.set( gFleetCam.cx + lx / len * gFleetCam.d, gFleetCam.cy + ly / len * gFleetCam.d, gWaterLevel + gCameraPlaneVerticalDistance / len * gFleetCam.d );
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt( new THREE.Vector3( gFleetCam.cx, gFleetCam.cy, gWaterLevel ) );
    }
    else if ( gCameraMode === kCameraModeBevGeo )
    {
        gCamera.position.set( 0, -gCameraPlaneLateralDistance, gCameraPlaneVerticalDistance );
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt( new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset) );
    }
    else if ( gCameraMode === kCameraModeBevWind )
    {
        var x = Math.sin( mvutils_add360( gTwdCameraAvg.avg, 180 ) * kDegToRad ) * gCameraPlaneLateralDistance;
        var y = Math.cos( mvutils_add360( gTwdCameraAvg.avg, 180 ) * kDegToRad ) * gCameraPlaneLateralDistance;

        gCamera.position.set(x, y, gCameraPlaneVerticalDistance);
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt(new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset));
    }
    else if ( gCameraMode === kCameraModeOverview && gOverviewCam !== null )
    {
        gCamera.position.set( gOverviewCam.x, gOverviewCam.y, gOverviewCam.z );
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt( new THREE.Vector3( gOverviewCam.cx, gOverviewCam.cy, gWaterLevel ) );
    }
    else if ( gCameraMode === kCameraModeChase )
    {
        var pos = getPastPositionForBoat( 20, gSelectedBoatIndex );

        // Extend camera position further back
        var cx = gSelectedBoatPos.x + gBoatChaseDistance * (pos.x - gSelectedBoatPos.x);
        var cy = gSelectedBoatPos.y + gBoatChaseDistance * (pos.y - gSelectedBoatPos.y);

        //console.log('CAM-POS, ' + cy + ',' + gSelectedBoatPos.y + ', ' + pos.y);

        gCamera.position.set(cx, cy, gWaterLevel + 0.3);
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt(new THREE.Vector3(gSelectedBoatPos.x, gSelectedBoatPos.y, gWaterLevel + 0.1));
    }
}

/* ==============================================================
   RENDERING FUNCTIONS
   ============================================================== */
function animate()
{
    if ( gReplayActive )
    {
        requestAnimationFrame( animate );
    }

    // Use absolute time delta to determine step sizes
    var delta = renderClock.getDelta();
    if ( delta > 0.5 )
    {
        // We got paused (by button or switching to another tab),
        // so just continue with the next normal rendering interval
        return;
    }

    gRenderMeasuredInterval += delta;
    gPhotoTimelineAnimationInterval += delta;
    if ( gRenderMeasuredInterval > gRenderInterval )
    {
        gPlaybackTime += (gRenderMeasuredInterval * gPlaybackSpeed);
        if (gPlaybackTime >= gRaceDuration - 1.0) {
            gPlaybackTime = 0.0;
            gPlaybackIndex = 0;
        }

        gRenderMeasuredInterval = 0;

        var playbackData = getRecordsAtCurrentPlaybackTime();

        if ( playbackData.recList != null )
        {
            renderBoats( playbackData.recList );

            renderMarkAnnotations();

            renderWindLines( playbackData.nextMarkIdx );

            updateCamera();

            gReplayScrubber.value = gPlaybackTime * (1000.0 / gRaceDuration);

            gRenderer.render( gScene, gCamera );
        }
    }

    if ( /*gPhotoTimelineAnimationInterval > 1.0 &&*/ document.getElementById('sailcast-photostream') != null )
    {
        var photoTimelineTop = 0;
        if ( gPlaybackTime > 0 && gRaceDuration > 10 )
        {
            photoTimelineTop = gPlaybackIndex / gRaceDuration * document.getElementById('sailcast-photostream').scrollHeight.toFixed(1);
        }
        document.getElementById('sailcast-photostream').scrollTop = photoTimelineTop;
        //$('#sailcast-photostream').animate({
        //    scrollTop: photoTimelineTop
        //}, gPhotoTimelineAnimationInterval * 1000.0);
        //gPhotoTimelineAnimationInterval = 0;
    }
}

function replayResume()
{
    gReplayActive = true;
    $('#replay-pause').html(tqTranslate('JS.PAUSE'));

    animate();
}

function replayPause()
{
    gReplayActive = false;
    $('#replay-pause').html(tqTranslate('JS.PLAY'));
}

function replaySkipTo( racetime )
{
    //console.log( 'Skipping from ' + gPlaybackTime + ' to ' + racetime);
    var index = gPlaybackIndex;

    if ( racetime > gPlaybackTime )
    {
        // Skipping forward
        while ( racetime > (gRecords[index][0].rtime / 100.0 - gRaceStartTime) )
        {
            index++;
            if ( index >= gNumRecords - 2 )
            {
                index = gNumRecords - 2;
                break;
            }
        }
    }
    else
    {
        // Skipping back in time
        while ( racetime < (gRecords[index][0].rtime / 100.0 - gRaceStartTime) )
        {
            index--;
            if ( index < 0 )
            {
                index = 0;
                break;
            }
        }
    }

    gPlaybackTime = gRecords[index][0].rtime / 100.0 - gRaceStartTime;
    gPlaybackIndex = index;
}

function updateLeaderBoard( rec )
{
    // Sanity check for more than one boat
    if ( rec.length < 2 ) return;

    // Only run this twice a second if we have at least two boats
    if ( gLeaderCalculationHold ) return;
    gLeaderCalculationHold = true;
    setTimeout( function() { gLeaderCalculationHold = false; }, 500 );

    // Sanity check that the race started for all boats (in a pursuit start we only show this once all boats started)
    var raceStarted = true;
    for ( var i=0; i<rec.length; i++ )
    {
        if ( rec[i].racetime < 5 )
        {
            raceStarted = false;
            gLeaderBoard = null;
            return;
        }
    }

    // First, find the leading leg index of all boats
    var leadingLegIdx = 0;
    for ( i=0; i<rec.length; i++ )
    {
        leadingLegIdx = Math.max( leadingLegIdx, rec[i].legIdx );
    }
    if ( leadingLegIdx >= gMarks.length )
    {
        console.log('Found more leg indices than marks!');
        return null;
    }

    // Next we look for at least 2 of the top three boats to be on the same leading leg
    var twoBoatRace = (rec.length === 2);
    var legWithLeadingBoat = -1;
    var legWithDistanceLines = -1;
    var leadCandidate = -1;
    for ( var li=leadingLegIdx; li >= 0; li-- )
    {
        var occupancy = 0;
        for ( i=0; i<rec.length; i++ )
        {
            // Loop through all boats to see who is on this leg. leadCandidate is only used if the first
            // boat is by itself on the leading leg - so only save the first boat we encounter on the leading leg.
            if ( rec[i].legIdx === li )
            {
                if ( leadCandidate === -1 ) leadCandidate = i;
                occupancy++;
            }
        }
        if ( occupancy === 1 && li === leadingLegIdx )
        {
            // The leading leg has a single boat on it
            legWithLeadingBoat = li;
        }
        if ( occupancy >= 2
             ||
             (twoBoatRace && li<legWithLeadingBoat && occupancy === 1) )
        {
            // The leg has at least 2 boats on it or we only have two boats
            legWithDistanceLines = li;
            break;
        }
    }
    if ( legWithLeadingBoat === -1 && legWithDistanceLines === -1 )
    {
        gLeaderBoard = null;
        return;
    }

    gLeaderBoard = null;
    gLeaderBoard = new Array();

    // If the leading boat is past the last mark stop calculating
    if ( leadingLegIdx >= gLegs.length ) return;

    // Check if we have a single leader already one leg ahead and adjust for the distance they already sailed from the mark
    var leaderDistancePastMark = 0;
    if ( legWithLeadingBoat > legWithDistanceLines && leadCandidate >= 0 && legWithLeadingBoat > 0 )
    {
        var vmgDistFromPrevMark;
        var distFromPrevMark = mvutils_distanceFromTo( gLegs[legWithLeadingBoat-1].lat,
                                                       gLegs[legWithLeadingBoat-1].lon,
                                                       rec[leadCandidate].lat,
                                                       rec[leadCandidate].lon ) * 1852.0;
        var headingFromPrevMark = mvutils_calculate_xhdm( {lat: gLegs[legWithLeadingBoat-1].lat, lon: gLegs[legWithLeadingBoat-1].lon},
                                                          {lat: rec[leadCandidate].lat, lon: rec[leadCandidate].lon} );
        headingFromPrevMark = mvutils_add360( headingFromPrevMark, -rec[leadCandidate].magvar );

        if ( legIsReaching( legWithLeadingBoat ) )
        {
            vmgDistFromPrevMark = Math.abs( distFromPrevMark * Math.cos( mvutils_substract360(gLegs[leadingLegIdx].legHdm, headingFromPrevMark) * kDegToRad ) );
        }
        else
        {
            vmgDistFromPrevMark = Math.abs(distFromPrevMark * Math.cos(mvutils_substract360(gTwd, headingFromPrevMark) * kDegToRad));
        }
        //console.log('Lead dist from last mark: ' + distFromPrevMark.toFixed(0) + ' | @ ' + mvutils_substract360(gTwd, headingFromPrevMark).toFixed(1) + 'º | ' + vmgDistFromPrevMark.toFixed(0));

        /// Need to check for VMG vs straight reaching
        leaderDistancePastMark = vmgDistFromPrevMark;

        gLeaderBoard.push( { idx: leadCandidate, dist: 0, gap: 0 } );
    }

    // Now find the leading two or three boats within the leading leg
    var legCandidates = new Array();
    for ( var i=0; i<rec.length; i++ )
    {
        if ( rec[i].legIdx !== legWithDistanceLines ) continue;

        // The distance and bearing to the next mark: logged by an instrument boat, computed from the
        // position and the mark for a tracker log (the phone app has no routing - xDist stays 999999,
        // which left a tracker fleet without a leader board)
        var xDist = rec[i].xDist;
        var xHdm = rec[i].xHdm;
        if ( !(xDist > 0 && xDist !== 999999 && xHdm !== 999999) )
        {
            if ( gLegs === null || legWithDistanceLines >= gLegs.length || rec[i].lat === 0 || rec[i].lon === 0 ) continue;
            var mark = gLegs[legWithDistanceLines];
            xDist = mvutils_distanceFromTo( rec[i].lat, rec[i].lon, mark.lat, mark.lon ) * 1852.0;
            xHdm = mvutils_add360( mvutils_calculate_xhdm( {lat: rec[i].lat, lon: rec[i].lon}, {lat: mark.lat, lon: mark.lon} ), -rec[i].magvar );
            if ( !(xDist > 0) ) continue;
        }

        var vmgDist;
        if ( legIsReaching( legWithDistanceLines ) )
        {
            vmgDist = Math.abs(xDist * Math.cos(mvutils_substract360(gLegs[legWithDistanceLines].legHdm, xHdm) * kDegToRad));
        }
        else
        {
            vmgDist = Math.abs(xDist * Math.cos(mvutils_substract360(gTwd, xHdm) * kDegToRad));
        }
        //console.log('Dist [' + i + '] to mark: ' + vmgDist.toFixed(0));
        legCandidates.push( { idx: i, dist: vmgDist } );
    }
    legCandidates.sort(function(a, b) {
        if (a.dist > b.dist) {
            return 1;
        }
        if (a.dist < b.dist) {
            return -1;
        }
        return 0;
    });

    for ( i=0; i<Math.min(3, legCandidates.length); i++ )
    {
        gLeaderBoard.push( { idx: legCandidates[i].idx, dist: leaderDistancePastMark + legCandidates[i].dist, gap: 0.0 } );
    }
    for ( i=1; i<gLeaderBoard.length; i++ )
    {
        gLeaderBoard[i].gap = gLeaderBoard[i].dist - gLeaderBoard[i-1].dist;
    }
}

function legIsReaching( idx )
{
    if ( idx >= gLegs.length ) return true;

    // Check if we have an up/downwind or a reaching leg
    var legTwa = Math.abs( mvutils_substract360( gTwd, gLegs[idx].legHdm ) );
    return (legTwa > gTwaTgtUp && legTwa < gTwaTgtDown);
}

/**
 * Fleet replay standings (Design/TRACKER_RC.md): every boat's place - finished boats first (by
 * the end of their log), then the boats beyond the last mark by the distance sailed past it, then
 * by leg and the straight distance to the next mark within the leg (xDist when the log has it,
 * else from the position and the mark). The top kFullModelBoats keep the Collada models, the rest
 * show the textured hull.
 * Re-evaluated every kStandingsIntervalMs, so a boat does not flicker between the two around
 * the sixth place; before the gun the page order stands.
 */
function updateStandings( rec )
{
    if ( gStandingsHold ) return;
    gStandingsHold = true;
    setTimeout( function() { gStandingsHold = false; }, kStandingsIntervalMs );

    var order = [];
    var lastLeg = (gLegs !== null ? gLegs.length : 0);
    for ( var i=0; i<rec.length; i++ )
    {
        var legIdx = (rec[i].legIdx !== undefined ? rec[i].legIdx : 0);
        var tier = legIdx;
        var dist = 1e12;   // no mark to measure against: last within the leg
        var placed = (rec[i].lat !== 0 && rec[i].lon !== 0);
        if ( lastLeg > 0 && legIdx >= lastLeg && placed )
        {
            // Past the last mark. A boat whose log has ended there has finished (the page pads it
            // with its last position and no race time): finished boats rank first, earliest log end
            // first; the others by how far beyond the last mark they have sailed
            var finished = (isNaN( rec[i].racetime ) || rec[i].racetime >= intval0( raceInfos[i].duration ) - 1);
            if ( finished )
            {
                tier = lastLeg + 1;
                dist = intval0( raceInfos[i].duration );
            }
            else
            {
                tier = lastLeg;
                dist = -mvutils_distanceFromTo( rec[i].lat, rec[i].lon, gLegs[lastLeg - 1].lat, gLegs[lastLeg - 1].lon ) * 1852.0;
            }
        }
        else if ( lastLeg > 0 && legIdx < lastLeg && rec[i].racetime >= 5 && placed )
        {
            // The straight distance to the next mark. The leader board's projection onto the leg (or the
            // wind) ranked a boat off the rhumb line ahead of one that was nearer the mark - on a bent
            // leg every boat is off the rhumb line
            dist = (rec[i].xDist > 0 && rec[i].xDist !== 999999
                    ? rec[i].xDist
                    : mvutils_distanceFromTo( rec[i].lat, rec[i].lon, gLegs[legIdx].lat, gLegs[legIdx].lon ) * 1852.0);
        }
        order.push( { idx: i, leg: tier, dist: dist } );
    }
    order.sort( function ( a, b )
    {
        if ( a.leg !== b.leg ) return b.leg - a.leg;
        if ( a.dist !== b.dist ) return a.dist - b.dist;
        return a.idx - b.idx;
    } );
    for ( var p=0; p<order.length; p++ ) gBoatRank[order[p].idx] = p;
    for ( var i=0; i<rec.length; i++ ) gBoatFullModel[i] = (gBoatRank[i] < kFullModelBoats);
}

/**
 * The annotation box of one boat: a boat on models has the mast line at the left and room for
 * four lines; a hull has no mast - its callsign sits centred just above the texture
 */
function applyAnnotationStyle( div, fullModel )
{
    div.style.height = (fullModel ? gBoatAnnotationFullHeight + 'px' : '18px');
    div.style.borderLeftWidth = (fullModel ? '1.5px' : '0px');
    div.style.paddingLeft = (fullModel ? '5px' : '0px');
    div.style.textAlign = (fullModel ? 'left' : 'center');
}

/** Every boat's annotation box after a camera mode change (the full height differs per mode) */
function applyAnnotationStyles()
{
    for ( var i=0; i<numBoats; i++ )
    {
        var div = document.getElementById( 'boat-annotation-' + i );
        if ( div === null ) continue;
        applyAnnotationStyle( div, (gBoatSprites.length === 0 || gBoatFullModel[i]) );
    }
}

/** A race info number as an integer (the page embeds them as strings) */
function intval0( v )
{
    var n = parseInt( v, 10 );
    return (isNaN( n ) ? 0 : n);
}

/** The trail dots of one boat (100 circles, sunk until the replay places them) */
function createBoatTrail( i )
{
    var bTrail = new Array();
    for ( var t=0; t<gBoatTrailSize; t++ )
    {
        var geometry = new THREE.CircleGeometry( gBoatTrailSpotSize, 32 );
        var material = new THREE.MeshLambertMaterial( { color: kTrailColors[i%kTrailColors.length] } );
        material.transparent = true;
        material.opacity = 1.0;
        // Drawn after the water without a depth test, like the textured hulls: a dot a metre above
        // the water plane loses the depth test against the Water2 surface and vanishes - the trail
        // showed early in a race and not after a jump to a later time
        material.depthTest = false;
        var circle = new THREE.Mesh( geometry, material );
        circle.renderOrder = 5;
        circle.position.z = -99999;
        circle.scale.set( gEgoScale, gEgoScale, gEgoScale );
        circle.name = 'TRACK ' + i;
        gScene.add( circle );
        bTrail.push( circle );
    }
    gBoatTrails[i] = bTrail;
    gBoatTrailIndex[i] = {index: 0, time: 0};
}

/**
 * The textured hulls of a fleet replay: a flat square plane per boat carrying the top-down boat
 * texture, sized so the painted hull is kSimpleBoatSizeFactor of the Collada model's hull length.
 * Only a fleet above kFullModelBoats boats gets them; updateStandings decides per boat which
 * representation shows. Called once the shared models are in (loadScene).
 */
function createSimpleBoats()
{
    if ( numBoats <= kFullModelBoats || gBoats.length === 0 || gOverviewMode ) return;

    // The model's hull length in scene units: the bounding box of the upwind pivot (bow along +x at rotation 0)
    var box = new THREE.Box3().setFromObject( gBoats[0][kSailpointSbUp] );
    var hullLength = Math.max( box.max.x - box.min.x, box.max.y - box.min.y );
    if ( !(hullLength > 0) || !isFinite( hullLength ) ) hullLength = 0.2;
    var side = kSimpleBoatSizeFactor * hullLength / kSimpleBoatTextureFill;
    gSimpleBoatHalfSide = side / 2;

    // Drawn after everything (renderOrder) without a depth test: a few metres above the water plane
    // the hull still lost the depth test against the water surface's shader and never showed
    // One material per fleet of a start group, the white texture tinted in the fleet's light
    // colour (gFleetHulls); a single fleet keeps the untinted white hull
    var materials = {};
    var materialForFleet = function ( fleetIdx )
    {
        var key = (gFleetHulls !== null ? fleetIdx % gFleetHulls.length : 0);
        if ( materials[key] === undefined )
        {
            var tint = (gFleetHulls !== null && gFleetHulls[key] ? gFleetHulls[key].tint : 0xffffff);
            materials[key] = new THREE.MeshBasicMaterial( { color: tint, transparent: true, alphaTest: 0.1, depthWrite: false, depthTest: false, fog: false, side: THREE.DoubleSide } );
        }
        return materials[key];
    };
    var textureLoader = new THREE.TextureLoader();
    textureLoader.load( site.uri.public + kSimpleBoatTexture, function ( map ) {
        map.anisotropy = 4;
        for ( var key in materials )
        {
            if ( !materials.hasOwnProperty( key ) ) continue;
            materials[key].map = map;
            materials[key].needsUpdate = true;
        }
    } );
    var geometry = new THREE.PlaneGeometry( side, side );
    for ( var i=0; i<numBoats; i++ )
    {
        var hull = new THREE.Mesh( geometry, materialForFleet( fleetIndexOfBoat( i ) ) );
        hull.name = 'HULL ' + i;
        hull.visible = false;
        hull.renderOrder = 10;
        hull.scale.set( gEgoScale / kEgoScaleBev, gEgoScale / kEgoScaleBev, 1 );
        hull.position.z = -9999;
        gScene.add( hull );
        gBoatSprites.push( hull );
        gBoatFullModel[i] = (i < kFullModelBoats);
    }
    console.log( 'SailCast: ' + numBoats + ' boats - models for the top ' + kFullModelBoats + ', textured hulls (' + side.toFixed(3) + ' of hull ' + hullLength.toFixed(3) + ') for the rest' );
}

/** The race ids of the page, comma-joined, as the capture token was minted for */
function captureRaceIdList()
{
    var ids = [];
    for ( var i=0; i<raceInfos.length; i++ ) ids.push( raceInfos[i].raceId );
    return ids.join( ',' );
}

/** The fleet colour of a boat (Report\FleetPalette order = the page's race order) */
function fleetColorForBoatIndex( idx )
{
    if ( gFleetInfo && gFleetInfo.colors && gFleetInfo.colors.length > 0 ) return gFleetInfo.colors[idx % gFleetInfo.colors.length];
    return colorForBoatIndex( idx );
}

function colorForBoatIndex( idx )
{
    var color = kTrailColors[idx % kTrailColors.length].toString(16);

    // Add leading zeros
    while ( color.length < 6 ) color = '0' + color;

    return '#' + color;
}

function renderBoats( rec )
{
    var sceneH = $('#scene').height();
    if ( gBoats.length > 1 )
    {
        updateLeaderBoard(rec);
        if ( gBoatSprites.length > 0 ) updateStandings( rec );
        if ( gLeaderBoard !== null && gLeaderBoard.length >= 2 )
        {
            $('#leader-1-name').html( raceInfos[gLeaderBoard[0].idx].sailcastName );
            $('#leader-1-dist').html( gLeaderBoard[0].gap.toFixed(0) + 'm' );
            $('#leader-1-vmg').html( rec[gLeaderBoard[0].idx].vmg.toFixed(1) + 'kn' );
            $('#leader-1-name').css( 'color', colorForBoatIndex(gLeaderBoard[0].idx) );
            $('#leader-1-dist').css( 'color', colorForBoatIndex(gLeaderBoard[0].idx) );
            $('#leader-1-vmg').css( 'color', colorForBoatIndex(gLeaderBoard[0].idx) );

            $('#leader-2-name').html( raceInfos[gLeaderBoard[1].idx].sailcastName );
            $('#leader-2-dist').html( gLeaderBoard[1].gap.toFixed(0) + 'm' );
            $('#leader-2-vmg').html( rec[gLeaderBoard[1].idx].vmg.toFixed(1) + 'kn' );
            $('#leader-2-name').css( 'color', colorForBoatIndex(gLeaderBoard[1].idx) );
            $('#leader-2-dist').css( 'color', colorForBoatIndex(gLeaderBoard[1].idx) );
            $('#leader-2-vmg').css( 'color', colorForBoatIndex(gLeaderBoard[1].idx) );

            if ( gLeaderBoard.length > 2 )
            {
                $('#leader-3-name').html( raceInfos[gLeaderBoard[2].idx].sailcastName );
                $('#leader-3-dist').html( gLeaderBoard[2].gap.toFixed(0) + 'm' );
                $('#leader-3-vmg').html( rec[gLeaderBoard[2].idx].vmg.toFixed(1) + 'kn' );
                $('#leader-3-name').css( 'color', colorForBoatIndex(gLeaderBoard[2].idx) );
                $('#leader-3-dist').css( 'color', colorForBoatIndex(gLeaderBoard[2].idx) );
                $('#leader-3-vmg').css( 'color', colorForBoatIndex(gLeaderBoard[2].idx) );
            }

            $('#scene-leader-board').show();
        }
        else
        {
            $('#scene-leader-board').hide();
        }
    }

    for ( i=0; i<gBoats.length; i++ )
    {
        if ( rec[i].lat !== 0 && rec[i].lon !== 0 )
        {
            // Get wind speed ('–' for a tracker race whose crew entered none, raceInfos[].twsSet; a gap in an
            // instrument log keeps the last value shown)
            var tws = (rec[i].tws === 999999 && raceInfos[i] !== undefined && raceInfos[i].twsSet === 0 ? '–' : parseFloat(rec[i].tws).toFixed(1));

            // Get position in scene coordinates
            var pos = translate( rec[i].lat, rec[i].lon );
            if ( i === gSelectedBoatIndex )
            {
                gSelectedBoatPos = pos;
                gTws = tws;
            }

            // A fleet replay: the boats beyond the top kFullModelBoats of the standings show the
            // textured hull instead of the models (createSimpleBoats / updateStandings)
            var fullModel = (gBoatSprites.length === 0 || gBoatFullModel[i]);
            if ( !fullModel )
            {
                if ( gSailpoints[i] !== -2 )
                {
                    for ( var cc=0; cc<4; cc++ ) gBoats[i][cc].visible = false;
                    gSailpoints[i] = -2;
                }
                var hull = gBoatSprites[i];
                hull.visible = true;
                hull.position.x = pos.x;
                hull.position.y = pos.y;
                hull.position.z = gWaterLevel + 0.003;
                hull.rotation.z = -(rec[i].hdm + rec[i].magvar) * kDegToRad;
            }
            else
            {
                if ( gBoatSprites.length > 0 ) gBoatSprites[i].visible = false;

                // Get sailpoint and update ego model visibility
                var sailpoint= kSailpointSbUp;
                if ( rec[i].twa !== 999999 )
                {
                    sailpoint = (rec[i].twa > 110 ? kSailpointSbDn : (rec[i].twa > 0 ? kSailpointSbUp : (rec[i].twa > -110 ? kSailpointPtUp : kSailpointPtDn)));
                }
                if ( gSailpoints[i] !== sailpoint )
                {
                    gBoats[i][kSailpointSbUp].visible = (sailpoint === kSailpointSbUp || (sailpoint === kSailpointSbDn && rec[i].racetime < 0));
                    gBoats[i][kSailpointSbDn].visible = (sailpoint === kSailpointSbDn && rec[i].racetime >= 0);
                    gBoats[i][kSailpointPtUp].visible = (sailpoint === kSailpointPtUp || (sailpoint === kSailpointPtDn && rec[i].racetime < 0));
                    gBoats[i][kSailpointPtDn].visible = (sailpoint === kSailpointPtDn && rec[i].racetime >= 0);
                    gSailpoints[i] = sailpoint;
                }

                // Adjust boat position and orientation
                for ( var cc=0; cc<4; cc++ )
                {
                    gBoats[i][cc].position.x = pos.x;
                    gBoats[i][cc].position.y = pos.y;
                    gBoats[i][cc].position.z = gWaterLevel;
                    gBoats[i][cc].rotation.z = -(rec[i].hdm + rec[i].magvar - 90.0) * kDegToRad;
                }
            }

            // Trail dots only for the boats on models (the top of the standings in a fleet replay):
            // a hull boat's dots are hidden; a boat that climbs into the top gets its trail redrawn
            // from its past positions (the time-jump path below)
            if ( !fullModel )
            {
                if ( gBoatTrails[i] !== null && gBoatTrailShown[i] )
                {
                    for ( var d=0; d<gBoatTrailSize; d++ ) gBoatTrails[i][d].visible = false;
                    gBoatTrailShown[i] = false;
                }
            }
            else
            {
                if ( gBoatTrails[i] === null ) createBoatTrail( i );
                if ( !gBoatTrailShown[i] )
                {
                    for ( var d=0; d<gBoatTrailSize; d++ ) gBoatTrails[i][d].visible = true;
                    gBoatTrailShown[i] = true;
                    gBoatTrailIndex[i].time = -1e9;
                }

                // Check if we jumped in time and reset the trail
                if ( Math.abs( gBoatTrailIndex[i].time - gPlaybackTime ) > 30 )
                {
                    // Sink all dots in the ocean
                    for ( var d=0; d<gBoatTrailSize; d++ )
                    {
                        gBoatTrails[i][d].position.z = -9999;
                    }

                    // Reset dot trail meta data
                    gBoatTrailIndex[i].time = gPlaybackTime;
                    gBoatTrailIndex[i].index = gBoatTrailSize-1;

                    // Redraw dots for current time
                    for ( var d=0; d<gBoatTrailSize-2 && gPlaybackTime > d * gBoatTrailInterval; d++ )
                    {
                        var dTime = gBoatTrailInterval * d;
                        var dotPos = getPastPositionForBoat( dTime, i );
                        var dot = gBoatTrails[i][gBoatTrailIndex[i].index-d];
                        dot.position.x = dotPos.x;
                        dot.position.y = dotPos.y;
                        dot.position.z = gWaterLevel + 0.001;
                    }

                    // Adjust trail to fade at the end
                    for ( var d=0; d<gBoatTrailSize; d++ )
                    {
                        var op = Math.min( 1.0, d / (gBoatTrailSize / 2) );
                        gBoatTrails[i][(gBoatTrailIndex[i].index + d) % gBoatTrailSize].material.opacity = op;
                    }
                }

                // Update boat trail
                if ( gPlaybackTime > (gBoatTrailIndex[i].time + gBoatTrailInterval) )
                {
                    //console.log('Adding DOT at ' + gPlaybackTime);
                    gBoatTrailIndex[i].index++;
                    gBoatTrailIndex[i].index %= gBoatTrailSize;
                    gBoatTrailIndex[i].time = gPlaybackTime;

                    var dot = gBoatTrails[i][gBoatTrailIndex[i].index];
                    dot.position.x = pos.x;
                    dot.position.y = pos.y;
                    dot.position.z = gWaterLevel + 0.001;

                    // Adjust trail to fade at the end
                    for ( var d=0; d<gBoatTrailSize; d++ )
                    {
                        var op = Math.min( 1.0, d / (gBoatTrailSize / 2) );
                        gBoatTrails[i][(gBoatTrailIndex[i].index + d) % gBoatTrailSize].material.opacity = op;
                    }
                }
            }

            // Update boat annotation - since we keep all sailpoint boats in sync we can use index 0 to get the boat's position
            var bname = (raceInfos[i].sailcastName == null
                         ? raceInfos[i].boatName.replace(/\s/g,'').toUpperCase().substring(0,3) : raceInfos[i].sailcastName);
            var stw = parseFloat(rec[i].stw).toFixed( 2 );
            var windDir = parseFloat(rec[i].twa).toFixed(0);
            var annotationHtml = document.getElementById( 'boat-annotation-' + i );
            var callSignColor = colorForBoatIndex(i);
            // A textured hull carries the callsign only - fifty boats' speed and wind would overlay each other
            var html = '<p class="callsign-legend" style="color: ' + callSignColor + '">' + bname + '</p>'
                       + (fullModel ? '<p class="boat-legend">' + (stw === '999999.00' ? '---' : stw + 'kn') + '</p><p class="wind-legend">' + (windDir === '999999' ? '---' : windDir + 'º') + '</p><p class="wind-legend">' + (tws === '999999.0' ? '---' : tws + 'kn') + '</p>' : '');
            if ( gBoatAnnotationHtml[i] !== html )
            {
                annotationHtml.innerHTML = html;
                applyAnnotationStyle( annotationHtml, fullModel );
                gBoatAnnotationHtml[i] = html;
                gBoatAnnotationWidth[i] = annotationHtml.offsetWidth;
            }
            if ( fullModel )
            {
                var viewportPos = getViewportCoordinates( {x: pos.x, y: pos.y, z: gWaterLevel + gBoatAnnotationOffset} );
                annotationHtml.style.bottom = sceneH - viewportPos.y + 'px';
                annotationHtml.style.left = viewportPos.x + 'px';
            }
            else
            {
                // The painted hull's half length on screen, at the hull's current scale, from a second
                // projected point (getViewportCoordinates returns one shared vector - copy before the
                // second call); the callsign's bottom edge sits a couple of pixels above the bow
                var halfLen = gSimpleBoatHalfSide * kSimpleBoatTextureFill * gBoatSprites[i].scale.x;
                var c = getViewportCoordinates( {x: pos.x, y: pos.y, z: gWaterLevel + 0.003} );
                var cx = c.x, cy = c.y;
                var e = getViewportCoordinates( {x: pos.x, y: pos.y + halfLen, z: gWaterLevel + 0.003} );
                var halfPx = Math.sqrt( (e.x - cx) * (e.x - cx) + (e.y - cy) * (e.y - cy) );
                annotationHtml.style.bottom = sceneH - (cy - halfPx - 2) + 'px';
                annotationHtml.style.left = (cx - (gBoatAnnotationWidth[i] || 0) / 2) + 'px';
            }

            // Update start timer. A cruising trip has no gun, so the countdown /
            // leg counter is suppressed entirely (see Design/CRUISING_IMPL.md).
            if ( i === 0 && !(typeof isCruiser !== "undefined" && isCruiser) )
            {
                if ( gRaceTimer !== rec[i].racetime )
                {
                    var timerDiv = document.getElementById('scene-start-timer');
                    var timer = document.getElementById('start-timer');

                    if ( rec[i].racetime <= 0 )
                    {
                        var min = Math.floor(Math.abs(rec[i].racetime / 60));
                        var sec = Math.abs(rec[i].racetime % 60);
                        timer.innerHTML = min.toFixed(0).toString().padStart(2, '0') + ':' + sec.toString().padStart(2, '0');
                        timer.style.width = '60px';
                        timerDiv.style.left = $('#scene').width() / 2 - 30 + 'px';
                    }
                    else if ( gLegs.length > 1 )
                    {
                        var leadBoatIdx = (gLeaderBoard !== null && gLeaderBoard.length > 0 ? gLeaderBoard[0].idx : 0);
                        timer.innerHTML = 'LEG ' + (rec[leadBoatIdx].legIdx + 1) + '/' + gLegs.length;
                        if ( gLegs.length < 10 )
                        {
                            timer.style.width = '80px';
                            timerDiv.style.left = $('#scene').width() / 2 - 40 + 'px';
                        }
                        else
                        {
                            timer.style.width = '100px';
                            timerDiv.style.left = $('#scene').width() / 2 - 50 + 'px';
                        }
                    }
                    else
                    {
                        timerDiv.style.left = '9999px';
                    }
                    gRaceTimer = rec[i].racetime;
                }
            }
        }
    }

    if ( water !== null )
    {
        var xFlow = -Math.sin(gTwd * kDegToRad);
        var yFlow = Math.cos(gTwd * kDegToRad);
        var flowDirection = new THREE.Vector2(xFlow, yFlow);
        water.material.uniforms["flowDirection"] = {
            type: 'v2',
            value: flowDirection
        };
    }
}

function renderMarkAnnotations()
{
    if ( gMarkAnnotations == null ) return;

    // Beacon marks nobody rounded (addBeaconMarks)
    if ( gBeaconMarkExtras !== null )
    {
        for ( var e=0; e<gBeaconMarkExtras.length; e++ )
        {
            var ex = gBeaconMarkExtras[e];
            var exPos = getViewportCoordinates({x: ex.cone.position.x, y: ex.cone.position.y, z: ex.z + gMarkAnnotationOffset});
            ex.div.style.top = exPos.y + 'px';
            ex.div.style.left = exPos.x + 'px';
        }
    }

    // Mark names
    for ( var i=0; i<gMarkAnnotations.length; i++ )
    {
        var annotation = document.getElementById('mark-annotation-' + i);
        if ( annotation !== null )
        {
            if ( gMarkAnnotations[i].visible )
            {
                var viewportPos = getViewportCoordinates({x: gMarkAnnotations[i].x, y: gMarkAnnotations[i].y, z: gMarkAnnotations[i].z + gMarkAnnotationOffset});
                annotation.style.top = viewportPos.y + 'px';
                annotation.style.left = viewportPos.x + 'px';
            }
            else
            {
                annotation.style.display = "none";
            }
        }
    }

    // Starting line (only during pre-start)
    if ( gRaceTimer < 0 )
    {
        if ( gStartingLine == null )
        {
            // First render
            var geometry = new THREE.Geometry();
            var boat = translate( raceInfos[0].startBoatLat, raceInfos[0].startBoatLon );
            var pin = translate( raceInfos[0].startPinLat, raceInfos[0].startPinLon );
            geometry.vertices.push(new THREE.Vector3( boat.x, boat.y, gCourseLevel) );
            geometry.vertices.push(new THREE.Vector3( pin.x, pin.y, gCourseLevel) );
            gStartingLine = new THREE.Line( geometry, gStartingLineMaterialPre );
            gStartingLine.name = 'START';

            gScene.add( gStartingLine );
        }
        else
        {
            gStartingLine.material = gStartingLineMaterialPre;
        }
    }
    else if ( gRaceTimer <= 10 )
    {
        if ( gStartingLine == null )
        {
            // First render
            var geometry = new THREE.Geometry();
            var boat = translate( raceInfos[0].startBoatLat, raceInfos[0].startBoatLon );
            var pin = translate( raceInfos[0].startPinLat, raceInfos[0].startPinLon );
            geometry.vertices.push(new THREE.Vector3( boat.x, boat.y, gCourseLevel) );
            geometry.vertices.push(new THREE.Vector3( pin.x, pin.y, gCourseLevel) );
            gStartingLine = new THREE.Line( geometry, gStartingLineMaterialPost );
            gStartingLine.name = 'START';

            gScene.add( gStartingLine );
        }
        else
        {
            gStartingLine.material = gStartingLineMaterialPost;
        }
    }
    else
    {
        gScene.remove( gStartingLine );
        gStartingLine = null;
    }
}

function renderWindLines( nextMarkIdx )
{
    // Step 1: Get the next mark's position
    var lat = 0, lon = 0, pLat = 0, pLon = 0, nextIdx = -1, prevIdx = (nextMarkIdx > 0 ? nextMarkIdx - 1 : -1);

    if ( nextMarkIdx >= raceInfos[gSelectedBoatIndex].loggedMarkList.length )
    {
        // Remove any existing laylines and ladder lines
        if ( gLaylines !== null )
        {
            gScene.remove( gLaylines );
            gLaylines = null;
        }
        if ( gLadderLines !== null && gLadderLines.length > 0 )
        {
            for ( var ll=0; ll<gLadderLines.length; ll++ )
            {
                gScene.remove( gLadderLines[ll] );
            }
            gLadderLines = null;
        }

        return;
    }

    lat = raceInfos[gSelectedBoatIndex].loggedMarkList[nextMarkIdx].lat;
    lon = raceInfos[gSelectedBoatIndex].loggedMarkList[nextMarkIdx].lon;
    gNextMarkHDT = raceInfos[gSelectedBoatIndex].loggedMarkList[nextMarkIdx].xhdt;

    if ( prevIdx === -1 )
    {
        // Use the start position for the beginning of the first leg
        pLat = gMarks[0].lat;
        pLon = gMarks[0].lon;
    }
    else
    {
        pLat = raceInfos[gSelectedBoatIndex].loggedMarkList[prevIdx].lat;
        pLon = raceInfos[gSelectedBoatIndex].loggedMarkList[prevIdx].lon;
    }

    if ( lat === 0 || lon === 0 || pLat === 0 || pLon === 0 )
    {
        return;
    }

    var mpos = translate( lat, lon );
    var prevMpos = translate( pLat, pLon );

    // Remove the trackline if we changed marks
    if ( gTrackLineMark !== gXName )
    {
        if ( gTrackline !== null )
        {
            gScene.remove( gTrackline );
            gTrackline = null;
        }

        gTrackLineMark = gXName;
    }

    if ( gTwaTgtPointOfSail === kNextMarkIsReaching )
    {
        // Remove any existing laylines and ladder lines
        if ( gLaylines !== null )
        {
            gScene.remove( gLaylines );
            gLaylines = null;
        }
        if ( gLadderLines !== null && gLadderLines.length > 0 )
        {
            for ( var ll=0; ll<gLadderLines.length; ll++ )
            {
                gScene.remove( gLadderLines[ll] );
            }
            gLadderLines = new Array();
        }

        if ( prevMpos !== null && gTrackline === null )
        {
            var tgeometry = new THREE.Geometry();
            tgeometry.vertices.push(new THREE.Vector3(prevMpos.x, prevMpos.y, gCourseLevel));
            tgeometry.vertices.push(new THREE.Vector3(mpos.x, mpos.y, gCourseLevel));
            gTrackline = new THREE.Line(tgeometry, gTracklineMaterial);
            gTrackline.name = 'TRACK LINE';
            gTrackline.computeLineDistances();

            gScene.add( gTrackline );
        }

        return;
    }
    else
    {
        // Remove any reaching leg graph
        if ( gTrackline !== null )
        {
            gScene.remove( gTrackline );
            gTrackline = null;
        }
    }

    // Step 2: Render ladder lines
    var sbx, sby, ptx, pty;
    var upAvg = (gTwaTgtUpAvg.avg === 999999 ? gTwaTgtUp : gTwaTgtUpAvg.avg);
    var downAvg = (gTwaTgtDownAvg.avg === 999999 ? gTwaTgtDown : gTwaTgtDownAvg.avg);
    for ( var j=0; j<10; j++ )
    {
        if ( gTwaTgtPointOfSail === kNextMarkIsUpwind)
        {
            sbx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * j;
            sby = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * j;
            ptx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * j;
            pty = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * j;
        }
        else if ( gTwaTgtPointOfSail === kNextMarkIsDownwind )
        {
            // Use a downwind TWA of 145 so the ladder lines don't collapse too far
            sbx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - 145) * kDegToRad) * j;
            sby = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - 145) * kDegToRad) * j;
            ptx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - 145) * kDegToRad) * j;
            pty = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - 145) * kDegToRad) * j;
        }

        if ( gLadderLines === null ) gLadderLines = [];

        if ( gLadderLines.length < 10 )
        {
            // First render
            var geometry = new THREE.Geometry();
            geometry.vertices.push(new THREE.Vector3( sbx, sby, gLaylineLevel) );
            geometry.vertices.push(new THREE.Vector3( ptx, pty, gLaylineLevel) );
            gLadderLines.push( new THREE.Line( geometry, gLadderLinesMaterial ) );
            gLadderLines.name = 'LADDER LINES';

            gScene.add( gLadderLines[j] );
        }
        else
        {
            // Just update the existing lines
            gLadderLines[j].geometry.vertices[ 0 ].x = sbx;
            gLadderLines[j].geometry.vertices[ 0 ].y = sby;
            gLadderLines[j].geometry.vertices[ 1 ].x = ptx;
            gLadderLines[j].geometry.vertices[ 1 ].y = pty;
            gLadderLines[j].geometry.verticesNeedUpdate = true;
        }
    }

    // Step 3: Calculate vertices for laylines
    if ( gTwaTgtPointOfSail === kNextMarkIsUpwind)
    {
        sbx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
        sby = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
        ptx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
        pty = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
    }
    else if ( gTwaTgtPointOfSail === kNextMarkIsDownwind )
    {
        sbx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
        sby = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
        ptx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
        pty = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
    }

    // Step 4: Draw laylines
    if ( gLaylines == null )
    {
        var lgeometry = new THREE.Geometry();
        lgeometry.vertices.push(new THREE.Vector3(sbx, sby, gLaylineLevel));
        lgeometry.vertices.push(new THREE.Vector3(mpos.x, mpos.y, gLaylineLevel));
        lgeometry.vertices.push(new THREE.Vector3(ptx, pty, gLaylineLevel));
        gLaylines = new THREE.Line(lgeometry, gLaylineMaterial);
        gLaylines.name = 'LAYLINES';

        gScene.add(gLaylines);
    }
    else
    {
        gLaylines.geometry.vertices[ 0 ].x = sbx;
        gLaylines.geometry.vertices[ 0 ].y = sby;
        gLaylines.geometry.vertices[ 1 ].x = mpos.x;
        gLaylines.geometry.vertices[ 1 ].y = mpos.y;
        gLaylines.geometry.vertices[ 2 ].x = ptx;
        gLaylines.geometry.vertices[ 2 ].y = pty;
        gLaylines.geometry.verticesNeedUpdate = true;
    }
}

/* ==============================================================
   RECORD ACCESS
   ============================================================== */
var logCnt = 0;

function getRecordsAtCurrentPlaybackTime()
{
    var rec = new Array();
    var markIdx = 0;

    // Check if the playback index needs advancing
    if ( gPlaybackIndex >= gNumRecords-1 )
    {
        gPlaybackIndex = 0;
        gPlaybackTime = 0.0;
    }

    // N boats logging at N sub-second phases put N rows into every race second, more than one
    // frame can step through at 10x or in a big fleet - catch up with the playback time
    while ( gPlaybackIndex < gNumRecords-1 && gPlaybackTime >= (gRecords[gPlaybackIndex+1][0].rtime / 100.0 - gRaceStartTime) )
    {
        gPlaybackIndex++;
    }

    mvutils_avg360_reset( gTwdAvg );

    // Assemble the array of data points for each boat
    for (var i = 0; i < numBoats; i++)
    {
        var subRec = getRecordAtTimeForBoat( gPlaybackTime, i );

        rec.push(subRec);

        mvutils_avg360_add( gHdmAvgPerBoat[i], subRec.hdm );

        // Adjust target angles and point of sail based on fixed 50º / 135º angles
        if ( i === gSelectedBoatIndex )
        {
            mvutils_avg360_add( gTwdAvg, (subRec.dampTwd !== 999999 ? subRec.dampTwd : gTwdAvg.avg) );
            gTwaTgt = Math.abs( subRec.twaTgt );
            if ( gTwaTgt < 35 )
            {
                //console.log('ooo');
            }
            markIdx = subRec.legIdx;

            if ( gLegs !== null && gLegs.length > 0 && rec[i].legIdx !== undefined && rec[i].legIdx < gLegs.length )
            {
                legHdm = gLegs[rec[i].legIdx].legHdm;

                if ( Math.abs(mvutils_substract360(subRec.dampTwd, legHdm - subRec.magvar)) > 135 )
                {
                    gTwaTgtPointOfSail = kNextMarkIsDownwind;
                }
                else if ( Math.abs(mvutils_substract360(subRec.dampTwd, legHdm - subRec.magvar)) < 50 )
                {
                    gTwaTgtPointOfSail = kNextMarkIsUpwind;
                }
                else
                {
                    gTwaTgtPointOfSail = kNextMarkIsReaching;
                }
            }
            else
            {
                // We have no legs (i.e. no course)
                gTwaTgtPointOfSail = kNextMarkIsReaching;
            }

            if ( Math.abs( gTwaTgt ) < 90 )
            {
                if ( gTwaTgt < 35 )
                {
                    //console.log('ooo');
                }
                gTwaTgtUp = (gTwaTgt !== 999999 ? gTwaTgt : kTwaTgtUp);
                mvutils_avg360_add( gTwaTgtUpAvg, gTwaTgtUp );
            }
            else
            {
                gTwaTgtDown = (gTwaTgt !== 999999 ? gTwaTgt : kTwaTgtDown);
                mvutils_avg360_add( gTwaTgtDownAvg, gTwaTgtDown );
            }
        }

        if ( logCnt++ == 0 )
        {
            //console.log('Boat ' + subRec.boat_id + ' | TWD = ' + gTwd + ' | xMark = ' + gXName + ' | xHdm = ' + subRec.xHdm + ' | ' + (gTwaTgtPointOfSail ? 'up' : 'down') );
        }
        logCnt %= 30;
    }

    mvutils_avg360_add( gTwdDisplayAvg, gTwdAvg.avg );
    mvutils_avg360_add( gTwdCameraAvg, gTwdAvg.avg );
    gTwd = gTwdDisplayAvg.avg;

    windIndicatorUpdate();

    return { recList: rec, nextMarkIdx: markIdx };
}

/**
 * The two real records of a boat around a playback time (Design/SAILCAST.md "Record grid and boat
 * interpolation"): rec1 the last fix at or before playtime, rec2 the next one, f the fraction of the
 * way from rec1 to rec2. The padding entries of gRecords are never used - they hold the last position
 * at another boat's timestamp, so a boat interpolated through them stands still for most of a second
 * and then jumps. Past the boat's last fix, or across a gap above kFixMaxInterpolationGap, rec1 is
 * held (f = 0). Returns null before the boat's first fix.
 */
function boatFixBracket( boatIdx, playtime )
{
    var fixes = gBoatFixes[boatIdx];
    if ( fixes === undefined || fixes.times.length === 0 || playtime < fixes.times[0] ) return null;

    // Binary search for the last fix at or before playtime
    var lo = 0;
    var hi = fixes.times.length - 1;
    while ( lo < hi )
    {
        var mid = (lo + hi + 1) >> 1;
        if ( fixes.times[mid] <= playtime ) lo = mid;
        else hi = mid - 1;
    }

    var rec1 = gRecords[fixes.rows[lo]][boatIdx];
    if ( lo + 1 >= fixes.times.length || fixes.times[lo+1] - fixes.times[lo] > kFixMaxInterpolationGap )
    {
        return { rec1: rec1, rec2: rec1, f: 0 };
    }

    var f = (playtime - fixes.times[lo]) / (fixes.times[lo+1] - fixes.times[lo]);
    return { rec1: rec1, rec2: gRecords[fixes.rows[lo+1]][boatIdx], f: f };
}

function getRecordAtTimeForBoat( playtime, boatIdx )
{
    var interpolatedRec = null;
    var bracket = boatFixBracket( boatIdx, playtime );

    // Interpolate between this boat's own records around the playtime
    if ( bracket !== null )
    {
        var rec1 = bracket.rec1;
        var rec2 = bracket.rec2;
        var f = bracket.f;

        // Use rec1 as a baseline - make a copy so we don't change the original data!
        interpolatedRec = {};
        interpolatedRec.boat_id = rec1.boat_id;
        interpolatedRec.race_id = rec1.race_id;
        interpolatedRec.lat = rec1.lat;
        interpolatedRec.lon = rec1.lon;
        interpolatedRec.racetime = rec1.racetime;
        interpolatedRec.rcount = rec1.rcount;
        interpolatedRec.rtime = rec1.rtime;
        interpolatedRec.stw = rec1.stw;
        interpolatedRec.vmg = rec1.vmg;
        interpolatedRec.vmc = rec1.vmc;
        interpolatedRec.twa = rec1.twa;
        interpolatedRec.tws = rec1.tws;
        interpolatedRec.twaTgt = rec1.twaTgt;
        interpolatedRec.heel = rec1.heel;
        interpolatedRec.magvar = rec1.magvar;
        interpolatedRec.legIdx = rec1.legIdx;
        interpolatedRec.xName = rec1.xName;
        interpolatedRec.xHdm = rec1.xHdm;
        interpolatedRec.xDist = rec1.xDist;

        interpolatedRec.lat += (rec2.lat - rec1.lat) * f;
        interpolatedRec.lon += (rec2.lon - rec1.lon) * f;
        interpolatedRec.hdm = mvutils_add360(rec1.hdm,
            mvutils_substract360(rec2.hdm, rec1.hdm) * f);
        interpolatedRec.dampTwd = mvutils_add360(rec1.dampTwd,
            mvutils_substract360(rec2.dampTwd, rec1.dampTwd) * f);

        // Interpolate TWA targets only while they are both up- or downwind
        if ( rec1.twaTgt !== 999999 && rec2.twaTgt !== 999999 && Math.abs( rec1.twaTgt - rec2.twaTgt ) < 45 )
        {
            interpolatedRec.twaTgt = mvutils_add360(rec1.twaTgt,
                mvutils_substract360(rec2.twaTgt, rec1.twaTgt) * f);
        }
        else
        {
            interpolatedRec.twaTgt = rec1.twaTgt;
        }
    }
    else
    {
        // Before the boat's first fix: not placed, on the first leg (renderWindLines needs a leg
        // index when this is the selected boat - the frame of the loop restart)
        interpolatedRec = { boat_id: raceInfos[boatIdx].boatId, race_id: gBoatIdList[boatIdx], lat: 0, lon: 0, legIdx: 0 };
    }

    return interpolatedRec;
}

/**
 * The scene position of a boat 'delay' seconds before the playback time, between its own fixes
 * (boatFixBracket) - the chase camera and the trail redraw after a time jump. Before the boat's
 * first fix its first position.
 */
function getPastPositionForBoat( delay, boatIdx )
{
    var bracket = boatFixBracket( boatIdx, gPlaybackTime - delay );
    if ( bracket === null )
    {
        var fixes = gBoatFixes[boatIdx];
        if ( fixes === undefined || fixes.rows.length === 0 ) return translate( 0, 0 );
        var first = gRecords[fixes.rows[0]][boatIdx];
        return translate( first.lat, first.lon );
    }

    return translate( bracket.rec1.lat + (bracket.rec2.lat - bracket.rec1.lat) * bracket.f,
        bracket.rec1.lon + (bracket.rec2.lon - bracket.rec1.lon) * bracket.f );
}

/* ==============================================================
   SCENE CREATION
   ============================================================== */
function loadScene()
{
    var sceneElement = document.getElementById('scene-canvas');

    gScene = new THREE.Scene();
    //scene.background = new THREE.Color( 0x2020a0 );

    gCamera = new THREE.PerspectiveCamera( 30, sceneElement.scrollWidth / sceneElement.scrollHeight, 0.1, 100 );

    //loadOcean( gScene );

    loadSky( gScene );

    // Create boats
    gBoats = new Array();
    gSailpoints = new Array();
    gEgoModel = new Array();
    gBoatTrails = new Array();
    gBoatTrailIndex = new Array();
    gBoatTrailShown = [];
    gBoatAnnotations = new Array();
    gBoatSprites = [];
    gBoatFullModel = [];
    gBoatRank = [];
    gBoatAnnotationHtml = [];

    // Step 1: the boat models. Every model file is loaded ONCE (the two upwind hulls, a downwind
    // hull per spinnaker colour) and cloned per boat - geometry and materials are shared, so a
    // fleet of 60 costs eight Collada parses instead of 240 (Design/TRACKER_RC.md, SailCast replay)
    var sharedModels = {};
    var sharedKeys = [];
    var boatColor = function ( idx ) { return (idx % 3 === 0 ? 'yw' : (idx % 3 === 1 ? 'rd' : 'be')); };
    var modelFile = function ( sp, color )
    {
        return (sp === kSailpointSbUp ? '/dae/ego-boat-sb-up.dae' : (sp === kSailpointSbDn ? '/dae/ego-boat-sb-dn-' + color + '.dae'
                : (sp === kSailpointPtUp ? '/dae/ego-boat-pt-up.dae' : '/dae/ego-boat-pt-dn-' + color + '.dae')));
    };
    var modelKey = function ( sp, color ) { return (sp === kSailpointSbUp || sp === kSailpointPtUp ? 'sp' + sp : 'sp' + sp + '-' + color); };
    var loadingManager = new THREE.LoadingManager(function () {
        // Every model file is in: the four sailpoints of each boat are clones of the shared models
        for ( var b=0; b<numBoats; b++ )
        {
            var thisBoat = new Array(4);
            gEgoModel[b] = new Array(4);
            for ( var sp=0; sp<4; sp++ )
            {
                var model = sharedModels[modelKey( sp, boatColor( b ) )].clone();
                // A start group: the hull in the fleet's colour (the spinnaker colour stays per boat)
                applyFleetHullTint( model, fleetIndexOfBoat( b ) );
                model.sailpoint = sp;
                model.scale.set(kEgoFullSizeFactor, kEgoFullSizeFactor, kEgoFullSizeFactor);
                model.position.x = 0.0;
                model.rotation.x = 0.0;
                model.rotation.y = 0.0;
                gEgoModel[b][sp] = model;

                // Create a pivot point for the boat so we turn around the center
                var pivot = new THREE.Object3D();
                pivot.add(model);
                pivot.scale.set(kEgoScaleBev, kEgoScaleBev, kEgoScaleBev);
                pivot.name = 'BOAT ' + b;
                thisBoat[sp] = pivot;
                gScene.add(pivot);
                pivot.visible = false;
            }
            gBoats.push(thisBoat);
        }
        createSimpleBoats();
        gAllElementsLoaded = true;
    });
    if ( !gOverviewMode )
    {
        for ( var c=0; c<Math.min( numBoats, 3 ); c++ )
        {
            for ( var sp=0; sp<4; sp++ )
            {
                var key = modelKey( sp, boatColor( c ) );
                if ( sharedKeys.indexOf( key ) >= 0 ) continue;
                sharedKeys.push( key );
                var colladaLoader = new THREE.ColladaLoader(loadingManager);
                colladaLoader.load(gDaePrefix + modelFile( sp, boatColor( c ) ), sp, key, function( collada, sp, key ) {
                    sharedModels[key] = collada.scene;
                });
            }
        }
    }

    for (var i = 0; i < numBoats; i++)
    {
        gSailpoints.push( -1 );
        gHdmAvgPerBoat.push( mvutils_avg360_init( gHdmDampTime ));
        gBoatFullModel.push( true );
        gBoatRank.push( i );
        gBoatAnnotationHtml.push( '' );

        // The overview never shows a boat model: stand-in pivots instead of the models
        if ( gOverviewMode )
        {
            var stubBoat = new Array(4);
            for ( var sp=0; sp<4; sp++ )
            {
                var stub = new THREE.Object3D();
                stub.name = 'BOAT ' + i;
                stub.visible = false;
                gScene.add( stub );
                stubBoat[sp] = stub;
            }
            gBoats.push( stubBoat );
            gEgoModel[i] = [ 1, 1, 1, 1 ];
        }

        // Step 2: the trail dots come on demand (createBoatTrail) - only the boats on models trail,
        // a fleet of 60 would otherwise start with 6,000 dot meshes
        gBoatTrails.push( null );
        gBoatTrailIndex.push( {index: 0, time: 0} );
        gBoatTrailShown.push( false );

        // Step 3: Create boat annotation DIVs
        var annotationDiv = document.createElement('div');
        annotationDiv.id = 'boat-annotation-' + i;
        annotationDiv.style.position = 'absolute';
        annotationDiv.style.width = 100;
        //annotationDiv.style.height = 75;
        annotationDiv.style.borderLeftStyle = 'solid';
        annotationDiv.style.borderLeftColor = '#FFF';
        annotationDiv.style.borderLeftWidth = '1.5px';
        annotationDiv.style.paddingLeft = '5px';
        annotationDiv.style.bottom = 0 + 'px';
        annotationDiv.style.left = 0 + 'px';
        annotationDiv.style.color = '#FFF';
        annotationDiv.style.textShadow = '0 0 5px rgba(0, 0, 0, 0.8)';
        annotationDiv.lineHeight = '14px';
        annotationDiv.whiteSpace = 'pre-line';
        annotationDiv.classList.add('boat-annotation-group');
        document.getElementById('scene').appendChild( annotationDiv );
    }
    gBoatAnnotationFullHeight = 60;
    applyAnnotationStyles();
    if ( gOverviewMode ) gAllElementsLoaded = true;

    gCamera.position.set( 0, -gCameraPlaneLateralDistance, gCameraPlaneVerticalDistance );
    gCamera.up = new THREE.Vector3(0,0,1);
    gCamera.lookAt( new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset) );

    var ambientLight = new THREE.AmbientLight( 0xcccccc, 0.6 );
    gScene.add( ambientLight );

    var directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
    directionalLight.position.set( -1, 1, 10 );
    gScene.add( directionalLight );

    gRenderer = new THREE.WebGLRenderer( { antialias: true } );
    gRenderer.setSize( sceneElement.scrollWidth, sceneElement.scrollHeight );
    sceneElement.appendChild( gRenderer.domElement );

    document.getElementById('scene-controls').style.opacity = 1.0;
    document.getElementById('scene-boat-legend').style.opacity = 1.0;

    var controls = new THREE.OrbitControls( gCamera, gRenderer.domElement );
    controls.enabled = false;

    gCamera.lookAt( new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset) );
}

function loadGmaps()
{
    if ( !googleMapsLoaded )
    {
        console.log("Creating new map");
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('defer', true);
        script.setAttribute('async', true);
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKXXgVQl9FU0D3yVGZ8QOd4X5R1Xw0y0&callback=initMap';
        document.body.appendChild(script);
        googleMapsLoaded = true;
    }
    else
    {
        console.log("Initializing map");
        //initMap();
    }
}

function initMap()
{
    // Nothing to do for sailcast, we just want the gmaps lib loaded
}

function loadGeoMap( ctrLat, ctrLon, zoom, latFrac, lonFrac, demo )
{
    // Load gmaps satellite overlay as surface texture and terrain map w/o labels as water area mask
    var waterThreshold = 0.85;
    //var mapSrc = 'https://maps.googleapis.com/maps/api/staticmap?size=600x600&center=' + ctrLat.toFixed(6) + '%2C' + ctrLon.toFixed(6) + '&zoom=' + zoom + '&maptype=satellite&format=jpg&scale=2&key=' + kGmapsKey;
    //var flowMaskSrc = site.uri.public + '/api/sailcast' + (rShareToken === '' ? '' : '-shared') + '/flow-map?lat=' + ctrLat.toFixed(6) + '&lon=' + ctrLon.toFixed(6) + '&zoom=' + zoom + '&ts=' + waterThreshold + (rShareToken === '' ? '' : '&tk=' + rShareToken);
    var mapSrc = site.uri.public + '/api/sailcast' + (gCaptureToken !== '' ? '-capture' : (rShareToken === '' ? '' : '-shared')) + '/geo-map?lat=' + ctrLat.toFixed(6) + '&lon=' + ctrLon.toFixed(6) + '&zoom=' + zoom + '&ts=' + waterThreshold
                 + (gCaptureToken !== '' ? '&race=' + captureRaceIdList() + '&ct=' + gCaptureToken : (rShareToken === '' ? '' : '&tk=' + rShareToken));

    if ( demo )
    {
        // The demo is a W/L on the ocean, don't waste time looking for the map
        gGeoTexturesLoaded = true;
    }
    else
    {
        loadGeoSurface(gScene, mapSrc, latFrac, lonFrac);
    }

    //loadOcean( gScene, mapSrc, flowMaskSrc );
    loadOceanSurface( gScene );
    loadWaterSurface( gScene );
    loadWindIndicator( gScene );
    loadWindSpeedInd( gScene );
}

/**
 * WebGL Vertex Shader for water mask processing
 * Maps texture coordinates from satellite and terrain images
 */
var waterMaskVertexShader =
"    varying vec2 vUv;\n" +
"    void main() {\n" +
"        vUv = uv;\n" +
"        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n" +
"    }";

/**
 * WebGL Fragment Shader for water mask processing
 * Identifies water pixels from terrain map using three color criteria and replaces them
 * in the satellite image with a unified water color
 */
var waterMaskFragmentShader =
"    precision highp float;\n" +
"\n" +
"    uniform sampler2D satTexture;\n" +
"    uniform sampler2D terrainTexture;\n" +
"    uniform vec4 waterColor;\n" +
"    varying vec2 vUv;\n" +
"\n" +
"    void main() {\n" +
"        vec4 terrainPixel = texture2D(terrainTexture, vUv);\n" +
"        vec4 satPixel = texture2D(satTexture, vUv);\n" +
"\n" +
"        // Convert to 0-255 range for comparison\n" +
"        float r = terrainPixel.r * 255.0;\n" +
"        float g = terrainPixel.g * 255.0;\n" +
"        float b = terrainPixel.b * 255.0;\n" +
"\n" +
"        // Check three water color conditions from PHP implementation:\n" +
"        // 1. Old terrain map water color: RGB(156, 192, 249)\n" +
"        bool isOldWater = (abs(r - 156.0) < 0.5 && abs(g - 192.0) < 0.5 && abs(b - 249.0) < 0.5);\n" +
"\n" +
"        // 2. Current terrain map water color: R[140-164], G[212-220], B[232-240]\n" +
"        bool isCurrentWater = (r >= 140.0 && r <= 164.0 && g >= 212.0 && g <= 220.0 && b >= 232.0 && b <= 240.0);\n" +
"\n" +
"        // 3. Current terrain map ferry connections: R[78-138], G[190-216], B[220-240]\n" +
"        bool isFerry = (r >= 78.0 && r <= 138.0 && g >= 190.0 && g <= 216.0 && b >= 220.0 && b <= 240.0);\n" +
"\n" +
"        // If any water condition matches, use water color, otherwise use satellite pixel\n" +
"        if (isOldWater || isCurrentWater || isFerry) {\n" +
"            gl_FragColor = waterColor;\n" +
"        } else {\n" +
"            gl_FragColor = satPixel;\n" +
"        }\n" +
"    }";

/**
 * Applies water mask to a satellite image using WebGL shader processing
 * Identifies water pixels in the terrain image and replaces them with a unified color
 * in the satellite image
 *
 * @param {HTMLImageElement} satImage - Satellite image
 * @param {HTMLImageElement} terrainImage - Terrain map image for water detection
 * @param {number} width - Image width in pixels
 * @param {number} height - Image height in pixels
 * @returns {HTMLCanvasElement} Canvas containing processed image with water pixels replaced
 */
function applyWaterMaskWebGL(satImage, terrainImage, width, height) {
    // Create off-screen WebGL renderer
    var renderer = new THREE.WebGLRenderer({
        preserveDrawingBuffer: true,
        antialias: false,
        alpha: true
    });
    renderer.setSize(width, height);

    // Create scene and orthographic camera for 2D rendering
    var scene = new THREE.Scene();
    var camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);

    // Create textures from images
    var satTexture = new THREE.Texture(satImage);
    satTexture.needsUpdate = true;
    satTexture.minFilter = THREE.NearestFilter;
    satTexture.magFilter = THREE.NearestFilter;

    var terrainTexture = new THREE.Texture(terrainImage);
    terrainTexture.needsUpdate = true;
    terrainTexture.minFilter = THREE.NearestFilter;
    terrainTexture.magFilter = THREE.NearestFilter;

    // Create shader material with water detection logic
    // Water color: RGBA(18, 56, 83, 127) - semi-transparent dark blue
    var material = new THREE.ShaderMaterial({
        uniforms: {
            satTexture: { value: satTexture },
            terrainTexture: { value: terrainTexture },
            waterColor: { value: new THREE.Vector4(18.0/255.0, 56.0/255.0, 83.0/255.0, 127.0/255.0) }
        },
        vertexShader: waterMaskVertexShader,
        fragmentShader: waterMaskFragmentShader,
        transparent: true
    });

    // Create full-screen quad and render
    var geometry = new THREE.PlaneGeometry(2, 2);
    var mesh = new THREE.Mesh(geometry, material);
    scene.add(mesh);

    renderer.render(scene, camera);

    // Extract result as canvas
    var canvas = renderer.domElement;

    // Cleanup GPU resources
    geometry.dispose();
    material.dispose();
    satTexture.dispose();
    terrainTexture.dispose();
    renderer.dispose();

    return canvas;
}

/**
 * Canvas 2D fallback for water mask processing (used if WebGL is unavailable)
 * Slower but more compatible implementation
 *
 * @param {HTMLImageElement} satImage - Satellite image
 * @param {HTMLImageElement} terrainImage - Terrain map image for water detection
 * @param {number} width - Image width in pixels
 * @param {number} height - Image height in pixels
 * @returns {HTMLCanvasElement} Canvas containing processed image with water pixels replaced
 */
function applyWaterMaskCanvas(satImage, terrainImage, width, height) {
    // Create temporary canvases for processing
    var satCanvas = document.createElement('canvas');
    satCanvas.width = width;
    satCanvas.height = height;
    var satCtx = satCanvas.getContext('2d');
    satCtx.drawImage(satImage, 0, 0);

    var terrainCanvas = document.createElement('canvas');
    terrainCanvas.width = width;
    terrainCanvas.height = height;
    var terrainCtx = terrainCanvas.getContext('2d');
    terrainCtx.drawImage(terrainImage, 0, 0);

    // Get pixel data
    var satImageData = satCtx.getImageData(0, 0, width, height);
    var terrainImageData = terrainCtx.getImageData(0, 0, width, height);
    var satPixels = satImageData.data;
    var terrainPixels = terrainImageData.data;

    // Water color: RGBA(18, 56, 83, 127)
    var waterColor = {r: 18, g: 56, b: 83, a: 127};

    // Iterate through each pixel (4 bytes per pixel: RGBA)
    for (var i = 0; i < terrainPixels.length; i += 4) {
        var r = terrainPixels[i];
        var g = terrainPixels[i + 1];
        var b = terrainPixels[i + 2];

        // Check if pixel matches any water criteria
        var isOldWater = (r === 156 && g === 192 && b === 249);
        var isCurrentWater = (r >= 140 && r <= 164 && g >= 212 && g <= 220 && b >= 232 && b <= 240);
        var isFerry = (r >= 78 && r <= 138 && g >= 190 && g <= 216 && b >= 220 && b <= 240);

        if (isOldWater || isCurrentWater || isFerry) {
            // Replace in satellite image
            satPixels[i] = waterColor.r;
            satPixels[i + 1] = waterColor.g;
            satPixels[i + 2] = waterColor.b;
            satPixels[i + 3] = waterColor.a;
        }
    }

    // Put modified data back to canvas
    satCtx.putImageData(satImageData, 0, 0);

    return satCanvas;
}

function loadGeoSurface( scene, mapUrl, latFrac, lonFrac )
{
    if ( mapUrl === undefined || mapUrl == null )
    {
        return;
    }

    // Create geometry with 512x512 segments for high-resolution elevation data
    var geoGeometry = new THREE.PlaneBufferGeometry( kOceanSize, kOceanSize, kOceanResolution, kOceanResolution );
    var geoMaterial = new THREE.MeshStandardMaterial( { roughness: 0.0, metalness: 0.0 } );
    var geoMesh = new THREE.Mesh( geoGeometry, geoMaterial );
    geoMesh.position.z = gGeoOverlayLevel;
    geoMesh.name = 'MAP';

    $('#loading-data-alert').text(tqTranslate('JS.LOADING_TERRAIN'));

    // Fetch the multipart response containing image and elevation data
    fetch(mapUrl)
        .then(function(response) {
            if (!response.ok) {
                throw new Error('Failed to load geo map: ' + response.status);
            }
            return response.arrayBuffer();
        })
        .then(function(arrayBuffer) {
            // Parse the multipart response as binary data
            var bytes = new Uint8Array(arrayBuffer);

            // Convert the beginning to text to find the boundary
            var headerText = '';
            for (var i = 0; i < Math.min(200, bytes.length); i++) {
                headerText += String.fromCharCode(bytes[i]);
            }
            var boundaryMatch = headerText.match(/--([^\r\n]+)/);
            if (!boundaryMatch) {
                throw new Error('No boundary found in multipart response');
            }
            var boundary = '--' + boundaryMatch[1];
            var boundaryBytes = [];
            for (var i = 0; i < boundary.length; i++) {
                boundaryBytes.push(boundary.charCodeAt(i));
            }

            // Find all boundary positions
            var boundaryPositions = [];
            for (var i = 0; i <= bytes.length - boundaryBytes.length; i++) {
                var match = true;
                for (var j = 0; j < boundaryBytes.length; j++) {
                    if (bytes[i + j] !== boundaryBytes[j]) {
                        match = false;
                        break;
                    }
                }
                if (match) {
                    boundaryPositions.push(i);
                }
            }

            var imageParts = {
                'sat-nw': null,
                'sat-ne': null,
                'sat-sw': null,
                'sat-se': null,
                'terrain-nw': null,
                'terrain-ne': null,
                'terrain-sw': null,
                'terrain-se': null
            };
            var elevationData = null;
            var offsetData = null;

            // Extract parts between boundaries
            for (var p = 0; p < boundaryPositions.length - 1; p++) {
                var partStart = boundaryPositions[p] + boundaryBytes.length;
                var partEnd = boundaryPositions[p + 1];
                var partBytes = bytes.slice(partStart, partEnd);

                // Convert headers to text to check content type
                var headersEndPos = -1;
                for (var i = 0; i < partBytes.length - 3; i++) {
                    if (partBytes[i] === 13 && partBytes[i+1] === 10 &&
                        partBytes[i+2] === 13 && partBytes[i+3] === 10) {
                        headersEndPos = i + 4;
                        break;
                    }
                }

                if (headersEndPos === -1) continue;

                var headerText = '';
                for (var i = 0; i < headersEndPos; i++) {
                    headerText += String.fromCharCode(partBytes[i]);
                }

                if (headerText.indexOf('Content-Type: image/png') !== -1) {
                    // Extract PNG binary data (trim trailing \r\n)
                    var dataEnd = partBytes.length;
                    while (dataEnd > headersEndPos &&
                           (partBytes[dataEnd-1] === 10 || partBytes[dataEnd-1] === 13)) {
                        dataEnd--;
                    }
                    var imageBytes = partBytes.slice(headersEndPos, dataEnd);

                    // Determine which image this is based on Content-Disposition header
                    var nameMatch = headerText.match(/name="([^"]+)"/);
                    if (nameMatch && imageParts.hasOwnProperty(nameMatch[1])) {
                        imageParts[nameMatch[1]] = imageBytes;
                        console.log('Parsed image part: ' + nameMatch[1] + ' (' + imageBytes.length + ' bytes)');
                    }
                } else if (headerText.indexOf('Content-Type: application/json') !== -1) {
                    // Extract JSON text
                    var jsonText = '';
                    for (var i = headersEndPos; i < partBytes.length; i++) {
                        if (partBytes[i] !== 13 && partBytes[i] !== 10) {
                            jsonText += String.fromCharCode(partBytes[i]);
                        }
                    }
                    try {
                        var parsedData = JSON.parse(jsonText.trim());

                        // Check if this is elevation data or offset data
                        var nameMatch = headerText.match(/name="([^"]+)"/);
                        if (nameMatch && nameMatch[1] === 'elevations') {
                            elevationData = parsedData;
                            // Log elevation data received from server
                            if (elevationData && elevationData.elevations) {
                                console.log('Elevation data received: ' + elevationData.elevations.length + ' values');
                                console.log('Expected count from server: ' + elevationData.count);
                                if (elevationData.elevations.length !== elevationData.count) {
                                    console.warn('WARNING: Elevation array size mismatch in received data!');
                                }
                            }
                        } else if (nameMatch && nameMatch[1] === 'offset') {
                            offsetData = parsedData;
                            console.log('Offset data received: ' + JSON.stringify(offsetData));
                        }
                    } catch (e) {
                        console.error('Failed to parse JSON:', e);
                    }
                }
            }

            // Verify all image parts were received
            var missingParts = [];
            for (var partName in imageParts) {
                if (imageParts[partName] === null) {
                    missingParts.push(partName);
                }
            }
            if (missingParts.length > 0) {
                throw new Error('Missing image parts: ' + missingParts.join(', '));
            }

            $('#loading-data-alert').text(tqTranslate('JS.INIT_PLAYER'));

            // Create a canvas to composite the 4 satellite tiles into a single image
            // Each tile is 1280x1280 pixels, but we crop 30 pixels from the bottom of each
            var canvas = document.createElement('canvas');
            var tileSize = 1280; // Each tile is 640x640 at scale=2, so 1280x1280
            var footerOffset = offsetData.value * 2; // Footer height to crop from bottom of norther tiles * scale factor
            canvas.width = tileSize * 2; // 2560 pixels wide
            canvas.height = tileSize * 2; // 2560 pixels tall
            var ctx = canvas.getContext('2d');

            // Load all 8 tiles (4 satellite + 4 terrain) and composite them
            var tilesToLoad = 8;
            var tilesLoaded = 0;
            var tileImages = {
                'sat-nw': null,
                'sat-ne': null,
                'sat-sw': null,
                'sat-se': null,
                'terrain-nw': null,
                'terrain-ne': null,
                'terrain-sw': null,
                'terrain-se': null
            };

            function onTileLoaded() {
                tilesLoaded++;
                if (tilesLoaded === tilesToLoad) {
                    console.log('All tiles loaded, processing water mask with WebGL shader');

                    // Process each quadrant through WebGL shader to replace water pixels
                    // NW quadrant (y-offset to accommodate footer, will stay transparent)
                    var processedNW = applyWaterMaskWebGL(tileImages['sat-nw'], tileImages['terrain-nw'], tileSize, tileSize);
                    ctx.drawImage(processedNW, 0, 0, tileSize, tileSize - footerOffset, 0, footerOffset, tileSize, tileSize - footerOffset); // Top-left

                    // NE quadrant (y-offset to accommodate footer, will stay transparent)
                    var processedNE = applyWaterMaskWebGL(tileImages['sat-ne'], tileImages['terrain-ne'], tileSize, tileSize);
                    ctx.drawImage(processedNE, 0, 0, tileSize, tileSize - footerOffset, tileSize, footerOffset, tileSize, tileSize - footerOffset); // Top-right

                    // SW quadrant
                    var processedSW = applyWaterMaskWebGL(tileImages['sat-sw'], tileImages['terrain-sw'], tileSize, tileSize);
                    ctx.drawImage(processedSW, 0, 0, tileSize, tileSize, 0, tileSize, tileSize, tileSize); // Bottom-left

                    // SE quadrant
                    var processedSE = applyWaterMaskWebGL(tileImages['sat-se'], tileImages['terrain-se'], tileSize, tileSize);
                    ctx.drawImage(processedSE, 0, 0, tileSize, tileSize, tileSize, tileSize, tileSize, tileSize); // Bottom-right

                    console.log('Water mask processing complete, creating texture');
                    overviewBuildTerrainMask( canvas );            // overview + the replay rose's placement

                    // Convert canvas to texture
                    var textureLoader = new THREE.TextureLoader();
                    var texture = textureLoader.load(canvas.toDataURL('image/png'),
                        function(map) {
                            // Texture loaded successfully
                            map.wrapS = THREE.ClampToEdgeWrapping;
                            map.wrapT = THREE.ClampToEdgeWrapping;
                            map.anisotropy = 16;
                            map.repeat.set(1, 1);
                            geoMaterial.map = map;
                            geoMaterial.transparent = true;
                            geoMaterial.alphaTest = 0.1;
                            geoMaterial.needsUpdate = true;

                            scene.add(geoMesh);

                            // Apply elevation data if available and 3D terrain is enabled
                            if (gEnable3DTerrain && elevationData && elevationData.elevations) {
                                // Find the elevation of the start area (for lakes where it's > 0m)
                                // The original elevation data is in kElevationResolution x kElevationResolution as a single array
                                var refElevation = 0;
                                if ( latFrac >= 0 && latFrac <= 1 && lonFrac >= 0 && lonFrac <= 1 )
                                {
                                    // Row 0 is the north edge (latFrac counts from the south), kElevationResolution + 1 values per row;
                                    // never below 0 m - sea is 0 in the data, a scattered coastal value below it must not lift the sea
                                    var refRow = Math.round((1.0 - latFrac) * kElevationResolution);
                                    var refCol = Math.round(lonFrac * kElevationResolution);
                                    refElevation = elevationData.elevations[refRow * (kElevationResolution + 1) + refCol];
                                    if ( refElevation === undefined || isNaN(refElevation) || refElevation < 0 ) refElevation = 0;
                                }
                                console.log('Using reference elevation of ' + refElevation);

                                // Interpolate from kElevationResolution source data to kOceanResolution target geometry
                                var interpolatedElevations = interpolateElevationData(elevationData.elevations, refElevation, kElevationResolution, kOceanResolution);

                                // Verify array sizes before applying elevations
                                var meshVertexCount = geoGeometry.attributes.position.count;
                                var elevationCount = interpolatedElevations.length;
                                console.log('Applying elevations to terrain: ' + elevationCount + ' elevations for ' + meshVertexCount + ' vertices');

                                if (elevationCount !== meshVertexCount) {
                                    console.error('ERROR: Elevation count (' + elevationCount + ') does not match mesh vertex count (' + meshVertexCount + ')');
                                    console.error('Missing ' + (meshVertexCount - elevationCount) + ' elevation values');
                                }

                                 updateTerrainGeometry(geoGeometry, interpolatedElevations, gElevationScale);
                                 overviewBuildTerrainHeights( interpolatedElevations, kOceanResolution, gElevationScale );
                            }

                            gGeoTexturesLoaded = true;
                            $('#google-maps-copyright').show();
                        },
                        undefined,
                        function(err) {
                            console.error('Failed to load texture from canvas:', err);
                            geoMesh = null;
                            gGeoTexturesLoaded = true;
                        }
                    );
                }
            }

            // Load each satellite tile as an Image
            for (var tileName in tileImages) {
                var img = new Image();
                img.tileName = tileName;
                img.onload = function() {
                    tileImages[this.tileName] = this;
                    onTileLoaded();
                };
                img.onerror = function() {
                    console.error('Failed to load tile: ' + this.tileName);
                    gGeoTexturesLoaded = true;
                };

                // Create blob URL for this tile
                var blob = new Blob([imageParts[tileName]], { type: 'image/png' });
                img.src = URL.createObjectURL(blob);
            }
        })
        .catch(function(error) {
            // We don't have a geomap since the area is mostly water or fetch failed
            console.error('Failed to load geo surface:', error);
            geoMesh = null;
            gGeoTexturesLoaded = true;
        });
}

/**
 * Interpolates elevation data from a lower resolution grid to a higher resolution grid
 * using bilinear interpolation for smooth terrain transitions.
 *
 * @param {Array} elevations - Source elevation data array
 * @param {Number} sourceSegments - Number of segments in source grid (e.g., 128)
 * @param {Number} targetSegments - Number of segments in target grid (e.g., 512)
 * @returns {Array} Interpolated elevation data for target grid
 */
function interpolateElevationData(elevations, refElevation, sourceSegments, targetSegments)
{
    var sourceRes = sourceSegments + 1; // Number of vertices per side in source
    var targetRes = targetSegments + 1; // Number of vertices per side in target
    var interpolated = new Array(targetRes * targetRes);

    // Cubic spline interpolation helper - Catmull-Rom spline
    function cubicInterpolate(p0, p1, p2, p3, t) {
        var t2 = t * t;
        var t3 = t2 * t;
        return 0.5 * (
            (2 * p1) +
            (-p0 + p2) * t +
            (2 * p0 - 5 * p1 + 4 * p2 - p3) * t2 +
            (-p0 + 3 * p1 - 3 * p2 + p3) * t3
        );
    }

    // Bicubic interpolation using Catmull-Rom spline
    function bicubicInterpolate(grid, x, y) {
        var arr = new Array(4);
        for (var i = 0; i < 4; i++) {
            arr[i] = cubicInterpolate(grid[i][0], grid[i][1], grid[i][2], grid[i][3], x);
        }
        return cubicInterpolate(arr[0], arr[1], arr[2], arr[3], y);
    }

    // Safe elevation getter with clamping
    function getElevation(x, y) {
        x = Math.max(0, Math.min(sourceRes - 1, x));
        y = Math.max(0, Math.min(sourceRes - 1, y));
        return elevations[y * sourceRes + x];
    }

    for (var y = 0; y < targetRes; y++) {
        for (var x = 0; x < targetRes; x++) {
            // Map target position to source position (in continuous coordinates)
            var sourceX = (x / (targetRes - 1)) * (sourceRes - 1);
            var sourceY = (y / (targetRes - 1)) * (sourceRes - 1);

            // Find the center point for the 4x4 grid
            var x1 = Math.floor(sourceX);
            var y1 = Math.floor(sourceY);

            // Calculate interpolation weights (0 to 1)
            var wx = sourceX - x1;
            var wy = sourceY - y1;

            // Get the 4x4 grid of surrounding points for bicubic interpolation
            var grid = [];
            for (var gy = -1; gy <= 2; gy++) {
                var row = [];
                for (var gx = -1; gx <= 2; gx++) {
                    row.push(getElevation(x1 + gx, y1 + gy));
                }
                grid.push(row);
            }

            // Apply bicubic interpolation
            var value = bicubicInterpolate(grid, wx, wy);

            // Normalize the elevation relative to water level, and make sure we are always above water :)
            var elevation = Math.max(0.1, value - refElevation);
            if ( elevation < 500 )
            {
                interpolated[y * targetRes + x] = elevation;
            }
            else
            {
                interpolated[y * targetRes + x] = Math.sqrt(elevation) * 22.36;
            }
        }
    }

    return interpolated;
}

function updateTerrainGeometry(geometry, elevations, scale)
{
    var posAttr = geometry.attributes.position;
    var vertexCount = posAttr.count;
    var elevationCount = elevations.length;

    // Apply elevations for available data
    var applyCount = Math.min(vertexCount, elevationCount);
    for (var i = 0; i < applyCount; i++) {
        var elevation = elevations[i];
        // Guard against undefined or NaN values
        if (elevation !== undefined && !isNaN(elevation)) {
            posAttr.setZ(i, elevation * scale);
        } else {
            posAttr.setZ(i, 0); // Default to sea level for invalid data
        }
    }

    // Fill remaining vertices with sea level if elevation data is short
    if (elevationCount < vertexCount) {
        console.warn('Filling ' + (vertexCount - elevationCount) + ' vertices with default elevation (sea level)');
        for (var i = elevationCount; i < vertexCount; i++) {
            posAttr.setZ(i, 0);
        }
    }

    posAttr.needsUpdate = true;
    geometry.computeVertexNormals();
    console.log('Terrain geometry updated: Applied ' + applyCount + ' elevations to ' + vertexCount + ' vertices.');
}

function loadOceanSurface( scene )
{
    var oceanGeometry = new THREE.PlaneBufferGeometry( kOceanSize, kOceanSize );
    var oceanMaterial = new THREE.MeshStandardMaterial( { roughness: 0.0, metalness: 0.0 } );
    var ocean = new THREE.Mesh( oceanGeometry, oceanMaterial );
    ocean.position.z = gWaterLevel-0.01;
    ocean.name = 'OCEAN';
    //ocean.layers.enable( 1 );
    scene.add( ocean );

    // Load the default water surface
    var textureLoader = new THREE.TextureLoader();
    textureLoader.load( gAssetPrefix + '/img/tx-water-surface-dark.jpg',
        function ( map ) {
            map.wrapS = THREE.RepeatWrapping;
            map.wrapT = THREE.RepeatWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            oceanMaterial.map = map;
            oceanMaterial.needsUpdate = true;

            gOceanTexturesLoaded = true;
        } );
}

function loadWaterSurface( scene )
{
    var waterGeometry = new THREE.PlaneBufferGeometry(kOceanSize, kOceanSize);
    water = new THREE.Water(waterGeometry, {
        color: '#abc0da',
        reflectivity: 0.001,
        clipBias: 0.003,
        scale: 10.0,
        flowSpeed: 0.05,
        flowDirection: new THREE.Vector2(0, 1),
        textureWidth: 640,
        textureHeight: 640
    });
    water.position.z = gWaterLevel;
    water.name = 'WATER';
    scene.add(water);
}

function loadSky( scene )
{
    // skybox
    var cubeTextureLoader = new THREE.CubeTextureLoader();
    cubeTextureLoader.setPath( gAssetPrefix + '/img/' );
    var cubeTexture = cubeTextureLoader.load( [
        'px.jpg', 'nx.jpg',
        'py.jpg', 'ny.jpg',
        'pz.jpg', 'nz.jpg',
    ] );
    var cubeShader = THREE.ShaderLib[ 'cube' ];
    cubeShader.uniforms[ 'tCube' ].value = cubeTexture;
    var skyBoxMaterial = new THREE.ShaderMaterial( {
        fragmentShader: cubeShader.fragmentShader,
        vertexShader: cubeShader.vertexShader,
        uniforms: cubeShader.uniforms,
        side: THREE.BackSide
    } );
    var skyBox = new THREE.Mesh( new THREE.BoxBufferGeometry( 1000, 1000, 1000 ), skyBoxMaterial );
    skyBox.layers.enable( 1 );
    skyBox.name = 'SKYBOX';
    scene.add( skyBox );
}

function geometryCloneFaces( geometry )
{
    for (var i = 0, len = geometry.faces.length; i < len; i++)
    {
        var face = geometry.faces[i].clone();
        face.materialIndex = 1;
        geometry.faces.push(face);
        geometry.faceVertexUvs[0].push(geometry.faceVertexUvs[0][i].slice(0));
    }
}

function loadWindIndicator( scene )
{
    var geometry1 = new THREE.PlaneGeometry( 3, 3 );
    var material1 = new THREE.MeshPhongMaterial( {side: THREE.FrontSide} );
    gWindIndRing = new THREE.Mesh( geometry1, material1 );
    gWindIndRing.name = 'WIND RING';
    scene.add( gWindIndRing );

    var textureLoader1 = new THREE.TextureLoader();
    textureLoader1.load( gAssetPrefix + '/img/tx-wind-indicator-ring.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            material1.map = map;
            material1.transparent = true;
            material1.alphaTest = 0.1;
            material1.needsUpdate = true;

            gWindIndRing.position.z = gWindRoseZ;
            windIndicatorPlace();
        } );

    var geometry2 = new THREE.PlaneBufferGeometry( 3, 3 );
    var material2 = new THREE.MeshPhongMaterial();
    gWindIndAvg = new THREE.Mesh( geometry2, material2 );
    gWindIndAvg.name = 'WIND AVG';
    scene.add( gWindIndAvg );

    var textureLoader2 = new THREE.TextureLoader();
    textureLoader2.load( gAssetPrefix + '/img/tx-wind-indicator-avg.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            material2.map = map;
            material2.transparent = true;
            material2.alphaTest = 0.1;
            material2.needsUpdate = true;

            gWindIndAvg.position.z = gWindRoseZ;
            windIndicatorPlace();
        } );

    var geometry3 = new THREE.PlaneBufferGeometry( 3, 3 );
    var material3 = new THREE.MeshPhongMaterial();
    gWindIndCurrent = new THREE.Mesh( geometry3, material3 );
    gWindIndCurrent.name = 'WIND CURRENT';
    scene.add( gWindIndCurrent );

    var textureLoader3 = new THREE.TextureLoader();
    textureLoader3.load( gAssetPrefix + '/img/tx-wind-indicator-current.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            material3.map = map;
            material3.transparent = true;
            material3.alphaTest = 0.1;
            material3.needsUpdate = true;

            gWindIndCurrent.position.z = gWindRoseZ + 0.005;
            windIndicatorPlace();
        } );
}

var gWindSpeedUpdateHold = false;

function windIndicatorUpdate()
{
    // Rotation is defined left-handed, so rotate by the negative wind direction
    if ( gWindIndAvg !== null && gWindIndCurrent !== null )
    {
        if ( Math.abs(gTwdCameraAvg.avg - gWindIndAvgValue) > 0.5 )
        {
            gWindIndAvgValue = gTwdCameraAvg.avg;
            gWindIndAvg.rotation.z = ((-gWindIndAvgValue) * kDegToRad);
        }
        if ( gTwd !== 999999.0 && Math.abs(gTwd - gWindIndCurrentValue) > 0.5 )
        {
            gWindIndCurrentValue = gTwd;
            gWindIndCurrent.rotation.z = ((-gWindIndCurrentValue) * kDegToRad);
        }
    }

    // Update the text for the wind speed
    if ( gWindSpeedText !== null && !gWindSpeedUpdateHold && gTws !== '999999.0' )
    {
        gWindSpeedUpdateHold = true;

        var textGeometry = new THREE.TextGeometry( gTws + '',
            {
                font: gWindSpeedFont,
                size: 0.3,
                height: 0.03,
                curveSegments: 12,
                bevelEnabled: false
            });
        textGeometry.computeBoundingBox();
        var tSize = textGeometry.boundingBox.getSize();
        textGeometry.translate( -(tSize.x / 1.9), -(1.2 * tSize.y), 0 );

        gWindSpeedText.geometry = textGeometry;
        gWindSpeedText.rotation.z = ((-gWindIndAvgValue) * kDegToRad);
        gWindSpeedUnit.rotation.z = ((-gWindIndAvgValue) * kDegToRad);
        gWindSpeedUnit.visible = (gTws !== '–');

        setTimeout( function() { gWindSpeedUpdateHold = false; }, 450 );
    }
}

function windIndicatorShow()
{
    gWindIndRing.position.z = gWindRoseZ;
    gWindIndAvg.position.z = gWindRoseZ;
    gWindIndCurrent.position.z = gWindRoseZ + 0.005;
    if ( gWindSpeedText !== null ) gWindSpeedText.position.z = gWindRoseZ;
    if ( gWindSpeedUnit !== null ) gWindSpeedUnit.position.z = gWindRoseZ;
}

/**
 * Put the replay's wind rose at its placement (gWindRoseX / gWindRoseY, roseWaterPlacement): every part that
 * exists - the texture and font callbacks call this again for the parts that load later. The rose draws
 * after the terrain mesh (renderOrder), so the transparent sort does not depend on both sitting at the
 * origin. The overview positions the same meshes itself (renderOverviewWindRose).
 */
function windIndicatorPlace()
{
    if ( gOverviewMode ) return;
    var parts = [ gWindIndRing, gWindIndAvg, gWindIndCurrent, gWindSpeedText, gWindSpeedUnit ];
    for ( var i=0; i<parts.length; i++ )
    {
        if ( parts[i] === null || parts[i] === undefined ) continue;
        parts[i].position.x = gWindRoseX;
        parts[i].position.y = gWindRoseY;
        parts[i].renderOrder = 2;
    }
}

function windIndicatorHide()
{
    gWindIndRing.position.z = 0.0;
    gWindIndAvg.position.z = 0.0;
    gWindIndCurrent.position.z = 0.0;
    gWindSpeedText.position.z = 0.0;
    gWindSpeedUnit.position.z = 0.0;
}

function loadWindSpeedInd( scene )
{
    var loader = new THREE.FontLoader();
    loader.load( gAssetPrefix + '/fonts/helvetiker_bold.typeface.json', function ( font ) {
        gWindSpeedFont = font;

        var textGeometry = new THREE.TextGeometry( ' ',
            {
                font: gWindSpeedFont,
                size: 0.3,
                height: 0.003,
                curveSegments: 12
            });

        var textMaterial = new THREE.MeshPhongMaterial(
            { color: 0x909090, specular: 0xffffff }
        );

        gWindSpeedText = new THREE.Mesh( textGeometry, textMaterial );
        gWindSpeedText.position.z = gWindRoseZ;
        gWindSpeedText.name = 'TWS VALUE';

        scene.add( gWindSpeedText );

        var unitGeometry = new THREE.TextGeometry( 'kn',
            {
                font: gWindSpeedFont,
                size: 0.18,
                height: 0.003,
                curveSegments: 12
            });
        unitGeometry.computeBoundingBox();
        var uSize = unitGeometry.boundingBox.getSize();
        unitGeometry.translate( -(uSize.x / 2.0), -(3.3 * uSize.y), 0 );


        gWindSpeedUnit = new THREE.Mesh( unitGeometry, textMaterial );
        gWindSpeedUnit.position.z = gWindRoseZ;
        gWindSpeedUnit.name = 'TWS UNIT';

        scene.add( gWindSpeedUnit );
        windIndicatorPlace();
    });
}

function loadCourseMarks( scene )
{
    gMarkCones = new Array();
    gMarkAnnotations = new Array();
    gLegs = new Array();
    var coneMaterials = new Array();

    for ( var i = 0; i < gMarks.length; i++ )
    {
        var sameMark = false;
        var coneName = 'MARK: ' + gMarks[i].name;
        for ( var j = 0; j < gMarkCones.length; j++ )
        {
            if ( coneName === gMarkCones[j].name )
            {
                sameMark = true;
                break;
            }
        }

        var geometry = new THREE.ConeGeometry(kMarkConeRadius, kMarkConeHeight, 20, 20);
        var material = new THREE.MeshBasicMaterial({color: 0xfff200});
        var cone = new THREE.Mesh(geometry, material);
        cone.name = coneName;
        if ( !sameMark ) scene.add(cone);
        gMarkCones.push(cone);
        coneMaterials.push(material);
        var pos = translate(gMarks[i].lat, gMarks[i].lon);
        cone.position.x = pos.x;
        cone.position.y = pos.y;
        cone.position.z = gWaterLevel + 0.01;
        cone.rotation.x = 90.0 * kDegToRad;
        if ( (gMarks[i].index === 0 && gMarks[i].name === 'Start') || gMarks[i].index > 0 )
        {
            gMarkAnnotations.push({x: cone.position.x, y: cone.position.y, z: cone.position.z + 0.05, index: gMarks[i].index, visible: !sameMark});
            gLegs.push({lat: gMarks[i].lat, lon: gMarks[i].lon});
        }
    }
    addBeaconMarks( scene, coneMaterials );
    var textureLoader = new THREE.TextureLoader();
    textureLoader.load( gAssetPrefix + '/img/tx-course-mark.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            for ( var i = 0; i < coneMaterials.length; i++ )
            {
                coneMaterials[i].map = map;
                coneMaterials[i].transparent = true;
                coneMaterials[i].alphaTest = 0.1;
                coneMaterials[i].needsUpdate = true;
            }
        } );

    // Update scale of mark cones
    for ( i=0; i<gMarkCones.length; i++ )
    {
        gMarkCones[i].scale.set( gMarkScale, gMarkScale, gMarkScale );
    }

    // Get the magn. variation
    var magvar = 0.0;
    for ( i=0; i<gRecords[0].length; i++ )
    {
        if ( gRecords[0][i].lat !== 0 && gRecords[0][i].lon !== 0 )
        {
            magvar = gRecords[0][i].magvar;
            break;
        }
    }

    // Calculate leg information
    for ( i=1; i<gLegs.length; i++ )
    {
        var xhdt = mvutils_calculate_xhdm( {lat: gLegs[i-1].lat, lon: gLegs[i-1].lon},
                                           {lat: gLegs[i].lat, lon: gLegs[i].lon} );
        var xhdm = mvutils_add360( xhdt, -magvar );
        var xdist = mvutils_distanceFromTo( gLegs[i-1].lat, gLegs[i-1].lon, gLegs[i].lat, gLegs[i].lon ) * 1852.0;

        gLegs[i].legHdm = xhdm;
        gLegs[i].legDist = xdist;
    }
    // Remove start entry from legs
    gLegs.shift();

    gMarksLoaded = true;
}

/* ==============================================================
   RACE DATA DOWNLOAD
   ============================================================== */
function downloadRaceData( demo )
{
    if ( raceInfos == null ) return;

    // Allow a bigger canvas for demo mode
    if ( demo )
    {
        kOceanSize -= 5;
    }

    var data = new Object();
    var url;
    if ( demo )
    {
        /// SINGLE RACE: url = gAssetPrefix + '/logs/records-53.json';
        url = gAssetPrefix + '/logs/records-53-64.json';
    }
    else
    {
        data[site.csrf.keys.name] = site.csrf.name;
        data[site.csrf.keys.value] = site.csrf.value;

        if ( gCaptureToken !== '' )
        {
            // Race report capture: token-guarded endpoints, no session; the token covers every
            // race of the page (a fleet capture lists them all)
            url = site.uri.public + '/api/sailcast-capture/records?race=' + captureRaceIdList() + '&ct=' + gCaptureToken
                + (gFleetMode && gFleetInfo ? '&fleet=' + gFleetInfo.fleet_start_id : '');
        }
        else if ( rShareToken == '' )
        {
            url = site.uri.public + '/api/sailcast/records?race=';
            for ( var i=0; i<raceInfos.length-1; i++ )
            {
                url += raceInfos[i].raceId + ',';
            }
            url += raceInfos[raceInfos.length-1].raceId;
        }
        else
        {
            url = site.uri.public + '/api/sailcast-shared/records?race=' + rShareToken + replaySoloFlag();
        }
    }

    var debugAjax = (typeof site !== "undefined") && site.debug.ajax;

    return $.ajax({
        type: "GET",
        url: url,
        data: data,
        dataType: 'json'
    }).fail(function (jqXHR) {
        if ( jqXHR.status == 200 )
        {
            console.log("Race data downloaded successfully.");
        }
        else
        {
            // Error messages
            if (debugAjax && jqXHR.responseText) {
                document.write(jqXHR.responseText);
                document.close();
            } else {
                console.log("Error (" + jqXHR.status + "): " + jqXHR.responseText );
            }
            // Display errors on failure
            // TODO: ufAlerts widget should have a 'destroy' method
            if (!$("#alerts-page").data('ufAlerts')) {
                $("#alerts-page").ufAlerts();
            } else {
                $("#alerts-page").ufAlerts('clear');
            }

            $("#alerts-page").ufAlerts('fetch').ufAlerts('render');
        }

        return jqXHR;
    }).done(function (response) {
        //console.log( response );
        gRecords = response;
        var gotRaceData = false;

        if ( gRecords != null )
        {
            // See how many we have and get start time and duration
            gNumRecords = gRecords.length;
            if ( gNumRecords > 10 )
            {
                // Calculate play times for challenge races (different start times)
                gPlaybackIndex = 0;
                gRaceStartTime = gRecords[0][0].rtime / 100.0;
                if ( raceInfos[0].regattaType === 2 )
                {
                    // Challenge replay - find start time offsets, raceInfo is sorted by duration (long -> short)
                    for ( var i = 1; i < gRecords[0].length; i++ )
                    {
                        gRaceStartTime = Math.min(gRaceStartTime, gRecords[0][i].rtime / 100.0);
                    }
                    for ( var i = 0; i < gRecords[0].length; i++ )
                    {
                        var thisRaceLogStart = gRecords[0][i].rtime / 100.0
                        gRaceStartOffset.push(thisRaceLogStart - gRaceStartTime);
                        console.log('Start offset for race ' + i + ': ' + thisRaceLogStart - gRaceStartTime);
                    }

                    var endIdx = gNumRecords - 1;
                    while ( gRecords[endIdx--][0].race_id !== gRecords[0][0].race_id ) ;
                    gRaceDuration = (gRecords[endIdx][0].rtime - gRecords[0][0].rtime) / 100.0;
                    gFirstMarkRaceTimeOffset = 0;
                }
                else
                {
                    // In a regular race all boats start at the same time
                    for ( var i = 0; i<raceInfos.length; i++ )
                    {
                        gRaceStartOffset.push(0.0);
                    }
                    gFirstMarkRaceTimeOffset = -gRecords[gSelectedBoatIndex][gReferenceMarkListIndex].racetime;
                }

                // Maintain each boat's current leg index so we can determine the lead boat
                for ( var i = 0; i<raceInfos.length; i++ )
                {
                    raceInfos[i].legIdx = 0;
                    raceInfos[i].legXMark = null;
                    raceInfos[i].constructedMarkList = [];

                    // Initialize the last info to 0
                    raceInfos[i].lastLat = 0.0;
                    raceInfos[i].lastLon = 0.0;
                    raceInfos[i].lastHdm = 0.0;
                    raceInfos[i].lastStw = 0.0;
                    raceInfos[i].lastVmg = 0.0;
                    raceInfos[i].lastVmc = 0.0;
                    raceInfos[i].lastTws = 0.0;
                    raceInfos[i].lastTwa = 0.0;
                    raceInfos[i].lastHeel = 0.0;
                    raceInfos[i].lastDampTwd = 0.0;
                    raceInfos[i].lastTwaTgt = 0.0;
                    raceInfos[i].lastXName = '';
                    raceInfos[i].lastXHdm = 0.0;
                    raceInfos[i].lastXDist = 0.0;
                }

                // Adjust array to contain at least one entry per boat per rtime. When we encounter missing records (zero records)
                // fill in the most recent data known.
                var latMin = 90.0, latMax = -90.0, lonMin = 180.0, lonMax = -180.0;

                // Each boat's real records (row, playback time) - the boats are interpolated between
                // these, never through the padding entries (boatFixBracket)
                gBoatFixes = [];
                for ( var i = 0; i < raceInfos.length; i++ )
                {
                    gBoatFixes.push( { rows: [], times: [] } );
                }
                for ( var r = 0; r < gNumRecords; r++ )
                {
                    // Fix HDM to use COG if HDM is off (e.g. user did not fix device perpendicular), and back-calculate TWA if invalid
                    for ( var i=0; i<gRecords[r].length; i++ )
                    {
                        var hdmFixed = false;
                        if ( Math.abs(mvutils_substract360(gRecords[r][i].hdm, gRecords[r][i].cog)) > 25.0 )
                        {
                            gRecords[r][i].hdm = gRecords[r][i].cog;
                            hdmFixed = true;
                        }

                        if ( (hdmFixed || gRecords[r][i].twa === 999999) && gRecords[r][i].dampTwd !== 999999 )
                        {
                            gRecords[r][i].twa = mvutils_substract360( gRecords[r][i].dampTwd, gRecords[r][i].hdm );
                            if ( gRecords[r][i].twa > 180.0 )
                                gRecords[r][i].twa -= 360.0;
                            else if ( gRecords[r][i].twa < -180.0 )
                                gRecords[r][i].twa += 360.0;
                        }
                    }

                    if ( gRecords[r].length !== raceInfos.length )
                    {
                        var recIndex = 0;
                        var tempArray = new Array();
                        for ( var i = 0; i < raceInfos.length; i++ )
                        {
                            // Build existing race records into an array at race time 'r' in the order of the race infos
                            if ( recIndex < gRecords[r].length
                                 &&
                                 gRecords[r][recIndex].race_id === raceInfos[i].raceId )
                            {
                                tempArray.splice(i, 0, gRecords[r][recIndex]);
                                if ( gRecords[r][recIndex].lat !== 0 && gRecords[r][recIndex].lon !== 0 )
                                {
                                    gBoatFixes[i].rows.push( r );
                                    gBoatFixes[i].times.push( gRecords[r][recIndex].rtime / 100.0 - gRaceStartOffset[i] - gRaceStartTime );

                                    raceInfos[i].lastLat = gRecords[r][recIndex].lat;
                                    raceInfos[i].lastLon = gRecords[r][recIndex].lon;
                                    raceInfos[i].lastHdm = gRecords[r][recIndex].hdm;
                                    raceInfos[i].lastStw = gRecords[r][recIndex].stw;
                                    raceInfos[i].lastVmg = gRecords[r][recIndex].vmg;
                                    raceInfos[i].lastVmc = gRecords[r][recIndex].vmc;
                                    raceInfos[i].lastTws = gRecords[r][recIndex].tws;
                                    raceInfos[i].lastTwa = gRecords[r][recIndex].twa;
                                    raceInfos[i].lastHeel = gRecords[r][recIndex].heel;
                                    raceInfos[i].lastDampTwd = gRecords[r][recIndex].dampTwd;
                                    raceInfos[i].lastTwaTgt = gRecords[r][recIndex].twaTgt;
                                    raceInfos[i].lastXName = gRecords[r][recIndex].xName;

                                    // xHdm and xDist are not always valid
                                    if ( !isNaN(gRecords[r][recIndex].xHdm) && gRecords[r][recIndex].xHdm !== 999999 )
                                        raceInfos[i].lastXHdm = gRecords[r][recIndex].xHdm;
                                    if ( !isNaN(gRecords[r][recIndex].xDist) && gRecords[r][recIndex].xDist > 0 )
                                        raceInfos[i].lastXDist = gRecords[r][recIndex].xDist;

                                    latMin = Math.min(latMin, raceInfos[i].lastLat);
                                    latMax = Math.max(latMax, raceInfos[i].lastLat);
                                    lonMin = Math.min(lonMin, raceInfos[i].lastLon);
                                    lonMax = Math.max(lonMax, raceInfos[i].lastLon);
                                }

                                recIndex++;
                            }
                            else
                            {
                                if ( raceInfos[i].lastLat === undefined )
                                {
                                    // We have a race index whose records begin past the beginning
                                    raceInfos[i].lastLat = 0;
                                    raceInfos[i].lastLon = 0;
                                }

                                // The original data set has at least one raceIndex per time 'r', so gRecords[r][0] is always a valid object.
                                // Find which raceIndex is contained in record 0 so we can use the correct start time offset:
                                var raceIdx;
                                for ( raceIdx = 0; raceIdx < raceInfos.length; raceIdx++ )
                                {
                                    if ( raceInfos[raceIdx].raceId === gRecords[r][0].race_id )
                                    {
                                        break;
                                    }
                                }
                                tempArray.splice(i, 0,
                                    {
                                        race_id: raceInfos[i].raceId,
                                        boat_id: raceInfos[i].boatId,
                                        rtime: (gRecords[r][0].rtime / 100.0 - gRaceStartOffset[raceIdx] + gRaceStartOffset[i]) * 100.0,
                                        lat: raceInfos[i].lastLat,
                                        lon: raceInfos[i].lastLon,
                                        hdm: raceInfos[i].lastHdm,
                                        stw: raceInfos[i].lastStw,
                                        vmg: raceInfos[i].lastVmg,
                                        vmc: raceInfos[i].lastVmc,
                                        tws: raceInfos[i].lastTws,
                                        twa: raceInfos[i].lastTwa,
                                        heel: raceInfos[i].lastHeel,
                                        dampTwd: raceInfos[i].lastDampTwd,
                                        twaTgt: raceInfos[i].lastTwaTgt,
                                        magvar: gRecords[r][0].magvar,
                                        xName: raceInfos[i].lastXName,
                                        xHdm: raceInfos[i].lastXHdm,
                                        xDist: raceInfos[i].lastXDist
                                    });
                            }
                        }
                        gRecords[r] = tempArray;
                    }
                    else
                    {
                        for ( var i = 0; i < raceInfos.length; i++ )
                        {
                            if ( gRecords[r][i].lat !== 0 && gRecords[r][i].lon !== 0 )
                            {
                                gBoatFixes[i].rows.push( r );
                                gBoatFixes[i].times.push( gRecords[r][i].rtime / 100.0 - gRaceStartOffset[i] - gRaceStartTime );

                                raceInfos[i].lastLat = gRecords[r][i].lat;
                                raceInfos[i].lastLon = gRecords[r][i].lon;
                                raceInfos[i].lastHdm = gRecords[r][i].hdm;
                                raceInfos[i].lastStw = gRecords[r][i].stw;
                                raceInfos[i].lastVmg = gRecords[r][i].vmg;
                                raceInfos[i].lastVmc = gRecords[r][i].vmc;
                                raceInfos[i].lastTws = gRecords[r][i].tws;
                                raceInfos[i].lastTwa = gRecords[r][i].twa;
                                raceInfos[i].lastHeel = gRecords[r][i].heel;
                                raceInfos[i].lastDampTwd = gRecords[r][i].dampTwd;
                                raceInfos[i].lastTwaTgt = gRecords[r][i].twaTgt;
                                raceInfos[i].lastXName = gRecords[r][i].xName;

                                // xHdm and xDist are not always valid
                                if ( !isNaN(gRecords[r][i].xHdm) && gRecords[r][i].xHdm !== 999999 )
                                    raceInfos[i].lastXHdm = gRecords[r][i].xHdm;
                                if ( !isNaN(gRecords[r][i].xDist) && gRecords[r][i].xDist > 0 )
                                    raceInfos[i].lastXDist = gRecords[r][i].xDist;

                                latMin = Math.min(latMin, raceInfos[i].lastLat);
                                latMax = Math.max(latMax, raceInfos[i].lastLat);
                                lonMin = Math.min(lonMin, raceInfos[i].lastLon);
                                lonMax = Math.max(lonMax, raceInfos[i].lastLon);
                            }
                        }
                    }

                    // The demo race records have bad race times, fix these here
                    if ( demo )
                    {
                        for ( var i=0; i<raceInfos.length; i++ )
                        {
                            gRecords[r][i].racetime = r - 359;
                        }
                    }

                    // Check if the leg counts need adjustment and fill the leg index into each gRecord
                    for ( var i = 0; i<raceInfos.length; i++ )
                    {
                        if ( gRecords[r][i].racetime >= 0 )
                        {
                            // If we don't have marks, extract them from for each boat record
                            if ( raceInfos[i].loggedMarkList.length === 0 )
                            {
                                if ( raceInfos[i].legXMark == null )
                                {
                                    if ( gRecords[r][i].xName !== undefined
                                         && gRecords[r][i].xName !== null
                                         && gRecords[r][i].xName.length > 1 )
                                    {
                                        // First time we have an xmark value for this boat
                                        raceInfos[i].legXMark = gRecords[r][i].xName;
                                        raceInfos[i].constructedMarkList.push( {index: 1, name: gRecords[r][i].xName, roundingRaceTime: 0});
                                        console.log('Setting first mark for boat ' + i + ' to ' + gRecords[r][i].xName);
                                    }
                                }
                                else
                                {
                                    // Check if the next mark changed
                                    if ( gRecords[r][i].xName !== undefined
                                         && gRecords[r][i].xName !== null
                                         && gRecords[r][i].xName.length > 1
                                         && gRecords[r][i].xName !== raceInfos[i].legXMark )
                                    {
                                        raceInfos[i].legIdx++;
                                        raceInfos[i].legXMark = gRecords[r][i].xName;
                                        raceInfos[i].constructedMarkList[raceInfos[i].constructedMarkList.length-1].roundingRaceTime = gRecords[r][i].racetime;
                                        raceInfos[i].constructedMarkList.push( {index: raceInfos[i].legIdx + 1, name: gRecords[r][i].xName, roundingRaceTime: 0});
                                        console.log('Changing next mark for boat ' + i + ' to ' + gRecords[r][i].xName + ' | ' + raceInfos[i].legIdx + ' at time ' + gRecords[r][i].racetime);
                                    }
                                }
                            }
                            else // ... otherwise use the rounding times of this boat's mark list
                            {
                                if ( raceInfos[i].loggedMarkList.length > raceInfos[i].legIdx
                                     &&
                                     gRecords[r][i].racetime > raceInfos[i].loggedMarkList[raceInfos[i].legIdx].roundingRaceTime )
                                {
                                    raceInfos[i].legIdx++;
                                    console.log('Changing next mark for boat ' + i + ' to ' + (raceInfos[i].legIdx < raceInfos[i].loggedMarkList.length ? raceInfos[i].loggedMarkList[raceInfos[i].legIdx].name : 'n/a') + ' | ' + raceInfos[i].legIdx + ' at time ' + gRecords[r][i].racetime);
                                }
                            }
                        }
                        gRecords[r][i].legIdx = raceInfos[i].legIdx;
                    }

                    //console.log(gRecords[r][0].race_id + ' | ' + gRecords[r][0].rtime + ' - ' + gRecords[r][1].race_id + ' | ' + gRecords[r][1].rtime);
                }

                // Check if we need to assign any constructed mark lists
                for ( var i = 0; i<raceInfos.length; i++ )
                {
                    if ( raceInfos[i].loggedMarkList.length === 0 && raceInfos[i].constructedMarkList.length > 0 )
                    {
                        for ( var j=0; j<raceInfos[i].constructedMarkList.length; j++ )
                        {
                            if ( raceInfos[i].constructedMarkList[j].hasOwnProperty('name') && raceInfos[i].constructedMarkList[j]['name']
                                 && raceInfos[i].constructedMarkList[j].hasOwnProperty('lat') && raceInfos[i].constructedMarkList[j]['lat']
                                 && raceInfos[i].constructedMarkList[j].hasOwnProperty('lon') && raceInfos[i].constructedMarkList[j]['lon']
                                 && raceInfos[i].constructedMarkList[j].hasOwnProperty('roundingRaceTime') && raceInfos[i].constructedMarkList[j]['roundingRaceTime'] )
                            {
                                if ( Math.abs(raceInfos[i].constructedMarkList[j]['lat']) > 0.01 && Math.abs(raceInfos[i].constructedMarkList[j]['lon']) > 0.01 )
                                {
                                    raceInfos[i].loggedMarkList.push(raceInfos[i].constructedMarkList[j]);
                                }
                            }
                            else
                            {
                                console.log("Ignoring incomplete mark:");
                                console.log(raceInfos[i].constructedMarkList[j]);
                            }
                        }
                    }
                }

                // If a boat has no finish or a mark close to the end, append a finish so that the legs look correct.
                for ( var i = 0; i<raceInfos.length; i++ )
                {
                    var startIsFinish = (Math.abs(gRecords[gNumRecords - 2][i].lat - raceInfos[i].startBoatLat) < 0.0045
                                         && Math.abs(gRecords[gNumRecords - 2][i].lon - raceInfos[i].startBoatLon) < 0.0045);

                    if ( raceInfos[i].loggedMarkList.length === 0 )
                    {
                        // Just append the finish
                        raceInfos[i].loggedMarkList.push(
                            {
                                index: 1,
                                name: (startIsFinish ? '' : 'Finish'),
                                lat: gRecords[gNumRecords - 2][i].lat,
                                lon: gRecords[gNumRecords - 2][i].lon,
                                roundingRaceTime: gRecords[gNumRecords - 2][i].racetime
                            });
                    }
                    else
                    {
                        var endDelta = gRecords[gNumRecords - 2][i].racetime - raceInfos[i].loggedMarkList[raceInfos[i].loggedMarkList.length - 1].roundingRaceTime;
                        if ( endDelta > 60
                             &&
                             raceInfos[i].loggedMarkList[raceInfos[i].loggedMarkList.length - 1].name !== 'Finish' )
                        {
                            var idx = raceInfos[i].loggedMarkList[raceInfos[i].loggedMarkList.length - 1].index + 1;
                            raceInfos[i].loggedMarkList.push(
                                {
                                    index: idx,
                                    name: (startIsFinish ? '' : 'Finish'),
                                    lat: gRecords[gNumRecords - 2][i].lat,
                                    lon: gRecords[gNumRecords - 2][i].lon,
                                    roundingRaceTime: gRecords[gNumRecords - 2][i].racetime
                                });
                        }
                    }
                }

                // Now that we have as-good-as-it-gets marklists, set the stops on the timeline
                updateTimelineStopsForSelectedBoatIdx( gSelectedBoatIndex );

                // Calculate play times for regular races (same start time for all boats)
                if ( raceInfos[0].regattaType !== 2 )
                {
                    // Regular race
                    for ( var i = 0; i < raceInfos.length; i++ )
                    {
                        gRaceStartOffset.push(0);
                    }
                    gRaceDuration = gRecords[gNumRecords - 1][gSelectedBoatIndex].rtime / 100.0 - gRaceStartTime;
                }

                console.log("SailCast: Found " + gNumRecords + " records for race");
                console.log("SailCast: Race started at " + gRaceStartTime + " and lasted " + gRaceDuration + " seconds");

                gotRaceData = true;

                gGeoBox = getBoundingGeoBox();
                gBoatChaseDistance = kCameraPlaneChaseDistance * 178.0 / gLatScale;

                // Get the relative position of the start in the geobox to look up the water elevation later on
                var latFrac = -1;
                var lonFrac = -1;
                var reflat = raceInfos[0].startBoatLat;
                var reflon = raceInfos[0].startBoatLon;
                if ( (reflat === 0 || reflon === 0) && gRecords.length > 10 )
                {
                    reflat = gRecords[8][0].lat;
                    reflon = gRecords[8][0].lon;
                }
                if ( reflat >= gGeoBox.minLat && reflat <= gGeoBox.maxLat && reflon >= gGeoBox.minLon && reflon <= gGeoBox.maxLon )
                {
                    latFrac = (reflat - gGeoBox.minLat) / (gGeoBox.maxLat - gGeoBox.minLat);
                    lonFrac = (reflon - gGeoBox.minLon) / (gGeoBox.maxLon - gGeoBox.minLon);
                }

                var verticalSpan = (gGeoBox.maxLat - gGeoBox.minLat) * 60 * 1852;
                gElevationScale = Math.min(kElevationScaleMax, Math.max(kElevationScaleMin, 0.0033 - verticalSpan/36000.0 * 0.001));
                console.log("Vertical span: " + verticalSpan + ", scale = " + gElevationScale);

                loadGeoMap(gGeoBox.ctrLat, gGeoBox.ctrLon, gGeoBox.mapZoom, latFrac, lonFrac, demo);

                ///layoutPlayerView();

                checkForLoadingCompleted();

                gAllLogsLoaded = true;

                if ( !gMarksLoaded )
                {
                    loadCourseMarks(gScene);
                }

                // On iPads / iPhone scroll down by the top bar size and hide side bar to maximize viewing area
                scrollViewForMobile();
            }
        }

        if ( !gotRaceData )
        {
            var alertDiv = document.getElementById('no-race-data-alert');
            alertDiv.style.display = 'block';
        }
    });
}

/* ==============================================================
   MEDIA PHOTO STREAM MASONRY
   ============================================================== */

/*** UNUSED FOR NOW
function mediaInitializeMasonry()
{
    if ( mediaStreamNumPhotos === 0 ) return;

    var rootElements = document.getElementsByClassName('masonry-root');
    gMediaRoots = Array.prototype.map.call(rootElements, function(rootElement) {
        var cellElements = rootElement.getElementsByClassName('masonry-cell');
        var cells = Array.prototype.map.call(cellElements, function(cellElement) {
            var style = getComputedStyle(cellElement);
            return {
                'element': cellElement,
                'outerHeight': parseInt(style.marginTop) + cellElement.offsetHeight + parseInt(style.marginBottom)
            };
        });
        return {
            'element': rootElement,
            'noOfColumns': 1,
            'cells': cells
        };
    });

    // Do the first layout
    mediaLayoutMasonry();
}

function mediaLayoutMasonry()
{
    if ( mediaStreamNumPhotos === 0 ) return;

    for ( var i=0; i<gMediaRoots.length; i++ )
    {
        // Only layout when the number of columns has changed
        var newNoOfColumns = 1; //Math.floor(root.element.offsetWidth / gMediaMinColWidth);
        if ( newNoOfColumns !== gMediaRoots[i].noOfColumns )
        {
            // Initialize
            gMediaRoots[i].noOfColumns = newNoOfColumns;
            var columns = Array.from(new Array(gMediaRoots[i].noOfColumns)).map( function(column) {
                return {
                    'cells': new Array(),
                    'outerHeight': 0
                };
            });

            // Divide...
            for ( var k=0; k<gMediaRoots[i].cells.length; k++ )
            {
                var minOuterHeight = Math.min(...columns.map( function(column) {
                    return column.outerHeight;
                }));
                var column = columns.find( function(column) {
                    return (column.outerHeight === minOuterHeight);
                });
                column.cells.push(gMediaRoots[i].cells[k]);
                column.outerHeight += gMediaRoots[i].cells[k].outerHeight;
            }

            // calculate masonry height
            var masonryHeight = Math.max(...columns.map( function(column) {
                return column.outerHeight;
            }));

            // ...and conquer
            var order = 0;
            for ( var j=0; j<columns.length; j++ )
            {
                for ( var l=0; l<columns[j].cells.length; l++ )
                {
                    columns[j].cells[l].element.style.order = order++;
                    // set the cell's flex-basis to 0
                    columns[j].cells[l].element.style.flexBasis = 0;
                }
                // set flex-basis of the last cell to fill the
                // leftover space at the bottom of the column
                // to prevent the first cell of the next column
                // to be rendered at the bottom of this column
                columns[j].cells[columns[j].cells.length - 1].element.style.flexBasis = columns[j].cells[columns[j].cells.length - 1].element.offsetHeight + masonryHeight - columns[j].outerHeight - 1 + 'px';
            }

            // set the masonry height to trigger
            // re-rendering of all cells over columns
            // one pixel more than the tallest column
            gMediaRoots[i].element.style.maxHeight = masonryHeight + 1 + 'px';

            console.log(columns.map( function(column) {
                return column.outerHeight;
            }));
            console.log(root.element.style.maxHeight);
        }
    }
}
 ***/

/* ==============================================================
   HELPER FUNCTIONS
   ============================================================== */
function getBoundingGeoBox()
{
    var minLat = 90;
    var minLon = 180;
    var maxLat = -90;
    var maxLon = -180;

    // Make sure all marks are accounted for - the beacon marks too
    var beaconMarks = scBeaconMarkList();
    for ( var i=0; i<beaconMarks.length; i++ )
    {
        minLat = Math.min(minLat, beaconMarks[i].lat);
        maxLat = Math.max(maxLat, beaconMarks[i].lat);
        minLon = Math.min(minLon, beaconMarks[i].lon);
        maxLon = Math.max(maxLon, beaconMarks[i].lon);
    }
    for ( var i=0; i<gMarks.length; i++ )
    {
        if ( !isNaN(gMarks[i].lat) && Math.abs(gMarks[i].lat) > 0.01 && !isNaN(gMarks[i].lon) && Math.abs(gMarks[i].lon) > 0.01 )
        {
            minLat = Math.min(minLat, gMarks[i].lat);
            maxLat = Math.max(maxLat, gMarks[i].lat);
            minLon = Math.min(minLon, gMarks[i].lon);
            maxLon = Math.max(maxLon, gMarks[i].lon);
        }
    }

    // Make sure all boat positions are accounted for
    for ( var i=0; i<gNumRecords; i+= 15 )
    {
        for ( var j=0; j<numBoats; j++ )
        {
            if ( !isNaN(gRecords[i][j].lat) && gRecords[i][j].lat != 0 && !isNaN(gRecords[i][j].lon) && gRecords[i][j].lon != 0 )
            {
                minLat = Math.min( minLat, gRecords[i][j].lat );
                maxLat = Math.max( maxLat, gRecords[i][j].lat );
                minLon = Math.min( minLon, gRecords[i][j].lon );
                maxLon = Math.max( maxLon, gRecords[i][j].lon );
            }
        }
    }

    centerLat = minLat + (maxLat - minLat) / 2.0;
    centerLon = minLon + (maxLon - minLon) / 2.0;

    // Find the longer side of the geo-box
    var latDelta = maxLat - minLat;
    var lonDelta = maxLon - minLon;

    // The box size is in latitudinal degrees
    var geoBoxSize = Math.max( latDelta, lonDelta * Math.cos( centerLat * kDegToRad ) );

    // Convert latitudinal degrees into a Google maps zoom factor
    // We retrieve the max. size for static gmaps at 640x640:
    var scale = geoBoxSize * 1852.0 / 640.0;
    var gmapZoom = Math.floor(8.0 - Math.log2(scale)) + 2;

    // Get the actual corner coordinates based on our center and gmap tiles
    var mapRegion = guGetGmapCorners( {lat: centerLat, lon: centerLon}, gmapZoom, 640, 640);
    minLat = mapRegion.sw.lat;
    maxLat = mapRegion.ne.lat;
    minLon = mapRegion.sw.lon;
    maxLon = mapRegion.ne.lon;

    // Update our box size to the gmap zoom step
    latDelta = maxLat - minLat;
    lonDelta = maxLon - minLon;
    geoBoxSize = Math.max( latDelta, lonDelta * Math.cos( centerLat * kDegToRad ) );

    // Make the box 3x the size to make sure we always cover the horizon
    // from the render perspective
    ///minLat = centerLat - 1.5 * geoBoxSize;
    ///maxLat = centerLat + 1.5 * geoBoxSize;
    ///minLon = centerLon - 1.5 * geoBoxSize / Math.cos( centerLat * kDegToRad );
    ///maxLon = centerLon + 1.5 * geoBoxSize / Math.cos( centerLat * kDegToRad );

    gLatScale = 1.0 / (geoBoxSize / kOceanSize);
    gLonScale = 1.0 / ((geoBoxSize / Math.cos( centerLat * kDegToRad )) / kOceanSize);

    gBoatTrailInterval = Math.max( 33.0 - 0.045 * gLatScale, 5 );

    return { minLat: minLat, minLon: minLon, maxLat: maxLat, maxLon: maxLon, ctrLat: centerLat, ctrLon: centerLon, mapZoom: gmapZoom };
}

/**
 * The red dot in front of a mark name whose position is a beacon report (mark.beacon - BeaconCourse roundings,
 * Design/BEACON_API.md "race page marks"; the race and fleet maps show the same).
 */
function scBeaconDot( mark )
{
    return ( mark && mark.beacon === true ? '<span class="sc-beacon-dot"></span>' : '' );
}

/**
 * The beacon marks of the race(s) on the page (raceInfos[].beaconMarks, SailcastController - a fleet's
 * boats all carry the fleet's), one per name.
 */
function scBeaconMarkList()
{
    var out = [];
    var seen = {};
    if ( typeof raceInfos === 'undefined' || raceInfos === null ) return out;
    for ( var r=0; r<raceInfos.length; r++ )
    {
        var list = raceInfos[r].beaconMarks;
        if ( !(list instanceof Array) ) continue;
        for ( var b=0; b<list.length; b++ )
        {
            if ( seen[list[b].name] ) continue;
            seen[list[b].name] = true;
            out.push( list[b] );
        }
    }
    return out;
}

/**
 * The beacon marks no drawn mark covers (none of gMarks within 50 m - an unrounded mark): a course mark cone
 * and a name with the red dot, outside gMarks, so they get no scrubber stop and take no part in the legs.
 */
function addBeaconMarks( scene, coneMaterials )
{
    gBeaconMarkExtras = [];
    var beacons = scBeaconMarkList();
    for ( var b=0; b<beacons.length; b++ )
    {
        var covered = false;
        for ( var k=0; k<gMarks.length; k++ )
        {
            if ( Math.abs( gMarks[k].lat ) < 0.01 || Math.abs( gMarks[k].lon ) < 0.01 ) continue;
            if ( mvutils_distanceFromTo( gMarks[k].lat, gMarks[k].lon, beacons[b].lat, beacons[b].lon ) < 50.0 / 1852.0 ) { covered = true; break; }
        }
        if ( covered ) continue;

        var geometry = new THREE.ConeGeometry(kMarkConeRadius, kMarkConeHeight, 20, 20);
        var material = new THREE.MeshBasicMaterial({color: 0xfff200});
        var cone = new THREE.Mesh(geometry, material);
        cone.name = 'BEACON MARK: ' + beacons[b].name;
        var pos = translate( beacons[b].lat, beacons[b].lon );
        cone.position.x = pos.x;
        cone.position.y = pos.y;
        cone.position.z = gWaterLevel + 0.01;
        cone.rotation.x = 90.0 * kDegToRad;
        cone.scale.set( gMarkScale, gMarkScale, gMarkScale );
        scene.add( cone );
        gMarkCones.push( cone );          // scaled with the course marks
        coneMaterials.push( material );   // and textured with them

        var div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.top = 0 + 'px';
        div.style.left = 9999 + 'px';
        div.style.zIndex = 5000;
        div.innerHTML = '<p class="mark-legend">' + scBeaconDot( { beacon: true } ) + scMarkLabel( beacons[b].name ) + '</p>';
        document.getElementById('scene').appendChild( div );
        gBeaconMarkExtras.push( { lat: beacons[b].lat, lon: beacons[b].lon, cone: cone, div: div, z: cone.position.z + 0.05 } );
    }
}

/**
 * Label for a mark as the viewer sees it.
 *
 * gMarks[].name is also state: it is compared against 'Start', 'Finish', 'FINISH' and
 * 'START-FINISH' when the scrubber stops and the annotations are built. Translating the
 * stored value would break those tests, so the mapping happens here, at the point of
 * display, and nowhere else.
 */
function scMarkLabel( name )
{
    if ( name === 'Start' ) return tqTranslate('JS.MARK_START');
    if ( name === 'Finish' || name === 'FINISH' ) return tqTranslate('JS.MARK_FINISH');
    return name;
}

function translate( lat, lon )
{
    return { x: (lon - centerLon) * gLonScale, y: (lat - centerLat) * gLatScale };
}

function getViewportCoordinates( location )
{
    var zOffset = (gCameraMode == kCameraModeChase ? 0.17 : 0.0);

    gVector.set( location.x, location.y, location.z + zOffset );
    gVector.project( gCamera );

    gVector.x = (gVector.x + 1)/2 * $('#scene').width();
    gVector.y = -(gVector.y - 1)/2 * $('#scene').height();

    return gVector;
}


/* ==============================================================
   OVERVIEW MODE (race report) - one static frame of the whole race
   ============================================================== */

/**
 * Mean true wind direction of the race (degrees true): the race's stored average
 * when valid, else the circular mean of the logged damped TWD, plus variation.
 */
function overviewTrueTwd()
{
    var magvar = 0.0;
    for ( var i=0; i<gRecords.length; i++ )
    {
        if ( gRecords[i][0].magvar !== undefined && gRecords[i][0].magvar !== 999999 ) { magvar = parseFloat( gRecords[i][0].magvar ); break; }
    }
    var ave = parseFloat( raceInfos[0].aveTwd );
    if ( !isNaN( ave ) && ave !== 999999 && ave > 0 && ave <= 360 )
    {
        return mvutils_conform360( ave + magvar );
    }
    var sinSum = 0.0, cosSum = 0.0;
    for ( var i=0; i<gRecords.length; i++ )
    {
        var twd = gRecords[i][0].dampTwd;
        if ( twd === undefined || twd === 999999 ) continue;
        sinSum += Math.sin( twd * kDegToRad );
        cosSum += Math.cos( twd * kDegToRad );
    }
    if ( sinSum === 0 && cosSum === 0 ) return 0.0;
    return mvutils_conform360( Math.atan2( sinSum, cosSum ) / kDegToRad + magvar );
}

/**
 * Scene-space points of everything the overview must show: all boats' tracks and the marks.
 */
function overviewScenePoints()
{
    var pts = [];
    // A fleet overview frames the course - the consensus marks and the start line, with a
    // margin - not every stray point: one boat that kept logging on the way home would
    // otherwise shrink the whole fleet to a dot. Tracks outside the box are drawn but clipped.
    var box = null;
    if ( gFleetMode )
    {
        var latMin = 999, latMax = -999, lonMin = 999, lonMax = -999, n = 0;
        var add = function ( lat, lon ) {
            if ( Math.abs( lat ) < 0.01 || Math.abs( lon ) < 0.01 ) return;
            latMin = Math.min( latMin, lat ); latMax = Math.max( latMax, lat );
            lonMin = Math.min( lonMin, lon ); lonMax = Math.max( lonMax, lon );
            n++;
        };
        for ( var m=0; m<gMarks.length; m++ ) add( gMarks[m].lat, gMarks[m].lon );
        var fleetBeacons = scBeaconMarkList();
        for ( var m=0; m<fleetBeacons.length; m++ ) add( fleetBeacons[m].lat, fleetBeacons[m].lon );
        add( raceInfos[0].startBoatLat, raceInfos[0].startBoatLon );
        add( raceInfos[0].startPinLat, raceInfos[0].startPinLon );
        if ( n >= 2 )
        {
            var padLat = Math.max( 0.012, (latMax - latMin) * 0.6 );
            var padLon = Math.max( 0.015, (lonMax - lonMin) * 0.6 );
            box = { latMin: latMin - padLat, latMax: latMax + padLat, lonMin: lonMin - padLon, lonMax: lonMax + padLon };
        }
    }
    for ( var b=0; b<numBoats; b++ )
    {
        for ( var i=0; i<gRecords.length; i++ )
        {
            var rec = gRecords[i][b];
            if ( rec === undefined || rec.lat === 0 || rec.lon === 0 || rec.lat === 999999 ) continue;
            if ( box !== null && (rec.lat < box.latMin || rec.lat > box.latMax || rec.lon < box.lonMin || rec.lon > box.lonMax) ) continue;
            var p = translate( rec.lat, rec.lon );
            if ( Math.abs( p.x ) > kOceanSize || Math.abs( p.y ) > kOceanSize ) continue;
            pts.push( p );
        }
    }
    for ( var m=0; m<gMarks.length; m++ )
    {
        if ( Math.abs( gMarks[m].lat ) > 0.01 && Math.abs( gMarks[m].lon ) > 0.01 ) pts.push( translate( gMarks[m].lat, gMarks[m].lon ) );
    }
    var overviewBeacons = scBeaconMarkList();
    for ( var m=0; m<overviewBeacons.length; m++ ) pts.push( translate( overviewBeacons[m].lat, overviewBeacons[m].lon ) );
    return pts;
}

/**
 * High oblique camera south of the race looking north (north up), at a distance that
 * fits every track point and mark into the frame. North-up keeps the view aligned
 * with the square ground tile, so the camera never looks past its edge - a wind-up
 * frame did on diagonal courses, and the tile size is fixed (satellite/terrain
 * resolution vs. mesh cost). The mean wind is reported in the legend instead.
 */
function computeOverviewCamera()
{
    var pts = overviewScenePoints();
    if ( pts.length === 0 ) { gOverviewCam = { x: 0, y: -20, z: 30, cx: 0, cy: 0, twd: 0, extent: kOceanSize }; return; }

    var twd = overviewTrueTwd();
    // Frame axes: w = north (screen up), v = east (screen right)
    var wx = 0.0, wy = 1.0;
    var vx = 1.0, vy = 0.0;
    var minW = 1e9, maxW = -1e9, minV = 1e9, maxV = -1e9;
    for ( var i=0; i<pts.length; i++ )
    {
        var pw = pts[i].x * wx + pts[i].y * wy;
        var pv = pts[i].x * vx + pts[i].y * vy;
        if ( pw < minW ) minW = pw; if ( pw > maxW ) maxW = pw;
        if ( pv < minV ) minV = pv; if ( pv > maxV ) maxV = pv;
    }
    var cW = (minW + maxW) / 2, cV = (minV + maxV) / 2;
    var cx = cW * wx + cV * vx, cy = cW * wy + cV * vy;
    var halfW = Math.max( 0.5, (maxW - minW) / 2 ), halfV = Math.max( 0.5, (maxV - minV) / 2 );

    var elev = kOverviewElevationDeg * kDegToRad;
    var fov = kCameraFovBev * kDegToRad;
    var aspect = gCamera.aspect > 0 ? gCamera.aspect : 1.6;
    var L = Math.max( halfW / Math.tan( fov / 2 ), halfV / (Math.tan( fov / 2 ) * aspect) ) * 0.9;

    gCamera.fov = kCameraFovBev;
    gCamera.far = 1000;
    gCamera.updateProjectionMatrix();

    // Grow the distance until every point projects inside the frame with a margin
    for ( var iter=0; iter<12; iter++ )
    {
        var dx = -wx * L * Math.cos( elev ), dy = -wy * L * Math.cos( elev );   // south of the centre
        gOverviewCam = { x: cx + dx, y: cy + dy, z: gWaterLevel + L * Math.sin( elev ), cx: cx, cy: cy, twd: twd, extent: Math.max( halfW, halfV ) * 2 };
        gCamera.position.set( gOverviewCam.x, gOverviewCam.y, gOverviewCam.z );
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt( new THREE.Vector3( cx, cy, gWaterLevel ) );
        gCamera.updateMatrixWorld();
        var inside = true;
        for ( var i=0; i<pts.length; i+=3 )
        {
            var v = new THREE.Vector3( pts[i].x, pts[i].y, gWaterLevel ).project( gCamera );
            if ( Math.abs( v.x ) > 0.90 || Math.abs( v.y ) > 0.86 ) { inside = false; break; }
        }
        if ( inside ) break;
        L *= 1.12;
    }
}

/** A tracker-mode race has no polar, so no speed performance: its ribbon is one solid colour. */
var kTrackerTrackColor = 0xe6ba6d;

function overviewPerfColor( stw, stwTgt )
{
    if ( stw === undefined || stwTgt === undefined || stw === 999999 || stwTgt === 999999 || stwTgt <= 0 || stw >= 50 )
    {
        return new THREE.Color( 0x8a8a8a );
    }
    var perf = Math.max( 80.0, Math.min( 120.0, stw / stwTgt * 100.0 ) );
    return new THREE.Color( mvutils_hslToHex( (perf - 80.0) * 3.0, 80, 50 ) );   // 80% red -> 120% green
}

/**
 * Full track of every boat as a flat ribbon on the water, coloured per segment by
 * boat speed against the polar target (WebGL lines are 1 px, hence a mesh).
 */
function renderOverviewTrack()
{
    var extent = (gOverviewCam !== null ? gOverviewCam.extent : kOceanSize);
    // Proportional to the course extent - the camera distance is too, so the ribbon keeps the
    // same width on screen whatever the course size (a fixed floor made small courses look fat)
    var halfWidth = Math.max( 0.004, extent / 420.0 );
    var step = Math.max( 1, Math.ceil( gRecords.length / kOverviewMaxTrackPoints ) );

    for ( var b=0; b<numBoats; b++ )
    {
        var geometry = new THREE.Geometry();
        var prev = null, prevColor = null, vi = 0;
        var tracker = ( raceInfos[b] !== undefined && parseInt( raceInfos[b].trackerMode ) === 1 );
        var trackerColor = new THREE.Color( gFleetMode ? fleetColorForBoatIndex( b ) : kTrackerTrackColor );
        for ( var i=0; i<gRecords.length; i+=step )
        {
            var rec = gRecords[i][b];
            if ( rec === undefined || rec.lat === 0 || rec.lon === 0 || rec.lat === 999999 || rec.racetime < 0 ) continue;
            var p = translate( rec.lat, rec.lon );
            if ( Math.abs( p.x ) > kOceanSize || Math.abs( p.y ) > kOceanSize ) continue;
            var color = ( tracker ? trackerColor : overviewPerfColor( rec.stw, rec.stwTgt ) );
            if ( prev !== null )
            {
                var dx = p.x - prev.x, dy = p.y - prev.y;
                var len = Math.sqrt( dx*dx + dy*dy );
                if ( len < 0.0005 ) continue;
                var nx = -dy / len * halfWidth, ny = dx / len * halfWidth;
                var z = gWaterLevel + 0.02;
                geometry.vertices.push( new THREE.Vector3( prev.x + nx, prev.y + ny, z ), new THREE.Vector3( prev.x - nx, prev.y - ny, z ),
                                        new THREE.Vector3( p.x + nx, p.y + ny, z ), new THREE.Vector3( p.x - nx, p.y - ny, z ) );
                var f1 = new THREE.Face3( vi, vi+1, vi+2 ); f1.vertexColors = [ prevColor, prevColor, color ];
                var f2 = new THREE.Face3( vi+1, vi+3, vi+2 ); f2.vertexColors = [ prevColor, color, color ];
                geometry.faces.push( f1, f2 );
                vi += 4;
            }
            prev = p; prevColor = color;
        }
        if ( geometry.faces.length === 0 ) continue;
        var material = new THREE.MeshBasicMaterial( { vertexColors: THREE.VertexColors, side: THREE.DoubleSide } );
        var mesh = new THREE.Mesh( geometry, material );
        mesh.name = 'OVERVIEW TRACK ' + b;
        gScene.add( mesh );
        gOverviewObjects.push( mesh );
    }
}

/**
 * Wind arrows along the selected boat's track: one every 2 minutes of race time (at most
 * 150), flying with the wind, coloured by wind speed over the race's own range - the
 * same glyph and colour rule as the 2D map's wind vanes (gmap-track.js). A race without a
 * speed range - a tracker race whose crew entered no speed, or one constant estimate - gets
 * plain arrows: the direction only.
 */
function renderOverviewWindArrows()
{
    var b = gSelectedBoatIndex;
    var minTws = 999, maxTws = 0, magvar = 0.0, lastT = null, first = null, last = null;
    for ( var i=0; i<gRecords.length; i++ )
    {
        var rec = gRecords[i][b];
        if ( rec === undefined || rec.racetime < 0 ) continue;
        if ( rec.magvar !== undefined && rec.magvar !== 999999 ) magvar = parseFloat( rec.magvar );
        if ( first === null ) first = rec.rtime / 100.0;
        last = rec.rtime / 100.0;
        if ( rec.tws === 999999 || rec.tws <= 0 || rec.tws > 60 ) continue;
        if ( rec.tws < minTws ) minTws = rec.tws;
        if ( rec.tws > maxTws ) maxTws = rec.tws;
    }
    if ( first === null ) return;
    var graded = (maxTws > minTws);
    gOverviewArrowTws = (graded ? { min: minTws, max: maxTws } : (maxTws > 0 ? { constant: maxTws } : { none: true }));
    var interval = Math.max( kOverviewArrowIntervalS, (last - first) / kOverviewMaxArrows );

    var extent = (gOverviewCam !== null ? gOverviewCam.extent : kOceanSize);
    var scale = Math.max( 0.45, extent / 28.0 ) / 100.0;    // glyph path is 100 units long
    var shape = new THREE.Shape();
    shape.moveTo( 2, 0 ); shape.lineTo( 2, 80 ); shape.lineTo( 10, 80 ); shape.lineTo( 0, 100 );
    shape.lineTo( -10, 80 ); shape.lineTo( -2, 80 ); shape.lineTo( -2, 0 ); shape.lineTo( 2, 0 );
    var geometry = new THREE.ShapeGeometry( shape );

    for ( var i=0; i<gRecords.length; i++ )
    {
        var rec = gRecords[i][b];
        if ( rec === undefined || rec.racetime < 0 || rec.lat === 0 || rec.lon === 0 || rec.dampTwd === undefined || rec.dampTwd === 999999 ) continue;
        if ( graded && (rec.tws === 999999 || rec.tws <= 0 || rec.tws > 60) ) continue;
        var t = rec.rtime / 100.0;
        if ( lastT !== null && t - lastT < interval ) continue;
        lastT = t;

        var color = 0xd8e4ee;
        if ( graded )
        {
            var strength = (rec.tws - minTws) * (100.0 / (maxTws - minTws));
            var hue = (strength + 20.0) * (120.0 / 140.0);
            color = mvutils_hslToHex( hue, 65, 50 );
        }
        var material = new THREE.MeshBasicMaterial( { color: new THREE.Color( color ), transparent: true, opacity: 0.8, side: THREE.DoubleSide } );
        var arrow = new THREE.Mesh( geometry, material );
        var p = translate( rec.lat, rec.lon );
        arrow.position.set( p.x, p.y, gWaterLevel + 0.03 );
        arrow.scale.set( scale, scale, scale );
        arrow.rotation.z = -(rec.dampTwd + magvar + 180.0) * kDegToRad;   // tip points downwind
        arrow.name = 'OVERVIEW WIND';
        gScene.add( arrow );
        gOverviewObjects.push( arrow );
    }
}

/**
 * Wind statistics of the race for the rose: mean true TWD, mean TWS and the 5th/95th
 * percentile of the TWD shifts around the mean (how stable the breeze was).
 */
function overviewWindStats()
{
    var mean = overviewTrueTwd();
    var deltas = [], twsSum = 0.0, twsN = 0, magvar = 0.0;
    for ( var i=0; i<gRecords.length; i++ )
    {
        var rec = gRecords[i][0];
        if ( rec === undefined || rec.racetime < 0 ) continue;
        if ( rec.magvar !== undefined && rec.magvar !== 999999 ) magvar = parseFloat( rec.magvar );
        if ( rec.dampTwd !== undefined && rec.dampTwd !== 999999 )
        {
            var d = mvutils_substract360( rec.dampTwd + magvar, mean );
            if ( d > 180 ) d -= 360;
            if ( d < -180 ) d += 360;
            deltas.push( d );
        }
        if ( rec.tws !== undefined && rec.tws !== 999999 && rec.tws > 0 && rec.tws < 60 ) { twsSum += rec.tws; twsN++; }
    }
    var left = -10, right = 10;
    if ( deltas.length >= 30 )
    {
        deltas.sort( function ( a, b ) { return a - b; } );
        left = Math.max( -90, Math.min( 0, deltas[Math.floor( deltas.length * 0.05 )] ) );
        right = Math.min( 90, Math.max( 0, deltas[Math.floor( deltas.length * 0.95 )] ) );
    }
    var tws = parseFloat( raceInfos[0].aveTws );
    if ( isNaN( tws ) || tws <= 0 || tws >= 60 ) tws = (twsN > 0 ? twsSum / twsN : 0);
    return { twd: mean, tws: tws, left: left, right: right };
}

/**
 * Scene point on the water plane under a normalized screen position (-1..1) of the
 * current camera.
 */
function overviewWaterPointAtNdc( nx, ny )
{
    var v = new THREE.Vector3( nx, ny, 0.5 ).unproject( gCamera );
    var dir = v.sub( gCamera.position ).normalize();
    if ( Math.abs( dir.z ) < 1e-6 ) return { x: gCamera.position.x, y: gCamera.position.y };
    var t = (gWaterLevel - gCamera.position.z) / dir.z;
    return { x: gCamera.position.x + dir.x * t, y: gCamera.position.y + dir.y * t };
}

/**
 * Overview and the replay rose (roseWaterPlacement): coarse water/land grid from the composited satellite canvas. The
 * water-mask shader paints water pixels with alpha 127/255 and leaves land opaque, so
 * the downsampled alpha tells the two apart (cells outside the map are open ocean).
 * Row 0 = north edge, column 0 = west edge, same as the mesh texture.
 */
function overviewBuildTerrainMask( canvas )
{
    try
    {
        var res = kOverviewTerrainRes;
        var small = document.createElement( 'canvas' );
        small.width = res;
        small.height = res;
        var ctx = small.getContext( '2d' );
        ctx.drawImage( canvas, 0, 0, res, res );
        var data = ctx.getImageData( 0, 0, res, res ).data;
        var water = new Uint8Array( res * res );
        var waterCells = 0;
        for ( var i=0; i<res*res; i++ )
        {
            water[i] = (data[i * 4 + 3] < 170) ? 1 : 0;        // mostly water-mask pixels in this cell
            waterCells += water[i];
        }
        gOverviewTerrain = { res: res, water: water, zmax: (gOverviewTerrain !== null ? gOverviewTerrain.zmax : null) };
        console.log( 'Overview terrain mask: ' + (100.0 * waterCells / (res * res)).toFixed(0) + '% water' );
    }
    catch ( e )
    {
        console.warn( 'Overview terrain mask failed: ' + e );
    }
}

/** Overview and the replay rose: highest terrain z (relative to the geo overlay level) per mask cell. */
function overviewBuildTerrainHeights( elevations, segments, scale )
{
    var res = kOverviewTerrainRes;
    var zmax = new Float32Array( res * res );
    var n = segments + 1;
    for ( var iy=0; iy<n; iy++ )
    {
        var cy = Math.min( res - 1, Math.floor( iy * res / n ) );
        for ( var ix=0; ix<n; ix++ )
        {
            var e = elevations[iy * n + ix];
            if ( e === undefined || isNaN( e ) ) continue;
            var c = cy * res + Math.min( res - 1, Math.floor( ix * res / n ) );
            var z = e * scale;
            if ( z > zmax[c] ) zmax[c] = z;
        }
    }
    if ( gOverviewTerrain === null ) gOverviewTerrain = { res: res, water: null, zmax: zmax };
    else gOverviewTerrain.zmax = zmax;
}

/** Mask cell index for a scene xy, -1 outside the ground tile. */
function overviewTerrainCell( x, y )
{
    if ( gOverviewTerrain === null ) return -1;
    var res = gOverviewTerrain.res;
    var px = Math.floor( (x / kOceanSize + 0.5) * res );
    var py = Math.floor( (0.5 - y / kOceanSize) * res );
    if ( px < 0 || py < 0 || px >= res || py >= res ) return -1;
    return py * res + px;
}

function overviewIsWater( x, y )
{
    var c = overviewTerrainCell( x, y );
    if ( c < 0 || gOverviewTerrain.water === null ) return true;
    return gOverviewTerrain.water[c] === 1;
}

function overviewTerrainZ( x, y )
{
    var c = overviewTerrainCell( x, y );
    if ( c < 0 || gOverviewTerrain.zmax === null ) return 0;
    return gOverviewTerrain.zmax[c];
}

/** Sample points covering a disc: centre, inner ring, outer ring. */
function overviewDiscSamples( cx, cy, r )
{
    var pts = [ { x: cx, y: cy } ];
    for ( var k=0; k<8; k++ )
    {
        var a = k * Math.PI / 4;
        pts.push( { x: cx + 0.5 * r * Math.cos( a ), y: cy + 0.5 * r * Math.sin( a ) } );
    }
    for ( var k2=0; k2<16; k2++ )
    {
        var a2 = k2 * Math.PI / 8;
        pts.push( { x: cx + r * Math.cos( a2 ), y: cy + r * Math.sin( a2 ) } );
    }
    return pts;
}

/** NDC of a water-plane point under the current camera. */
function overviewNdcOfWaterPoint( x, y )
{
    var v = new THREE.Vector3( x, y, gWaterLevel ).project( gCamera );
    return { x: v.x, y: v.y };
}

/** Screen box of the legend in NDC, or null when it is hidden. */
function overviewLegendNdcBox()
{
    var legend = document.getElementById( 'scene-overview-legend' );
    if ( legend === null || legend.style.display === 'none' ) return null;
    var view = gRenderer.domElement.getBoundingClientRect();
    var box = legend.getBoundingClientRect();
    if ( view.width === 0 || view.height === 0 || box.width === 0 ) return null;
    return { x0: (box.left - view.left) / view.width * 2 - 1, x1: (box.right - view.left) / view.width * 2 - 1,
             y0: 1 - (box.bottom - view.top) / view.height * 2, y1: 1 - (box.top - view.top) / view.height * 2 };
}

/**
 * Whether a rose of radius r centred at (cx,cy) sits entirely on water, inside the
 * frame and clear of the legend box.
 */
function overviewRoseFits( cx, cy, r )
{
    var samples = overviewDiscSamples( cx, cy, r );
    var legendBox = overviewLegendNdcBox();
    var nx0 = 1, nx1 = -1, ny0 = 1, ny1 = -1;
    for ( var i=0; i<samples.length; i++ )
    {
        if ( !overviewIsWater( samples[i].x, samples[i].y ) ) return false;
        var n = overviewNdcOfWaterPoint( samples[i].x, samples[i].y );
        if ( Math.abs( n.x ) > 0.96 || Math.abs( n.y ) > 0.92 ) return false;
        nx0 = Math.min( nx0, n.x ); nx1 = Math.max( nx1, n.x );
        ny0 = Math.min( ny0, n.y ); ny1 = Math.max( ny1, n.y );
    }
    if ( legendBox !== null && nx1 > legendBox.x0 - 0.02 && nx0 < legendBox.x1 + 0.02 && ny1 > legendBox.y0 - 0.02 && ny0 < legendBox.y1 + 0.02 ) return false;
    return true;
}

/** Number of track points / marks inside the disc. */
function overviewDiscOverlap( cx, cy, r, pts )
{
    var n = 0, rr = r * r;
    for ( var i=0; i<pts.length; i++ )
    {
        var dx = pts[i].x - cx, dy = pts[i].y - cy;
        if ( dx * dx + dy * dy < rr ) n++;
    }
    return n;
}

/**
 * Where the replay's wind rose goes (Design/SAILCAST.md "Wind rose placement"): the centre when a disc of
 * radius r there is open water; else the nearest open-water spot within maxDist of the centre - among the
 * spots up to 1 unit farther than the nearest one, the one with the fewest track points / marks under it;
 * else the centre, lifted just above the terrain under the disc (at most kWindRoseLiftMax). Open water =
 * water in the mask and no terrain at the rose's height; a cell fits when its distance to the nearest
 * blocked cell (exact Euclidean distance transform over the mask grid) is at least r - no island slips
 * between sample points. Without terrain data everything is water: the centre.
 *
 * @param {number} r        the rose's radius with a margin (scene units)
 * @param {number} maxDist  how far from the centre it may move (scene units)
 * @return {{x: number, y: number, z: number, mode: string}}
 */
function roseWaterPlacement( r, maxDist )
{
    var centre = { x: 0.0, y: 0.0, z: gWindIndLevel, mode: 'centre' };
    if ( gOverviewTerrain === null || gOverviewTerrain.water === null )
    {
        console.log( 'Wind rose: centre (no terrain data)' );
        return centre;
    }
    var res = gOverviewTerrain.res;
    var cell = kOceanSize / res;
    var clearZ = gWindIndLevel - gGeoOverlayLevel;
    var dist2 = new Float64Array( res * res );
    for ( var i=0; i<res*res; i++ )
    {
        var blocked = (gOverviewTerrain.water[i] !== 1) || (gOverviewTerrain.zmax !== null && gOverviewTerrain.zmax[i] >= clearZ);
        dist2[i] = (blocked ? 0 : 1e10);           // "far": well above any squared grid distance, exact in doubles
    }
    roseDistanceTransform( dist2, res );
    var rc2 = (r / cell) * (r / cell);

    var c0 = overviewTerrainCell( 0, 0 );
    if ( c0 >= 0 && dist2[c0] >= rc2 )
    {
        console.log( 'Wind rose: centre (open water)' );
        return centre;
    }

    // Open-water spots within maxDist, the disc inside the tile
    var half = kOceanSize / 2.0;
    var cands = [];
    var d0 = Infinity;
    for ( var cy=0; cy<res; cy++ )
    {
        for ( var cx=0; cx<res; cx++ )
        {
            if ( dist2[cy * res + cx] < rc2 ) continue;
            var x = (cx + 0.5) * cell - half;
            var y = half - (cy + 0.5) * cell;
            if ( Math.abs( x ) > half - r || Math.abs( y ) > half - r ) continue;
            var d = Math.sqrt( x * x + y * y );
            if ( d > maxDist ) continue;
            cands.push( { x: x, y: y, d: d } );
            if ( d < d0 ) d0 = d;
        }
    }
    if ( cands.length > 0 )
    {
        // Track points / marks per cell, so the overlap of a disc is a sum over its cells
        var counts = new Uint16Array( res * res );
        var pts = overviewScenePoints();
        for ( var p=0; p<pts.length; p++ )
        {
            var pc = overviewTerrainCell( pts[p].x, pts[p].y );
            if ( pc >= 0 && counts[pc] < 65535 ) counts[pc]++;
        }
        var rCells = Math.ceil( r / cell );
        var best = null;
        for ( var k=0; k<cands.length; k++ )
        {
            var cand = cands[k];
            if ( cand.d > d0 + 1.0 ) continue;
            var cc = overviewTerrainCell( cand.x, cand.y );
            var ccx = cc % res, ccy = Math.floor( cc / res );
            var overlap = 0;
            for ( var dy=-rCells; dy<=rCells; dy++ )
            {
                for ( var dx=-rCells; dx<=rCells; dx++ )
                {
                    if ( (dx * dx + dy * dy) * cell * cell > r * r ) continue;
                    var qx = ccx + dx, qy = ccy + dy;
                    if ( qx < 0 || qy < 0 || qx >= res || qy >= res ) continue;
                    overlap += counts[qy * res + qx];
                }
            }
            if ( best === null || overlap < best.overlap || (overlap === best.overlap && cand.d < best.d) )
            {
                best = { x: cand.x, y: cand.y, d: cand.d, overlap: overlap };
            }
        }
        console.log( 'Wind rose: moved to ' + best.x.toFixed(2) + ', ' + best.y.toFixed(2) + ' (' + best.d.toFixed(2) + ' units from the centre, '
                     + best.overlap + ' track points under it)' );
        return { x: best.x, y: best.y, z: gWindIndLevel, mode: 'moved' };
    }

    // Fallback: the centre, just above the terrain under the disc
    var zTop = 0.0;
    var rC = Math.ceil( r / cell );
    var c0x = (c0 >= 0 ? c0 % res : Math.floor( res / 2 )), c0y = (c0 >= 0 ? Math.floor( c0 / res ) : Math.floor( res / 2 ));
    if ( gOverviewTerrain.zmax !== null )
    {
        for ( var fy=-rC; fy<=rC; fy++ )
        {
            for ( var fx=-rC; fx<=rC; fx++ )
            {
                if ( (fx * fx + fy * fy) * cell * cell > r * r ) continue;
                var gx = c0x + fx, gy = c0y + fy;
                if ( gx < 0 || gy < 0 || gx >= res || gy >= res ) continue;
                zTop = Math.max( zTop, gOverviewTerrain.zmax[gy * res + gx] );
            }
        }
    }
    var lift = Math.min( zTop + 0.005, kWindRoseLiftMax );
    var z = Math.max( gWindIndLevel, gGeoOverlayLevel + lift );
    console.log( 'Wind rose: no open water within ' + maxDist + ' units, centre lifted by ' + (z - gWindIndLevel).toFixed(3) + ' (terrain up to ' + zTop.toFixed(3) + ')' );
    return { x: 0.0, y: 0.0, z: z, mode: 'lifted' };
}

/**
 * Exact squared Euclidean distance transform (Felzenszwalb / Huttenlocher) of a res x res grid in place:
 * 0 = blocked, a large value = free; afterwards every cell holds its squared distance (in cells) to the
 * nearest blocked cell.
 *
 * @param {Float64Array} grid  res * res values, row-major
 * @param {number} res
 */
function roseDistanceTransform( grid, res )
{
    var f = new Float64Array( res );
    var d = new Float64Array( res );
    var v = new Int32Array( res );
    var z = new Float64Array( res + 1 );
    var pass = function ()
    {
        var k = 0;
        v[0] = 0;
        z[0] = -Infinity;
        z[1] = Infinity;
        for ( var q=1; q<res; q++ )
        {
            var s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
            while ( s <= z[k] )
            {
                k--;
                s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
            }
            k++;
            v[k] = q;
            z[k] = s;
            z[k + 1] = Infinity;
        }
        k = 0;
        for ( var q2=0; q2<res; q2++ )
        {
            while ( z[k + 1] < q2 ) k++;
            d[q2] = (q2 - v[k]) * (q2 - v[k]) + f[v[k]];
        }
    };
    for ( var x=0; x<res; x++ )
    {
        for ( var y=0; y<res; y++ ) f[y] = grid[y * res + x];
        pass();
        for ( var y2=0; y2<res; y2++ ) grid[y2 * res + x] = d[y2];
    }
    for ( var y3=0; y3<res; y3++ )
    {
        for ( var x2=0; x2<res; x2++ ) f[x2] = grid[y3 * res + x2];
        pass();
        for ( var x3=0; x3<res; x3++ ) grid[y3 * res + x3] = d[x3];
    }
}

/**
 * Where the wind rose goes: from the centroid of the track walk north, east, south and
 * west until a disc of radius r lies on open water inside the frame; the nearest spot
 * that the track does not cross wins, else the nearest water spot (the track then draws
 * over the rose). When no cardinal direction reaches water (a branched mountain lake,
 * a river course) the rose sits at the centroid, lifted above the terrain there.
 */
function overviewRosePlacement( r )
{
    var pts = overviewScenePoints();
    var cx = 0, cy = 0;
    if ( pts.length > 0 )
    {
        for ( var i=0; i<pts.length; i++ ) { cx += pts[i].x; cy += pts[i].y; }
        cx /= pts.length;
        cy /= pts.length;
    }
    var dirs = [ { x: 0, y: 1, name: 'N' }, { x: 1, y: 0, name: 'E' }, { x: 0, y: -1, name: 'S' }, { x: -1, y: 0, name: 'W' } ];
    var step = Math.max( 0.15, r * 0.5 );
    var best = null;
    for ( var d=0; d<dirs.length; d++ )
    {
        for ( var dist=0; dist<=kOceanSize; dist+=step )
        {
            var x = cx + dirs[d].x * dist, y = cy + dirs[d].y * dist;
            if ( !overviewRoseFits( x, y, r * 1.1 ) ) continue;
            var overlap = overviewDiscOverlap( x, y, r * 1.15, pts );
            var cand = { x: x, y: y, dist: dist, overlap: overlap, dir: dirs[d].name };
            if ( best === null || (best.overlap > 0 && overlap === 0) || (((best.overlap > 0) === (overlap > 0)) && dist < best.dist) ) best = cand;
            if ( overlap === 0 ) break;          // nearest clean spot in this direction found
        }
    }
    if ( best !== null )
    {
        console.log( 'Overview rose: ' + best.dir + ' ' + best.dist.toFixed(1) + ' from centroid' + (best.overlap > 0 ? ' (under the track)' : '') );
        return { x: best.x, y: best.y, z: gWindIndLevel, lifted: false };
    }
    // Fallback: centre of the course, above whatever terrain is there
    var zTop = 0;
    var samples = overviewDiscSamples( cx, cy, r * 1.1 );
    for ( var k=0; k<samples.length; k++ ) zTop = Math.max( zTop, overviewTerrainZ( samples[k].x, samples[k].y ) );
    console.log( 'Overview rose: no water reachable, lifted at the centroid by ' + zTop.toFixed(3) );
    return { x: cx, y: cy, z: gGeoOverlayLevel + zTop + 0.05, lifted: true };
}

/**
 * The replay's wind rose, repurposed for the overview: compass ring (north up), orange
 * needle at the mean true wind direction, a generated grey sector spanning the race's
 * TWD shift range, and the mean TWS. Placed on open water near the track by
 * overviewRosePlacement().
 */
function renderOverviewWindRose()
{
    if ( gWindIndRing === null || gWindIndCurrent === null ) return;
    var stats = overviewWindStats();
    var extent = (gOverviewCam !== null ? gOverviewCam.extent : kOceanSize);
    var s = Math.max( 0.5, Math.min( 2.0, extent / 16.0 ) );
    var pos = overviewRosePlacement( 0.86 * s );
    var zBase = pos.z;

    // The fixed 90-degree sector texture of the replay is replaced by the measured range
    if ( gWindIndAvg !== null ) gWindIndAvg.position.z = 0.0;
    if ( gOverviewRose !== null )
    {
        gScene.remove( gOverviewRose.sector );
        gScene.remove( gOverviewRose.outline );
        gScene.remove( gOverviewRose.backdrop );
    }
    // Translucent dark disc so the rose reads on bright land as well as on water
    var backdrop = new THREE.Mesh( new THREE.CircleGeometry( 0.86, 64 ),
                                   new THREE.MeshBasicMaterial( { color: 0x0a1a2a, transparent: true, opacity: 0.45, side: THREE.DoubleSide } ) );
    backdrop.name = 'OVERVIEW WIND BACKDROP';
    gScene.add( backdrop );
    var thetaStart = (90.0 - (stats.twd + stats.right)) * kDegToRad;
    var thetaLength = (stats.right - stats.left) * kDegToRad;
    var sector = new THREE.Mesh( new THREE.RingGeometry( 0.08, 0.72, 48, 1, thetaStart, thetaLength ),
                                 new THREE.MeshBasicMaterial( { color: 0xe8e8e8, transparent: true, opacity: 0.8, side: THREE.DoubleSide } ) );
    sector.name = 'OVERVIEW WIND SECTOR';
    var outline = new THREE.Mesh( new THREE.RingGeometry( 0.74, 0.79, 64 ),
                                  new THREE.MeshBasicMaterial( { color: 0xe0e0e0, transparent: true, opacity: 0.9, side: THREE.DoubleSide } ) );
    outline.name = 'OVERVIEW WIND OUTLINE';
    gScene.add( sector );
    gScene.add( outline );
    gOverviewRose = { sector: sector, outline: outline, backdrop: backdrop, twd: stats.twd, tws: stats.tws, left: stats.left, right: stats.right };

    var parts = [ backdrop, gWindIndRing, gWindIndCurrent, sector, outline ];
    for ( var i=0; i<parts.length; i++ )
    {
        parts[i].position.x = pos.x;
        parts[i].position.y = pos.y;
        parts[i].scale.set( s, s, 1 );
    }
    backdrop.position.z = zBase - 0.003;
    gWindIndRing.position.z = zBase;
    sector.position.z = zBase + 0.002;
    outline.position.z = zBase + 0.002;
    gWindIndCurrent.position.z = zBase + 0.005;
    gWindIndCurrent.rotation.z = -stats.twd * kDegToRad;     // needle to the mean true wind

    // Mean wind speed in the centre, readable (north up: no rotation)
    if ( gWindSpeedText !== null && gWindSpeedFont !== null )
    {
        // a tracker race whose crew entered no speed has none: a dash, no unit
        var textGeometry = new THREE.TextGeometry( (stats.tws > 0 ? stats.tws.toFixed(1) : '–'), { font: gWindSpeedFont, size: 0.3, height: 0.003, curveSegments: 12 } );
        textGeometry.computeBoundingBox();
        var tSize = textGeometry.boundingBox.getSize( new THREE.Vector3() );
        textGeometry.translate( -(tSize.x / 1.9), -(1.2 * tSize.y), 0 );
        gWindSpeedText.geometry = textGeometry;
        var textMaterial = new THREE.MeshBasicMaterial( { color: 0xffffff } );
        gWindSpeedText.material = textMaterial;
        gWindSpeedUnit.material = textMaterial;
        gWindSpeedUnit.visible = (stats.tws > 0);
        var texts = [ gWindSpeedText, gWindSpeedUnit ];
        for ( var t=0; t<texts.length; t++ )
        {
            texts[t].position.set( pos.x, pos.y, zBase + 0.008 );
            texts[t].rotation.z = 0;
            texts[t].scale.set( s, s, 1 );
        }
    }
}

function renderOverviewStartLine()
{
    if ( typeof isCruiser !== 'undefined' && isCruiser ) return;
    if ( raceInfos[0].startBoatLat === 0 || raceInfos[0].startPinLat === 0 ) return;
    var geometry = new THREE.Geometry();
    var boat = translate( raceInfos[0].startBoatLat, raceInfos[0].startBoatLon );
    var pin = translate( raceInfos[0].startPinLat, raceInfos[0].startPinLon );
    geometry.vertices.push( new THREE.Vector3( boat.x, boat.y, gCourseLevel ), new THREE.Vector3( pin.x, pin.y, gCourseLevel ) );
    var line = new THREE.Line( geometry, gStartingLineMaterialPost );
    line.name = 'OVERVIEW START';
    gScene.add( line );
    gOverviewObjects.push( line );
}

/** Park the replay-only objects and put each boat at its last logged position. */
function overviewPlaceBoats()
{
    for ( var b=0; b<numBoats; b++ )
    {
        if ( gBoatTrails[b] !== null ) for ( var d=0; d<gBoatTrailSize; d++ ) gBoatTrails[b][d].position.z = -99999;
        var rec = null;
        for ( var i=gRecords.length-1; i>=0; i-- )
        {
            var r = gRecords[i][b];
            if ( r !== undefined && r.lat !== 0 && r.lon !== 0 && r.lat !== 999999 ) { rec = r; break; }
        }
        // The overview is the track, not the boat: no model, no label
        for ( var cc=0; cc<4; cc++ ) gBoats[b][cc].visible = false;
        var label = document.getElementById( 'boat-annotation-' + b );
        if ( label !== null ) label.style.display = 'none';
    }
}

/**
 * The report's leg split, reproduced from the same inputs (Report\RaceAnalyzer): the
 * mark rounding times inlined by the page (overviewLegMarks), a finish mark appended
 * when the log runs on more than 120 s past the last rounding, the whole race as one
 * leg without marks. Records are walked in order; a leg closes when the next rounding
 * time is passed. Returns one entry per leg with its label anchors: the record nearest
 * the leg's time midpoint first (x, y), then the records at kOverviewLabelFractions of
 * the leg, so a label blocked at the midpoint can slide along its own leg.
 */
function overviewLegSplit()
{
    var b = gSelectedBoatIndex;
    var marks = [];
    if ( typeof overviewLegMarks !== 'undefined' && overviewLegMarks instanceof Array )
    {
        for ( var m=0; m<overviewLegMarks.length; m++ ) marks.push( parseFloat( overviewLegMarks[m] ) );
        marks.sort( function ( a, c ) { return a - c; } );
    }
    var lastRec = (gRecords.length >= 2 ? gRecords[gRecords.length - 2][b] : null);
    var lastTime = (lastRec !== undefined && lastRec !== null ? lastRec.racetime : 0);
    if ( marks.length === 0 ) marks.push( lastTime );
    else if ( marks[marks.length - 1] < lastTime - 120 ) marks.push( lastTime );

    var legs = [];
    var cur = null;
    var xindex = 0, legMarkIdx = 0, legIdx = 1;
    for ( var i=0; i<gRecords.length; i++ )
    {
        var rec = gRecords[i][b];
        if ( rec === undefined || rec.racetime <= 0 ) continue;
        while ( marks[xindex] < rec.racetime && xindex < marks.length - 1 ) xindex++;
        if ( rec.lat === 0 || rec.lon === 0 || rec.lat === 999999 || rec.stw >= 50.0 || (rec.tws > 50 && rec.tws !== 999999) ) continue;
        if ( cur === null ) cur = { idx: legIdx, start: rec.racetime, recs: [] };
        cur.recs.push( rec );
        if ( xindex !== legMarkIdx || i === gRecords.length - 1 )
        {
            cur.end = rec.racetime;
            legs.push( cur );
            legIdx++;
            legMarkIdx = xindex;
            cur = null;
        }
    }
    if ( cur !== null && cur.recs.length > 0 ) { cur.end = cur.recs[cur.recs.length - 1].racetime; legs.push( cur ); }

    var points = [];
    for ( var l=0; l<legs.length; l++ )
    {
        var leg = legs[l];
        var anchors = [];
        for ( var f=0; f<kOverviewLabelFractions.length; f++ )
        {
            var tAt = leg.start + (leg.end - leg.start) * kOverviewLabelFractions[f];
            var best = null;
            for ( var r=0; r<leg.recs.length; r++ )
            {
                if ( best === null || Math.abs( leg.recs[r].racetime - tAt ) < Math.abs( best.racetime - tAt ) ) best = leg.recs[r];
            }
            var p = translate( best.lat, best.lon );
            anchors.push( { x: p.x, y: p.y } );
        }
        points.push( { idx: leg.idx, x: anchors[0].x, y: anchors[0].y, anchors: anchors, seconds: leg.end - leg.start } );
    }
    console.log( 'Overview legs: ' + points.length + ' (marks ' + marks.length + ')' );
    return points;
}

/** The screen boxes a leg label must not cover: the mark names, the legend and the wind rose */
function overviewLabelObstacles( scene )
{
    var out = [];
    var sceneRect = scene.getBoundingClientRect();
    var els = scene.querySelectorAll( '[id^="mark-annotation-"], #scene-overview-legend' );
    for ( var i=0; i<els.length; i++ )
    {
        if ( els[i].style.display === 'none' ) continue;
        var r = els[i].getBoundingClientRect();
        if ( r.width === 0 || r.height === 0 ) continue;
        out.push( { x1: r.left - sceneRect.left - 4, y1: r.top - sceneRect.top - 4, x2: r.right - sceneRect.left + 4, y2: r.bottom - sceneRect.top + 4 } );
    }
    if ( gOverviewRose !== null && gOverviewRose.backdrop )
    {
        // the rose's disc with its compass letters, projected: the oblique camera squashes it vertically
        var c = gOverviewRose.backdrop.position, s = gOverviewRose.backdrop.scale.x;
        var v = getViewportCoordinates( { x: c.x, y: c.y, z: c.z } );
        var cx = v.x, cy = v.y;
        v = getViewportCoordinates( { x: c.x + 1.15 * s, y: c.y, z: c.z } );
        var rx = Math.abs( v.x - cx );
        v = getViewportCoordinates( { x: c.x, y: c.y + 1.15 * s, z: c.z } );
        var ry = Math.abs( v.y - cy );
        out.push( { x1: cx - rx, y1: cy - ry, x2: cx + rx, y2: cy + ry } );
    }
    return out;
}

function overviewBoxBlocked( box, boxes )
{
    for ( var i=0; i<boxes.length; i++ )
    {
        if ( !(box.x2 < boxes[i].x1 || boxes[i].x2 < box.x1 || box.y2 < boxes[i].y1 || boxes[i].y2 < box.y1) ) return true;
    }
    return false;
}

/**
 * "Leg N" labels on the legs, placed so that none covers another label, a mark name, the legend or
 * the wind rose (owner 2026-11-03): for every leg in order, the anchors along the leg (its midpoint
 * first) and the offsets around each anchor are tried until a free spot inside the frame is found; the
 * midpoint stands when nothing is free. The CSS centres the box 1.4 heights above the point it is given.
 */
function renderOverviewLegLabels()
{
    // A fleet overview carries no leg labels (one boat's split would mislead) - guarded here
    // too, the resize / camera paths call this as well
    if ( gFleetMode ) return;
    if ( gOverviewLegPoints === null ) gOverviewLegPoints = overviewLegSplit();
    var scene = document.getElementById( 'scene' );
    var sceneW = $( scene ).width(), sceneH = $( scene ).height();
    var obstacles = overviewLabelObstacles( scene );
    var placed = [];
    for ( var i=0; i<gOverviewLegPoints.length; i++ )
    {
        var pt = gOverviewLegPoints[i];
        var div = document.getElementById( 'leg-annotation-' + pt.idx );
        if ( div === null )
        {
            div = document.createElement( 'div' );
            div.id = 'leg-annotation-' + pt.idx;
            div.className = 'leg-annotation no-text-select';
            div.style.position = 'absolute';
            div.style.zIndex = 5001;
            div.innerHTML = '<p class="leg-legend">' + tqTranslate( 'JS.OVERVIEW_LEG', { n: pt.idx } ) + '</p>';
            scene.appendChild( div );
        }
        if ( pt.seconds < 60 )
        {
            div.style.display = 'none';        // a fragment leg: no room for a label
            continue;
        }
        div.style.display = 'block';
        var w = div.offsetWidth, h = div.offsetHeight;
        var anchors = (pt.anchors ? pt.anchors : [ { x: pt.x, y: pt.y } ]);
        var chosen = null, chosenBox = null;
        for ( var a=0; a<anchors.length && chosen === null; a++ )
        {
            var v = getViewportCoordinates( { x: anchors[a].x, y: anchors[a].y, z: gWaterLevel } );
            var sx = v.x, sy = v.y;              // getViewportCoordinates reuses one vector
            for ( var o=0; o<kOverviewLabelOffsets.length; o++ )
            {
                var px = sx + kOverviewLabelOffsets[o][0] * w, py = sy + kOverviewLabelOffsets[o][1] * h;
                var box = { x1: px - w / 2, y1: py - 1.4 * h, x2: px + w / 2, y2: py - 0.4 * h };
                if ( box.x1 < 0 || box.y1 < 0 || box.x2 > sceneW || box.y2 > sceneH ) continue;
                if ( overviewBoxBlocked( box, obstacles ) || overviewBoxBlocked( box, placed ) ) continue;
                chosen = { x: px, y: py };
                chosenBox = box;
                break;
            }
        }
        if ( chosen === null )
        {
            var v0 = getViewportCoordinates( { x: pt.x, y: pt.y, z: gWaterLevel } );
            chosen = { x: v0.x, y: v0.y };
            chosenBox = { x1: chosen.x - w / 2, y1: chosen.y - 1.4 * h, x2: chosen.x + w / 2, y2: chosen.y - 0.4 * h };
        }
        // a few pixels of air between neighbouring labels
        placed.push( { x1: chosenBox.x1 - 4, y1: chosenBox.y1 - 4, x2: chosenBox.x2 + 4, y2: chosenBox.y2 + 4 } );
        div.style.left = chosen.x + 'px';
        div.style.top = chosen.y + 'px';
    }
}

function overviewLegend()
{
    var legend = document.getElementById( 'scene-overview-legend' );
    if ( legend === null || gOverviewCam === null ) return;
    if ( gFleetMode && gFleetInfo )
    {
        var html = '<p class="callsign-legend">' + gFleetInfo.fleet + ' · ' + gFleetInfo.regatta + '</p>';
        var when = (raceInfos[0].startTimeDate ? raceInfos[0].startTimeDate.substring( 0, 16 ) : '');
        html += '<p class="boat-legend">' + when + ' · ' + tqTranslate('JS.OVERVIEW_NORTH_UP') + '</p>';
        // At most 20 swatches (the palette's length): a 60-boat legend would push the frame; the
        // PDF's own legend lists every boat
        var shown = Math.min( gFleetInfo.boats.length, 20 );
        for ( var b=0; b<shown; b++ )
        {
            html += '<p class="wind-legend"><span style="display:inline-block;width:10px;height:10px;border-radius:2px;margin-right:6px;vertical-align:-1px;background:' + fleetColorForBoatIndex( b ) + ';"></span>' + gFleetInfo.boats[b].label + '</p>';
        }
        if ( gFleetInfo.boats.length > shown ) html += '<p class="wind-legend">' + tqTranslate( 'JS.OVERVIEW_MORE_BOATS', { n: gFleetInfo.boats.length - shown } ) + '</p>';
        legend.innerHTML = html;
        legend.style.display = 'block';
        return;
    }
    var name = raceInfos[0].boatName + (raceInfos[0].boatSailNo ? ' | ' + raceInfos[0].boatSailNo : '');
    var when = (raceInfos[0].startTimeDate ? raceInfos[0].startTimeDate.substring( 0, 16 ) : '');
    var tws = parseFloat( raceInfos[0].aveTws );
    legend.innerHTML = '<p class="callsign-legend">' + name + '</p>'
        + '<p class="boat-legend">' + when + (raceInfos[0].regatta ? ' · ' + raceInfos[0].regatta : '') + '</p>'
        + '<p class="wind-legend">' + tqTranslate('JS.OVERVIEW_MEAN_WIND') + ' ' + gOverviewCam.twd.toFixed(0) + 'º' + (!isNaN( tws ) && tws > 0 && tws < 60 ? ' / ' + tws.toFixed(1) + 'kn' : '')
        + (gOverviewRose !== null ? ' · ' + tqTranslate('JS.OVERVIEW_SHIFTS') + ' ' + gOverviewRose.left.toFixed(0) + 'º/+' + gOverviewRose.right.toFixed(0) + 'º' : '')
        + ' · ' + tqTranslate('JS.OVERVIEW_NORTH_UP') + '</p>'
        + '<p class="wind-legend">' + tqTranslate('JS.OVERVIEW_TRACK') + '</p>'
        + '<p class="wind-legend">' + overviewArrowLegend() + '</p>';
    legend.style.display = 'block';
}

/**
 * The overview legend's line on the wind arrows: their colour range, one constant speed, or no speed at all.
 */
function overviewArrowLegend()
{
    if ( gOverviewArrowTws === null ) return tqTranslate('JS.OVERVIEW_ARROWS');
    if ( gOverviewArrowTws.min !== undefined )
    {
        return tqTranslate('JS.OVERVIEW_ARROWS_RANGE', { min: gOverviewArrowTws.min.toFixed(1), max: gOverviewArrowTws.max.toFixed(1) });
    }
    if ( gOverviewArrowTws.constant !== undefined ) return tqTranslate('JS.OVERVIEW_ARROWS_CONST', { tws: gOverviewArrowTws.constant.toFixed(1) });

    return tqTranslate('JS.OVERVIEW_ARROWS_NO_TWS');
}

/** One-shot render for the overview; sets window.gOverviewReady for the headless capture. */
function renderOverview()
{
    layoutContainer();
    gCameraMode = kCameraModeOverview;
    gEgoScale = 1.5;
    gMarkScale = kMarkScaleBev;
    gMarkAnnotationOffset = 0.5;
    if ( gMarkCones !== null ) for ( var i=0; i<gMarkCones.length; i++ ) gMarkCones[i].scale.set( gMarkScale, gMarkScale, gMarkScale );

    windIndicatorHide();
    overviewPlaceBoats();
    computeOverviewCamera();
    renderOverviewStartLine();
    renderOverviewTrack();
    // A fleet overview (Design/TRACKER_RC.md) is the tracks and the marks: the wind of one
    // boat's reconstruction and one boat's leg labels would mislead
    if ( !gFleetMode ) renderOverviewWindArrows();
    layoutPlayerView();
    if ( !gFleetMode ) renderOverviewWindRose();
    overviewLegend();
    renderMarkAnnotations();
    if ( !gFleetMode ) renderOverviewLegLabels();
    gRenderer.render( gScene, gCamera );

    // A second frame once textures uploaded and labels settled, then signal readiness
    setTimeout( function() {
        computeOverviewCamera();
        updateCamera();
        if ( !gFleetMode ) renderOverviewWindRose();
        overviewLegend();
        renderMarkAnnotations();
        if ( !gFleetMode ) renderOverviewLegLabels();
        gRenderer.render( gScene, gCamera );
        window.gOverviewReady = true;
        console.log( 'SailCast overview ready' );
    }, 800 );
}

function checkForLoadingCompleted()
{
    if ( gAllElementsLoaded && gAllLogsLoaded && gGeoTexturesLoaded && gOceanTexturesLoaded )
    {
        if ( gOverviewMode )
        {
            renderOverview();
            return;
        }

        layoutContainer();
        layoutPlayerView();
        setTimeout( function() { layoutScrubberTimeline(); }, 1000 );

        // In demo mode start in upwind view
        if ( gDemoMode ) gCameraMode = kCameraModeBevGeo;

        // The wind rose on open water near the centre (the terrain is final here)
        var rose = roseWaterPlacement( kWindRoseRadius * 1.1, kWindRoseSearchMax );
        gWindRoseX = rose.x;
        gWindRoseY = rose.y;
        gWindRoseZ = rose.z;
        windIndicatorPlace();

        toggleCameraMode();

        // Show helper for camera toggle
        var helper = document.getElementById('cam-toggle-helper');
        helper.style.display = 'block';
        setTimeout( function() {
            helper.style.opacity = 1.0;
            setTimeout(function () {
                helper.style.opacity = 0.0;
            }, 5000);
        }, 1000 );

        replayResume();
    }
    else
    {
        setTimeout( function() {
            checkForLoadingCompleted();
        }, 250 );
    }
}

function showShareLinkModal( id )
{
    $("body").ufModal({
        sourceUrl: site.uri.public + "/modals/sailcast/share-link?id=" + id + (originatorIsApp === 1 ? '&m=1' : ''),
        msgTarget: $("#alerts-page")
    });

    attachShareLinkForm( id );
}

/**
 * The share-link modal of a fleet replay (Design/TRACKER_RC.md): /sailcast?fleet=<id> has no
 * anchor race; the race committee that ran the start shares the start's replay.
 */
function showFleetShareLinkModal( fleetStartId )
{
    $("body").ufModal({
        sourceUrl: site.uri.public + "/modals/sailcast/share-link?fleet=" + fleetStartId,
        msgTarget: $("#alerts-page")
    });

    attachShareLinkForm( 0 );
}

function attachShareLinkForm( raceId )
{
    $("body").on('renderSuccess.ufModal', function (data) {
        var modal = $(this).ufModal('getModal');
        modal.css( 'z-index', '10000' );
        var form = modal.find('.js-form');
        // Set up the form for submission
        form.ufForm({
            validators: page.validators
        }).on("submitSuccess.ufForm", function() {
            // Reload page on success
            window.location.reload();
        });
    });
}